webpackJsonp([4011265886480],{

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(119);

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	var settle = __webpack_require__(125);
	var buildURL = __webpack_require__(128);
	var parseHeaders = __webpack_require__(134);
	var isURLSameOrigin = __webpack_require__(132);
	var createError = __webpack_require__(71);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(127);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(130);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	var bind = __webpack_require__(72);
	var Axios = __webpack_require__(121);
	var defaults = __webpack_require__(39);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(69);
	axios.CancelToken = __webpack_require__(120);
	axios.isCancel = __webpack_require__(70);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(135);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),

/***/ 69:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(69);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(39);
	var utils = __webpack_require__(8);
	var InterceptorManager = __webpack_require__(122);
	var dispatchRequest = __webpack_require__(123);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(124);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	var transformData = __webpack_require__(126);
	var isCancel = __webpack_require__(70);
	var defaults = __webpack_require__(39);
	var isAbsoluteURL = __webpack_require__(131);
	var combineURLs = __webpack_require__(129);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(71);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(8);
	var normalizeHeaderName = __webpack_require__(133);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(68);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(68);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),

/***/ 127:
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),

/***/ 129:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),

/***/ 131:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(8);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(72);
	var isBuffer = __webpack_require__(151);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 151:
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(49);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _enhancer = __webpack_require__(454);
	
	var _enhancer2 = _interopRequireDefault(_enhancer);
	
	var _types = __webpack_require__(455);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint react/prop-types: 0 */
	var Circle = function (_Component) {
	  (0, _inherits3['default'])(Circle, _Component);
	
	  function Circle() {
	    (0, _classCallCheck3['default'])(this, Circle);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  Circle.prototype.getPathStyles = function getPathStyles() {
	    var _props = this.props,
	        percent = _props.percent,
	        strokeWidth = _props.strokeWidth,
	        _props$gapDegree = _props.gapDegree,
	        gapDegree = _props$gapDegree === undefined ? 0 : _props$gapDegree,
	        gapPosition = _props.gapPosition;
	
	    var radius = 50 - strokeWidth / 2;
	    var beginPositionX = 0;
	    var beginPositionY = -radius;
	    var endPositionX = 0;
	    var endPositionY = -2 * radius;
	    switch (gapPosition) {
	      case 'left':
	        beginPositionX = -radius;
	        beginPositionY = 0;
	        endPositionX = 2 * radius;
	        endPositionY = 0;
	        break;
	      case 'right':
	        beginPositionX = radius;
	        beginPositionY = 0;
	        endPositionX = -2 * radius;
	        endPositionY = 0;
	        break;
	      case 'bottom':
	        beginPositionY = radius;
	        endPositionY = 2 * radius;
	        break;
	      default:
	    }
	    var pathString = 'M 50,50 m ' + beginPositionX + ',' + beginPositionY + '\n     a ' + radius + ',' + radius + ' 0 1 1 ' + endPositionX + ',' + -endPositionY + '\n     a ' + radius + ',' + radius + ' 0 1 1 ' + -endPositionX + ',' + endPositionY;
	    var len = Math.PI * 2 * radius;
	    var trailPathStyle = {
	      strokeDasharray: len - gapDegree + 'px ' + len + 'px',
	      strokeDashoffset: '-' + gapDegree / 2 + 'px',
	      transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s'
	    };
	    var strokePathStyle = {
	      strokeDasharray: percent / 100 * (len - gapDegree) + 'px ' + len + 'px',
	      strokeDashoffset: '-' + gapDegree / 2 + 'px',
	      transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s' // eslint-disable-line
	    };
	    return { pathString: pathString, trailPathStyle: trailPathStyle, strokePathStyle: strokePathStyle };
	  };
	
	  Circle.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        prefixCls = _props2.prefixCls,
	        strokeWidth = _props2.strokeWidth,
	        trailWidth = _props2.trailWidth,
	        strokeColor = _props2.strokeColor,
	        percent = _props2.percent,
	        trailColor = _props2.trailColor,
	        strokeLinecap = _props2.strokeLinecap,
	        style = _props2.style,
	        className = _props2.className,
	        restProps = (0, _objectWithoutProperties3['default'])(_props2, ['prefixCls', 'strokeWidth', 'trailWidth', 'strokeColor', 'percent', 'trailColor', 'strokeLinecap', 'style', 'className']);
	
	    var _getPathStyles = this.getPathStyles(),
	        pathString = _getPathStyles.pathString,
	        trailPathStyle = _getPathStyles.trailPathStyle,
	        strokePathStyle = _getPathStyles.strokePathStyle;
	
	    delete restProps.percent;
	    delete restProps.gapDegree;
	    delete restProps.gapPosition;
	    return _react2['default'].createElement(
	      'svg',
	      (0, _extends3['default'])({
	        className: prefixCls + '-circle ' + className,
	        viewBox: '0 0 100 100',
	        style: style
	      }, restProps),
	      _react2['default'].createElement('path', {
	        className: prefixCls + '-circle-trail',
	        d: pathString,
	        stroke: trailColor,
	        strokeWidth: trailWidth || strokeWidth,
	        fillOpacity: '0',
	        style: trailPathStyle
	      }),
	      _react2['default'].createElement('path', {
	        className: prefixCls + '-circle-path',
	        d: pathString,
	        strokeLinecap: strokeLinecap,
	        stroke: strokeColor,
	        strokeWidth: this.props.percent === 0 ? 0 : strokeWidth,
	        fillOpacity: '0',
	        ref: function ref(path) {
	          _this2.path = path;
	        },
	        style: strokePathStyle
	      })
	    );
	  };
	
	  return Circle;
	}(_react.Component);
	
	Circle.propTypes = (0, _extends3['default'])({}, _types.propTypes, {
	  gapPosition: _propTypes2['default'].oneOf(['top', 'bottom', 'left', 'right'])
	});
	
	Circle.defaultProps = (0, _extends3['default'])({}, _types.defaultProps, {
	  gapPosition: 'top'
	});
	
	exports['default'] = (0, _enhancer2['default'])(Circle);
	module.exports = exports['default'];

/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(49);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _enhancer = __webpack_require__(454);
	
	var _enhancer2 = _interopRequireDefault(_enhancer);
	
	var _types = __webpack_require__(455);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Line = function (_Component) {
	  (0, _inherits3['default'])(Line, _Component);
	
	  function Line() {
	    (0, _classCallCheck3['default'])(this, Line);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  Line.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        className = _props.className,
	        percent = _props.percent,
	        prefixCls = _props.prefixCls,
	        strokeColor = _props.strokeColor,
	        strokeLinecap = _props.strokeLinecap,
	        strokeWidth = _props.strokeWidth,
	        style = _props.style,
	        trailColor = _props.trailColor,
	        trailWidth = _props.trailWidth,
	        restProps = (0, _objectWithoutProperties3['default'])(_props, ['className', 'percent', 'prefixCls', 'strokeColor', 'strokeLinecap', 'strokeWidth', 'style', 'trailColor', 'trailWidth']);
	
	
	    delete restProps.gapPosition;
	
	    var pathStyle = {
	      strokeDasharray: '100px, 100px',
	      strokeDashoffset: 100 - percent + 'px',
	      transition: 'stroke-dashoffset 0.3s ease 0s, stroke 0.3s linear'
	    };
	
	    var center = strokeWidth / 2;
	    var right = 100 - strokeWidth / 2;
	    var pathString = 'M ' + (strokeLinecap === 'round' ? center : 0) + ',' + center + '\n           L ' + (strokeLinecap === 'round' ? right : 100) + ',' + center;
	    var viewBoxString = '0 0 100 ' + strokeWidth;
	
	    return _react2['default'].createElement(
	      'svg',
	      (0, _extends3['default'])({
	        className: prefixCls + '-line ' + className,
	        viewBox: viewBoxString,
	        preserveAspectRatio: 'none',
	        style: style
	      }, restProps),
	      _react2['default'].createElement('path', {
	        className: prefixCls + '-line-trail',
	        d: pathString,
	        strokeLinecap: strokeLinecap,
	        stroke: trailColor,
	        strokeWidth: trailWidth || strokeWidth,
	        fillOpacity: '0'
	      }),
	      _react2['default'].createElement('path', {
	        className: prefixCls + '-line-path',
	        d: pathString,
	        strokeLinecap: strokeLinecap,
	        stroke: strokeColor,
	        strokeWidth: strokeWidth,
	        fillOpacity: '0',
	        ref: function ref(path) {
	          _this2.path = path;
	        },
	        style: pathStyle
	      })
	    );
	  };
	
	  return Line;
	}(_react.Component);
	
	Line.propTypes = _types.propTypes;
	
	Line.defaultProps = _types.defaultProps;
	
	exports['default'] = (0, _enhancer2['default'])(Line);
	module.exports = exports['default'];

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var enhancer = function enhancer(WrappedComponent) {
	  return function (_WrappedComponent) {
	    (0, _inherits3['default'])(Progress, _WrappedComponent);
	
	    function Progress() {
	      (0, _classCallCheck3['default'])(this, Progress);
	      return (0, _possibleConstructorReturn3['default'])(this, _WrappedComponent.apply(this, arguments));
	    }
	
	    Progress.prototype.componentDidUpdate = function componentDidUpdate() {
	      if (!this.path) {
	        return;
	      }
	      var pathStyle = this.path.style;
	      pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';
	      var now = Date.now();
	      if (this.prevTimeStamp && now - this.prevTimeStamp < 100) {
	        pathStyle.transitionDuration = '0s, 0s';
	      }
	      this.prevTimeStamp = Date.now();
	    };
	
	    Progress.prototype.render = function render() {
	      return _WrappedComponent.prototype.render.call(this);
	    };
	
	    return Progress;
	  }(WrappedComponent);
	};
	
	exports['default'] = enhancer;
	module.exports = exports['default'];

/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Circle = exports.Line = undefined;
	
	var _Line = __webpack_require__(962);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _Circle = __webpack_require__(961);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.Line = _Line2['default'];
	exports.Circle = _Circle2['default'];
	exports['default'] = {
	  Line: _Line2['default'],
	  Circle: _Circle2['default']
	};

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.propTypes = exports.defaultProps = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultProps = exports.defaultProps = {
	  className: '',
	  percent: 0,
	  prefixCls: 'rc-progress',
	  strokeColor: '#2db7f5',
	  strokeLinecap: 'round',
	  strokeWidth: 1,
	  style: {},
	  trailColor: '#D9D9D9',
	  trailWidth: 1
	};
	
	var propTypes = exports.propTypes = {
	  className: _propTypes2['default'].string,
	  percent: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  prefixCls: _propTypes2['default'].string,
	  strokeColor: _propTypes2['default'].string,
	  strokeLinecap: _propTypes2['default'].oneOf(['butt', 'round', 'square']),
	  strokeWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  style: _propTypes2['default'].object,
	  trailColor: _propTypes2['default'].string,
	  trailWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	};

/***/ }),

/***/ 996:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(20);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSpotify = function FaSpotify(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.2 27q0-0.7-0.7-1.1-4.3-2.6-10-2.6-3 0-6.4 0.8-0.9 0.2-0.9 1.1 0 0.5 0.3 0.8t0.8 0.3q0.1 0 0.8-0.2 2.9-0.6 5.4-0.6 5.1 0 8.9 2.3 0.4 0.3 0.7 0.3 0.4 0 0.7-0.3t0.4-0.8z m2.1-4.8q0-0.9-0.8-1.4-5.3-3.1-12.2-3.1-3.4 0-6.8 0.9-1 0.3-1 1.5 0 0.5 0.3 0.9t1 0.4q0.1 0 0.8-0.2 2.7-0.7 5.6-0.7 6.2 0 10.9 2.8 0.5 0.3 0.9 0.3 0.5 0 0.9-0.4t0.4-1z m2.4-5.5q0-1.1-0.9-1.6-2.8-1.6-6.5-2.5t-7.7-0.8q-4.5 0-8.1 1.1-0.5 0.1-0.9 0.5t-0.3 1.1q0 0.7 0.5 1.2t1.1 0.4q0.2 0 0.9-0.1 3-0.9 6.8-0.9 3.6 0 7 0.8t5.6 2.1q0.5 0.3 0.9 0.3 0.7 0 1.1-0.5t0.5-1.1z m4.6 3.3q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaSpotify;
	module.exports = exports['default'];

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(nextProps, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Script = function (_React$Component) {
	  _inherits(Script, _React$Component);
	
	  // A dictionary mapping script URL to a boolean value indicating if the script
	  // has failed to load.
	
	
	  // A dictionary mapping script URLs to a dictionary mapping
	  // component key to component for all components that are waiting
	  // for the script to load.
	  function Script(props) {
	    _classCallCheck(this, Script);
	
	    var _this = _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).call(this, props));
	
	    _this.scriptLoaderId = 'id' + _this.constructor.idCount++; // eslint-disable-line space-unary-ops, no-plusplus
	    return _this;
	  }
	
	  // A counter used to generate a unique id for each component that uses
	  // ScriptLoaderMixin.
	
	
	  // A dictionary mapping script URL to a boolean value indicating if the script
	  // has already been loaded.
	
	
	  _createClass(Script, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          onError = _props.onError,
	          onLoad = _props.onLoad,
	          url = _props.url;
	
	
	      if (this.constructor.loadedScripts[url]) {
	        onLoad();
	        return;
	      }
	
	      if (this.constructor.erroredScripts[url]) {
	        onError();
	        return;
	      }
	
	      // If the script is loading, add the component to the script's observers
	      // and return. Otherwise, initialize the script's observers with the component
	      // and start loading the script.
	      if (this.constructor.scriptObservers[url]) {
	        this.constructor.scriptObservers[url][this.scriptLoaderId] = this.props;
	        return;
	      }
	
	      this.constructor.scriptObservers[url] = _defineProperty({}, this.scriptLoaderId, this.props);
	
	      this.createScript();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var url = this.props.url;
	
	      var observers = this.constructor.scriptObservers[url];
	
	      // If the component is waiting for the script to load, remove the
	      // component from the script's observers before unmounting the component.
	      if (observers) {
	        delete observers[this.scriptLoaderId];
	      }
	    }
	  }, {
	    key: 'createScript',
	    value: function createScript() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          onCreate = _props2.onCreate,
	          url = _props2.url,
	          attributes = _props2.attributes;
	
	      var script = document.createElement('script');
	
	      onCreate();
	
	      // add 'data-' or non standard attributes to the script tag
	      if (attributes) {
	        Object.keys(attributes).forEach(function (prop) {
	          return script.setAttribute(prop, attributes[prop]);
	        });
	      }
	
	      script.src = url;
	
	      // default async to true if not set with custom attributes
	      if (!script.hasAttribute('async')) {
	        script.async = 1;
	      }
	
	      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(shouldRemoveObserver) {
	        var observers = _this2.constructor.scriptObservers[url];
	        Object.keys(observers).forEach(function (key) {
	          if (shouldRemoveObserver(observers[key])) {
	            delete _this2.constructor.scriptObservers[url][_this2.scriptLoaderId];
	          }
	        });
	      };
	      script.onload = function () {
	        _this2.constructor.loadedScripts[url] = true;
	        callObserverFuncAndRemoveObserver(function (observer) {
	          observer.onLoad();
	          return true;
	        });
	      };
	
	      script.onerror = function () {
	        _this2.constructor.erroredScripts[url] = true;
	        callObserverFuncAndRemoveObserver(function (observer) {
	          observer.onError();
	          return true;
	        });
	      };
	
	      document.body.appendChild(script);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Script;
	}(_react2.default.Component);
	
	Script.propTypes = {
	  attributes: _propTypes.PropTypes.object, // eslint-disable-line react/forbid-prop-types
	  onCreate: _propTypes.PropTypes.func,
	  onError: _propTypes.PropTypes.func.isRequired,
	  onLoad: _propTypes.PropTypes.func.isRequired,
	  url: _propTypes.PropTypes.string.isRequired
	};
	Script.defaultProps = {
	  attributes: {},
	  onCreate: function onCreate() {},
	  onError: function onError() {},
	  onLoad: function onLoad() {} };
	Script.scriptObservers = {};
	Script.loadedScripts = {};
	Script.erroredScripts = {};
	Script.idCount = 0;
	exports.default = Script;
	module.exports = exports['default'];

/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(43);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(1072);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(471);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(318);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _reactLifecyclesCompat = __webpack_require__(118);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _reactDom2.default.createPortal !== undefined;
	var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      parent.removeChild(_this.node);
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = document.createElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      var prevParent = getParentElement(prevProps.parentSelector);
	      var nextParent = getParentElement(this.props.parentSelector);
	      return { prevParent: prevParent, nextParent: nextParent };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, _, snapshot) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          portalClassName = _props.portalClassName;
	
	
	      if (prevProps.portalClassName !== portalClassName) {
	        this.node.className = portalClassName;
	      }
	
	      // Stop unnecessary renders if modal is remaining closed
	      if (!prevProps.isOpen && !isOpen) return;
	
	      var prevParent = snapshot.prevParent,
	          nextParent = snapshot.nextParent;
	
	      if (nextParent !== prevParent) {
	        prevParent.removeChild(this.node);
	        nextParent.appendChild(this.node);
	      }
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = document.createElement("div");
	      }
	
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  parentSelector: function parentSelector() {
	    return document.body;
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Modal);
	
	exports.default = Modal;

/***/ }),

/***/ 1072:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(1074);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(1075);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(471);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _classList = __webpack_require__(1073);
	
	var classList = _interopRequireWildcard(_classList);
	
	var _safeHTMLElement = __webpack_require__(318);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	var TAB_KEY = 9;
	var ESC_KEY = 27;
	
	var ariaHiddenInstances = 0;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };
	
	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName;
	
	      // Remove classes.
	
	      classList.remove(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;
	
	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus();
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.setState({ afterOpen: true });
	
	          if (_this.props.isOpen && _this.props.onAfterOpen) {
	            _this.props.onAfterOpen();
	          }
	        });
	      }
	    };
	
	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus();
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (event.keyCode === TAB_KEY) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.ariaAttributes = function (items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc["aria-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isOpen) {
	        this.open();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (false) {
	        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	
	      if (this.props.isOpen && !prevProps.isOpen) {
	        this.open();
	      } else if (!this.props.isOpen && prevProps.isOpen) {
	        this.close();
	      }
	
	      // Focus only needs to be set once when the modal is being opened
	      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
	        this.focusContent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.afterClose();
	      clearTimeout(this.closeTimer);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName;
	
	      // Add classes.
	
	      classList.add(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      return this.shouldBeClosed() ? null : _react2.default.createElement(
	        "div",
	        {
	          ref: this.setOverlayRef,
	          className: this.buildClassName("overlay", overlayClassName),
	          style: _extends({}, overlayStyles, this.props.style.overlay),
	          onClick: this.handleOverlayOnClick,
	          onMouseDown: this.handleOverlayOnMouseDown,
	          "aria-modal": "true"
	        },
	        _react2.default.createElement(
	          "div",
	          _extends({
	            ref: this.setContentRef,
	            style: _extends({}, contentStyles, this.props.style.content),
	            className: this.buildClassName("content", className),
	            tabIndex: "-1",
	            onKeyDown: this.handleKeyDown,
	            onMouseDown: this.handleContentOnMouseDown,
	            onMouseUp: this.handleContentOnMouseUp,
	            onClick: this.handleContentOnClick,
	            role: this.props.role,
	            "aria-label": this.props.contentLabel
	          }, this.ariaAttributes(this.props.aria || {}), {
	            "data-testid": this.props.testId
	          }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  },
	  defaultStyles: {}
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  testId: _propTypes2.default.string
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	exports.resetForTesting = resetForTesting;
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _safeHTMLElement = __webpack_require__(318);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalElement = null;
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = "length" in el ? el[0] : el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function validateElement(appElement) {
	  if (!appElement && !globalElement) {
	    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
	
	    return false;
	  }
	
	  return true;
	}
	
	function hide(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).setAttribute("aria-hidden", "true");
	  }
	}
	
	function show(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).removeAttribute("aria-hidden");
	  }
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}
	
	function resetForTesting() {
	  globalElement = null;
	}

/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dumpClassLists = dumpClassLists;
	var htmlClassList = {};
	var docBodyClassList = {};
	
	function dumpClassLists() {
	  if (false) {
	    var classes = document.getElementsByTagName("html")[0].className;
	    var buffer = "Show tracked classes:\n\n";
	
	    buffer += "<html /> (" + classes + "):\n";
	    for (var x in htmlClassList) {
	      buffer += "  " + x + " " + htmlClassList[x] + "\n";
	    }
	
	    classes = document.body.className;
	
	    // eslint-disable-next-line max-len
	    buffer += "\n\ndoc.body (" + classes + "):\n";
	    for (var _x in docBodyClassList) {
	      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
	    }
	
	    buffer += "\n";
	
	    // eslint-disable-next-line no-console
	    console.log(buffer);
	  }
	}
	
	/**
	 * Track the number of reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var incrementReference = function incrementReference(poll, className) {
	  if (!poll[className]) {
	    poll[className] = 0;
	  }
	  poll[className] += 1;
	  return className;
	};
	
	/**
	 * Drop the reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var decrementReference = function decrementReference(poll, className) {
	  if (poll[className]) {
	    poll[className] -= 1;
	  }
	  return className;
	};
	
	/**
	 * Track a class and add to the given class list.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be tracked.
	 */
	var trackClass = function trackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    incrementReference(poll, className);
	    classListRef.add(className);
	  });
	};
	
	/**
	 * Untrack a class and remove from the given class list if the reference
	 * reaches 0.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be untracked.
	 */
	var untrackClass = function untrackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    decrementReference(poll, className);
	    poll[className] === 0 && classListRef.remove(className);
	  });
	};
	
	/**
	 * Public inferface to add classes to the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var add = exports.add = function add(element, classString) {
	  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};
	
	/**
	 * Public inferface to remove classes from the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var remove = exports.remove = function remove(element, classString) {
	  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};

/***/ }),

/***/ 1074:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(472);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var toFocus = null;
	  try {
	    if (focusLaterElements.length !== 0) {
	      toFocus = focusLaterElements.pop();
	      toFocus.focus();
	    }
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = undefined;
	
	var _exenv = __webpack_require__(251);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ }),

/***/ 1075:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(472);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	
	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === document.activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }
	
	  var target;
	  if (tail === document.activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === document.activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prone, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(document.activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  event.preventDefault();
	
	  tabbable[x].focus();
	}
	module.exports = exports["default"];

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var tabbableNode = /input|select|textarea|button|object/;
	
	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
	
	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;
	
	  // Otherwise we need to check some styles
	  var style = window.getComputedStyle(element);
	  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
	}
	
	function visible(element) {
	  var parentElement = element;
	  while (parentElement) {
	    if (parentElement === document.body) break;
	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
	}
	module.exports = exports["default"];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(1071);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 1131:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactLifecyclesCompat = __webpack_require__(118);
	
	var _Grid = __webpack_require__(169);
	
	var _types = __webpack_require__(477);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
	 */
	
	var ArrowKeyStepper = function (_React$PureComponent) {
	  (0, _inherits3.default)(ArrowKeyStepper, _React$PureComponent);
	
	  function ArrowKeyStepper() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ArrowKeyStepper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ArrowKeyStepper.__proto__ || (0, _getPrototypeOf2.default)(ArrowKeyStepper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      scrollToColumn: 0,
	      scrollToRow: 0
	    }, _this._columnStartIndex = 0, _this._columnStopIndex = 0, _this._rowStartIndex = 0, _this._rowStopIndex = 0, _this._onKeyDown = function (event) {
	      var _this$props = _this.props,
	          columnCount = _this$props.columnCount,
	          disabled = _this$props.disabled,
	          mode = _this$props.mode,
	          rowCount = _this$props.rowCount;
	
	
	      if (disabled) {
	        return;
	      }
	
	      var _this$_getScrollState = _this._getScrollState(),
	          scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
	          scrollToRowPrevious = _this$_getScrollState.scrollToRow;
	
	      var _this$_getScrollState2 = _this._getScrollState(),
	          scrollToColumn = _this$_getScrollState2.scrollToColumn,
	          scrollToRow = _this$_getScrollState2.scrollToRow;
	
	      // The above cases all prevent default event event behavior.
	      // This is to keep the grid from scrolling after the snap-to update.
	
	
	      switch (event.key) {
	        case 'ArrowDown':
	          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
	          break;
	        case 'ArrowLeft':
	          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
	          break;
	        case 'ArrowRight':
	          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
	          break;
	        case 'ArrowUp':
	          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
	          break;
	      }
	
	      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
	        event.preventDefault();
	
	        _this._updateScrollState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
	      }
	    }, _this._onSectionRendered = function (_ref2) {
	      var columnStartIndex = _ref2.columnStartIndex,
	          columnStopIndex = _ref2.columnStopIndex,
	          rowStartIndex = _ref2.rowStartIndex,
	          rowStopIndex = _ref2.rowStopIndex;
	
	      _this._columnStartIndex = columnStartIndex;
	      _this._columnStopIndex = columnStopIndex;
	      _this._rowStartIndex = rowStartIndex;
	      _this._rowStopIndex = rowStopIndex;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ArrowKeyStepper, [{
	    key: 'setScrollIndexes',
	    value: function setScrollIndexes(_ref3) {
	      var scrollToColumn = _ref3.scrollToColumn,
	          scrollToRow = _ref3.scrollToRow;
	
	      this.setState({
	        scrollToRow: scrollToRow,
	        scrollToColumn: scrollToColumn
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children;
	
	      var _getScrollState2 = this._getScrollState(),
	          scrollToColumn = _getScrollState2.scrollToColumn,
	          scrollToRow = _getScrollState2.scrollToRow;
	
	      return React.createElement(
	        'div',
	        { className: className, onKeyDown: this._onKeyDown },
	        children({
	          onSectionRendered: this._onSectionRendered,
	          scrollToColumn: scrollToColumn,
	          scrollToRow: scrollToRow
	        })
	      );
	    }
	  }, {
	    key: '_getScrollState',
	    value: function _getScrollState() {
	      return this.props.isControlled ? this.props : this.state;
	    }
	  }, {
	    key: '_updateScrollState',
	    value: function _updateScrollState(_ref4) {
	      var scrollToColumn = _ref4.scrollToColumn,
	          scrollToRow = _ref4.scrollToRow;
	      var _props2 = this.props,
	          isControlled = _props2.isControlled,
	          onScrollToChange = _props2.onScrollToChange;
	
	
	      if (typeof onScrollToChange === 'function') {
	        onScrollToChange({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
	      }
	
	      if (!isControlled) {
	        this.setState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
	      }
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (nextProps.isControlled) {
	        return null;
	      }
	
	      if (nextProps.scrollToColumn !== prevState.scrollToColumn || nextProps.scrollToRow !== prevState.scrollToRow) {
	        return {
	          scrollToColumn: nextProps.scrollToColumn,
	          scrollToRow: nextProps.scrollToRow
	        };
	      }
	
	      return null;
	    }
	  }]);
	  return ArrowKeyStepper;
	}(React.PureComponent);
	
	ArrowKeyStepper.defaultProps = {
	  disabled: false,
	  isControlled: false,
	  mode: 'edges',
	  scrollToColumn: 0,
	  scrollToRow: 0
	};
	ArrowKeyStepper.propTypes =  true ? null : {
	  children: _propTypes2.default.func.isRequired,
	  className: _propTypes2.default.string,
	  columnCount: _propTypes2.default.number.isRequired,
	  disabled: _propTypes2.default.bool.isRequired,
	  isControlled: _propTypes2.default.bool.isRequired,
	  mode: _propTypes2.default.oneOf(['cells', 'edges']).isRequired,
	  onScrollToChange: _propTypes2.default.func,
	  rowCount: _propTypes2.default.number.isRequired,
	  scrollToColumn: _propTypes2.default.number.isRequired,
	  scrollToRow: _propTypes2.default.number.isRequired
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(ArrowKeyStepper);
	
	exports.default = ArrowKeyStepper;

/***/ }),

/***/ 1132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bpfrpt_proptype_ScrollIndices = exports.ArrowKeyStepper = exports.default = undefined;
	
	var _ArrowKeyStepper = __webpack_require__(1131);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ArrowKeyStepper).default;
	  }
	});
	Object.defineProperty(exports, 'ArrowKeyStepper', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ArrowKeyStepper).default;
	  }
	});
	
	var _types = __webpack_require__(477);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.bpfrpt_proptype_ScrollIndices = _types.bpfrpt_proptype_ScrollIndices;

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bpfrpt_proptype_ScrollIndices = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bpfrpt_proptype_ScrollIndices =  true ? null : {
	  scrollToColumn: _propTypes2.default.number.isRequired,
	  scrollToRow: _propTypes2.default.number.isRequired
	};
	exports.bpfrpt_proptype_ScrollIndices = bpfrpt_proptype_ScrollIndices;

/***/ }),

/***/ 1133:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _detectElementResize = __webpack_require__(493);
	
	var _detectElementResize2 = _interopRequireDefault(_detectElementResize);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutoSizer = function (_React$PureComponent) {
	  (0, _inherits3.default)(AutoSizer, _React$PureComponent);
	
	  function AutoSizer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoSizer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoSizer.__proto__ || (0, _getPrototypeOf2.default)(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      height: _this.props.defaultHeight || 0,
	      width: _this.props.defaultWidth || 0
	    }, _this._onResize = function () {
	      var _this$props = _this.props,
	          disableHeight = _this$props.disableHeight,
	          disableWidth = _this$props.disableWidth,
	          onResize = _this$props.onResize;
	
	
	      if (_this._parentNode) {
	        // Guard against AutoSizer component being removed from the DOM immediately after being added.
	        // This can result in invalid style values which can result in NaN values if we don't handle them.
	        // See issue #150 for more context.
	
	        var _height = _this._parentNode.offsetHeight || 0;
	        var _width = _this._parentNode.offsetWidth || 0;
	
	        var _style = window.getComputedStyle(_this._parentNode) || {};
	        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
	        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
	        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
	        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;
	
	        var newHeight = _height - paddingTop - paddingBottom;
	        var newWidth = _width - paddingLeft - paddingRight;
	
	        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
	          _this.setState({
	            height: _height - paddingTop - paddingBottom,
	            width: _width - paddingLeft - paddingRight
	          });
	
	          onResize({ height: _height, width: _width });
	        }
	      }
	    }, _this._setRef = function (autoSizer) {
	      _this._autoSizer = autoSizer;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoSizer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var nonce = this.props.nonce;
	
	      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
	        // Delay access of parentNode until mount.
	        // This handles edge-cases where the component has already been unmounted before its ref has been set,
	        // As well as libraries like react-lite which have a slightly different lifecycle.
	        this._parentNode = this._autoSizer.parentNode;
	
	        // Defer requiring resize handler in order to support server-side rendering.
	        // See issue #41
	        this._detectElementResize = (0, _detectElementResize2.default)(nonce);
	        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
	
	        this._onResize();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._detectElementResize && this._parentNode) {
	        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          disableHeight = _props.disableHeight,
	          disableWidth = _props.disableWidth,
	          style = _props.style;
	      var _state = this.state,
	          height = _state.height,
	          width = _state.width;
	
	      // Outer div should not force width/height since that may prevent containers from shrinking.
	      // Inner component should overflow and use calculated width/height.
	      // See issue #68 for more information.
	
	      var outerStyle = { overflow: 'visible' };
	      var childParams = {};
	
	      if (!disableHeight) {
	        outerStyle.height = 0;
	        childParams.height = height;
	      }
	
	      if (!disableWidth) {
	        outerStyle.width = 0;
	        childParams.width = width;
	      }
	
	      /**
	       * TODO: Avoid rendering children before the initial measurements have been collected.
	       * At best this would just be wasting cycles.
	       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
	       * Note that if default width/height props were provided this would still work with SSR.
	      if (
	        height !== 0 &&
	        width !== 0
	      ) {
	        child = children({ height, width })
	      }
	      */
	
	      return React.createElement(
	        'div',
	        {
	          className: className,
	          ref: this._setRef,
	          style: (0, _extends3.default)({}, outerStyle, style) },
	        children(childParams)
	      );
	    }
	  }]);
	  return AutoSizer;
	}(React.PureComponent);
	
	AutoSizer.defaultProps = {
	  onResize: function onResize() {},
	  disableHeight: false,
	  disableWidth: false,
	  style: {}
	};
	AutoSizer.propTypes =  true ? null : {
	  /** Function responsible for rendering children.*/
	  children: _propTypes2.default.func.isRequired,
	
	
	  /** Optional custom CSS class name to attach to root AutoSizer element.  */
	  className: _propTypes2.default.string,
	
	
	  /** Default height to use for initial render; useful for SSR */
	  defaultHeight: _propTypes2.default.number,
	
	
	  /** Default width to use for initial render; useful for SSR */
	  defaultWidth: _propTypes2.default.number,
	
	
	  /** Disable dynamic :height property */
	  disableHeight: _propTypes2.default.bool.isRequired,
	
	
	  /** Disable dynamic :width property */
	  disableWidth: _propTypes2.default.bool.isRequired,
	
	
	  /** Nonce of the inlined stylesheet for Content Security Policy */
	  nonce: _propTypes2.default.string,
	
	
	  /** Callback to be invoked on-resize */
	  onResize: _propTypes2.default.func.isRequired,
	
	
	  /** Optional inline style */
	  style: _propTypes2.default.object
	};
	exports.default = AutoSizer;

/***/ }),

/***/ 1134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AutoSizer = __webpack_require__(1133);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AutoSizer).default;
	  }
	});
	Object.defineProperty(exports, 'AutoSizer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AutoSizer).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 1135:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(43);
	
	var _types = __webpack_require__(479);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Wraps a cell and measures its rendered content.
	 * Measurements are stored in a per-cell cache.
	 * Cached-content is not be re-measured.
	 */
	var CellMeasurer = function (_React$PureComponent) {
	  (0, _inherits3.default)(CellMeasurer, _React$PureComponent);
	
	  function CellMeasurer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CellMeasurer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CellMeasurer.__proto__ || (0, _getPrototypeOf2.default)(CellMeasurer)).call.apply(_ref, [this].concat(args))), _this), _this._measure = function () {
	      var _this$props = _this.props,
	          cache = _this$props.cache,
	          _this$props$columnInd = _this$props.columnIndex,
	          columnIndex = _this$props$columnInd === undefined ? 0 : _this$props$columnInd,
	          parent = _this$props.parent,
	          _this$props$rowIndex = _this$props.rowIndex,
	          rowIndex = _this$props$rowIndex === undefined ? _this.props.index || 0 : _this$props$rowIndex;
	
	      var _this$_getCellMeasure = _this._getCellMeasurements(),
	          height = _this$_getCellMeasure.height,
	          width = _this$_getCellMeasure.width;
	
	      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
	        cache.set(rowIndex, columnIndex, width, height);
	
	        if (parent && typeof parent.recomputeGridSize === 'function') {
	          parent.recomputeGridSize({
	            columnIndex: columnIndex,
	            rowIndex: rowIndex
	          });
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CellMeasurer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._maybeMeasureCell();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._maybeMeasureCell();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return typeof children === 'function' ? children({ measure: this._measure }) : children;
	    }
	  }, {
	    key: '_getCellMeasurements',
	    value: function _getCellMeasurements() {
	      var cache = this.props.cache;
	
	
	      var node = (0, _reactDom.findDOMNode)(this);
	
	      // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height
	
	      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
	        var styleWidth = node.style.width;
	        var styleHeight = node.style.height;
	
	        // If we are re-measuring a cell that has already been measured,
	        // It will have a hard-coded width/height from the previous measurement.
	        // The fact that we are measuring indicates this measurement is probably stale,
	        // So explicitly clear it out (eg set to "auto") so we can recalculate.
	        // See issue #593 for more info.
	        // Even if we are measuring initially- if we're inside of a MultiGrid component,
	        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
	        // eg top/left Grid renders before bottom/right Grid
	        // Since the CellMeasurerCache is shared between them this taints derived cell size values.
	        if (!cache.hasFixedWidth()) {
	          node.style.width = 'auto';
	        }
	        if (!cache.hasFixedHeight()) {
	          node.style.height = 'auto';
	        }
	
	        var height = Math.ceil(node.offsetHeight);
	        var width = Math.ceil(node.offsetWidth);
	
	        // Reset after measuring to avoid breaking styles; see #660
	        if (styleWidth) {
	          node.style.width = styleWidth;
	        }
	        if (styleHeight) {
	          node.style.height = styleHeight;
	        }
	
	        return { height: height, width: width };
	      } else {
	        return { height: 0, width: 0 };
	      }
	    }
	  }, {
	    key: '_maybeMeasureCell',
	    value: function _maybeMeasureCell() {
	      var _props = this.props,
	          cache = _props.cache,
	          _props$columnIndex = _props.columnIndex,
	          columnIndex = _props$columnIndex === undefined ? 0 : _props$columnIndex,
	          parent = _props.parent,
	          _props$rowIndex = _props.rowIndex,
	          rowIndex = _props$rowIndex === undefined ? this.props.index || 0 : _props$rowIndex;
	
	
	      if (!cache.has(rowIndex, columnIndex)) {
	        var _getCellMeasurements2 = this._getCellMeasurements(),
	            height = _getCellMeasurements2.height,
	            width = _getCellMeasurements2.width;
	
	        cache.set(rowIndex, columnIndex, width, height);
	
	        // If size has changed, let Grid know to re-render.
	        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
	          parent.invalidateCellSizeAfterRender({
	            columnIndex: columnIndex,
	            rowIndex: rowIndex
	          });
	        }
	      }
	    }
	  }]);
	  return CellMeasurer;
	}(React.PureComponent);
	
	// Used for DEV mode warning check
	
	
	CellMeasurer.__internalCellMeasurerFlag = false;
	CellMeasurer.propTypes =  true ? null : {
	  cache: function cache() {
	    return (typeof _types.bpfrpt_proptype_CellMeasureCache === 'function' ? _types.bpfrpt_proptype_CellMeasureCache.isRequired ? _types.bpfrpt_proptype_CellMeasureCache.isRequired : _types.bpfrpt_proptype_CellMeasureCache : _propTypes2.default.shape(_types.bpfrpt_proptype_CellMeasureCache).isRequired).apply(this, arguments);
	  },
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]).isRequired,
	  columnIndex: _propTypes2.default.number,
	  index: _propTypes2.default.number,
	  parent: _propTypes2.default.shape({
	    invalidateCellSizeAfterRender: _propTypes2.default.func,
	    recomputeGridSize: _propTypes2.default.func
	  }).isRequired,
	  rowIndex: _propTypes2.default.number
	};
	exports.default = CellMeasurer;
	if (false) {
	  CellMeasurer.__internalCellMeasurerFlag = true;
	}

/***/ }),

/***/ 1136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_WIDTH = exports.DEFAULT_HEIGHT = undefined;
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _types = __webpack_require__(479);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_HEIGHT = exports.DEFAULT_HEIGHT = 30;
	
	var DEFAULT_WIDTH = exports.DEFAULT_WIDTH = 100;
	
	// Enables more intelligent mapping of a given column and row index to an item ID.
	// This prevents a cell cache from being invalidated when its parent collection is modified.
	
	/**
	 * Caches measurements for a given cell.
	 */
	var CellMeasurerCache = function () {
	  function CellMeasurerCache() {
	    var _this = this;
	
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, CellMeasurerCache);
	    this._cellHeightCache = {};
	    this._cellWidthCache = {};
	    this._columnWidthCache = {};
	    this._rowHeightCache = {};
	    this._columnCount = 0;
	    this._rowCount = 0;
	
	    this.columnWidth = function (_ref) {
	      var index = _ref.index;
	
	      var key = _this._keyMapper(0, index);
	
	      return _this._columnWidthCache.hasOwnProperty(key) ? _this._columnWidthCache[key] : _this._defaultWidth;
	    };
	
	    this.rowHeight = function (_ref2) {
	      var index = _ref2.index;
	
	      var key = _this._keyMapper(index, 0);
	
	      return _this._rowHeightCache.hasOwnProperty(key) ? _this._rowHeightCache[key] : _this._defaultHeight;
	    };
	
	    var defaultHeight = params.defaultHeight,
	        defaultWidth = params.defaultWidth,
	        fixedHeight = params.fixedHeight,
	        fixedWidth = params.fixedWidth,
	        keyMapper = params.keyMapper,
	        minHeight = params.minHeight,
	        minWidth = params.minWidth;
	
	
	    this._hasFixedHeight = fixedHeight === true;
	    this._hasFixedWidth = fixedWidth === true;
	    this._minHeight = minHeight || 0;
	    this._minWidth = minWidth || 0;
	    this._keyMapper = keyMapper || defaultKeyMapper;
	
	    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
	    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);
	
	    if (false) {
	      if (this._hasFixedHeight === false && this._hasFixedWidth === false) {
	        console.warn("CellMeasurerCache should only measure a cell's width or height. " + 'You have configured CellMeasurerCache to measure both. ' + 'This will result in poor performance.');
	      }
	
	      if (this._hasFixedHeight === false && this._defaultHeight === 0) {
	        console.warn('Fixed height CellMeasurerCache should specify a :defaultHeight greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
	      }
	
	      if (this._hasFixedWidth === false && this._defaultWidth === 0) {
	        console.warn('Fixed width CellMeasurerCache should specify a :defaultWidth greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
	      }
	    }
	  }
	
	  (0, _createClass3.default)(CellMeasurerCache, [{
	    key: 'clear',
	    value: function clear(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var key = this._keyMapper(rowIndex, columnIndex);
	
	      delete this._cellHeightCache[key];
	      delete this._cellWidthCache[key];
	
	      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
	    }
	  }, {
	    key: 'clearAll',
	    value: function clearAll() {
	      this._cellHeightCache = {};
	      this._cellWidthCache = {};
	      this._columnWidthCache = {};
	      this._rowHeightCache = {};
	      this._rowCount = 0;
	      this._columnCount = 0;
	    }
	  }, {
	    key: 'hasFixedHeight',
	    value: function hasFixedHeight() {
	      return this._hasFixedHeight;
	    }
	  }, {
	    key: 'hasFixedWidth',
	    value: function hasFixedWidth() {
	      return this._hasFixedWidth;
	    }
	  }, {
	    key: 'getHeight',
	    value: function getHeight(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (this._hasFixedHeight) {
	        return this._defaultHeight;
	      } else {
	        var _key = this._keyMapper(rowIndex, columnIndex);
	
	        return this._cellHeightCache.hasOwnProperty(_key) ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
	      }
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (this._hasFixedWidth) {
	        return this._defaultWidth;
	      } else {
	        var _key2 = this._keyMapper(rowIndex, columnIndex);
	
	        return this._cellWidthCache.hasOwnProperty(_key2) ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
	      }
	    }
	  }, {
	    key: 'has',
	    value: function has(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var key = this._keyMapper(rowIndex, columnIndex);
	
	      return this._cellHeightCache.hasOwnProperty(key);
	    }
	  }, {
	    key: 'set',
	    value: function set(rowIndex, columnIndex, width, height) {
	      var key = this._keyMapper(rowIndex, columnIndex);
	
	      if (columnIndex >= this._columnCount) {
	        this._columnCount = columnIndex + 1;
	      }
	      if (rowIndex >= this._rowCount) {
	        this._rowCount = rowIndex + 1;
	      }
	
	      // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
	      this._cellHeightCache[key] = height;
	      this._cellWidthCache[key] = width;
	
	      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
	    }
	  }, {
	    key: '_updateCachedColumnAndRowSizes',
	    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
	      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
	      // Pre-cache these derived values for faster lookup later.
	      // Reads are expected to occur more frequently than writes in this case.
	      // Only update non-fixed dimensions though to avoid doing unnecessary work.
	      if (!this._hasFixedWidth) {
	        var columnWidth = 0;
	        for (var i = 0; i < this._rowCount; i++) {
	          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
	        }
	        var columnKey = this._keyMapper(0, columnIndex);
	        this._columnWidthCache[columnKey] = columnWidth;
	      }
	      if (!this._hasFixedHeight) {
	        var rowHeight = 0;
	        for (var _i = 0; _i < this._columnCount; _i++) {
	          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
	        }
	        var rowKey = this._keyMapper(rowIndex, 0);
	        this._rowHeightCache[rowKey] = rowHeight;
	      }
	    }
	  }, {
	    key: 'defaultHeight',
	    get: function get() {
	      return this._defaultHeight;
	    }
	  }, {
	    key: 'defaultWidth',
	    get: function get() {
	      return this._defaultWidth;
	    }
	  }]);
	  return CellMeasurerCache;
	}();
	
	exports.default = CellMeasurerCache;
	
	
	function defaultKeyMapper(rowIndex, columnIndex) {
	  return rowIndex + '-' + columnIndex;
	}

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CellMeasurerCache = exports.CellMeasurer = undefined;
	
	var _CellMeasurer = __webpack_require__(1135);
	
	var _CellMeasurer2 = _interopRequireDefault(_CellMeasurer);
	
	var _CellMeasurerCache = __webpack_require__(1136);
	
	var _CellMeasurerCache2 = _interopRequireDefault(_CellMeasurerCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CellMeasurer2.default;
	exports.CellMeasurer = _CellMeasurer2.default;
	exports.CellMeasurerCache = _CellMeasurerCache2.default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bpfrpt_proptype_CellMeasureCache = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bpfrpt_proptype_CellMeasureCache =  true ? null : {
	  hasFixedWidth: _propTypes2.default.func.isRequired,
	  hasFixedHeight: _propTypes2.default.func.isRequired,
	  has: _propTypes2.default.func.isRequired,
	  set: _propTypes2.default.func.isRequired,
	  getHeight: _propTypes2.default.func.isRequired,
	  getWidth: _propTypes2.default.func.isRequired
	};
	exports.bpfrpt_proptype_CellMeasureCache = bpfrpt_proptype_CellMeasureCache;

/***/ }),

/***/ 1137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(49);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _CollectionView = __webpack_require__(1138);
	
	var _CollectionView2 = _interopRequireDefault(_CollectionView);
	
	var _calculateSizeAndPositionData2 = __webpack_require__(1142);
	
	var _calculateSizeAndPositionData3 = _interopRequireDefault(_calculateSizeAndPositionData2);
	
	var _getUpdatedOffsetForIndex = __webpack_require__(1170);
	
	var _getUpdatedOffsetForIndex2 = _interopRequireDefault(_getUpdatedOffsetForIndex);
	
	var _types = __webpack_require__(322);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Renders scattered or non-linear data.
	 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
	 */
	var Collection = function (_React$PureComponent) {
	  (0, _inherits3.default)(Collection, _React$PureComponent);
	
	  function Collection(props, context) {
	    (0, _classCallCheck3.default)(this, Collection);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Collection.__proto__ || (0, _getPrototypeOf2.default)(Collection)).call(this, props, context));
	
	    _this._cellMetadata = [];
	    _this._lastRenderedCellIndices = [];
	
	    // Cell cache during scroll (for perforamnce)
	    _this._cellCache = [];
	
	    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
	    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Collection, [{
	    key: 'forceUpdate',
	    value: function forceUpdate() {
	      if (this._collectionView !== undefined) {
	        this._collectionView.forceUpdate();
	      }
	    }
	
	    /** See Collection#recomputeCellSizesAndPositions */
	
	  }, {
	    key: 'recomputeCellSizesAndPositions',
	    value: function recomputeCellSizesAndPositions() {
	      this._cellCache = [];
	      this._collectionView.recomputeCellSizesAndPositions();
	    }
	
	    /** React lifecycle methods */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = (0, _objectWithoutProperties3.default)(this.props, []);
	
	
	      return React.createElement(_CollectionView2.default, (0, _extends3.default)({
	        cellLayoutManager: this,
	        isScrollingChange: this._isScrollingChange,
	        ref: this._setCollectionViewRef
	      }, props));
	    }
	
	    /** CellLayoutManager interface */
	
	  }, {
	    key: 'calculateSizeAndPositionData',
	    value: function calculateSizeAndPositionData() {
	      var _props = this.props,
	          cellCount = _props.cellCount,
	          cellSizeAndPositionGetter = _props.cellSizeAndPositionGetter,
	          sectionSize = _props.sectionSize;
	
	
	      var data = (0, _calculateSizeAndPositionData3.default)({
	        cellCount: cellCount,
	        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
	        sectionSize: sectionSize
	      });
	
	      this._cellMetadata = data.cellMetadata;
	      this._sectionManager = data.sectionManager;
	      this._height = data.height;
	      this._width = data.width;
	    }
	
	    /**
	     * Returns the most recently rendered set of cell indices.
	     */
	
	  }, {
	    key: 'getLastRenderedIndices',
	    value: function getLastRenderedIndices() {
	      return this._lastRenderedCellIndices;
	    }
	
	    /**
	     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
	     */
	
	  }, {
	    key: 'getScrollPositionForCell',
	    value: function getScrollPositionForCell(_ref) {
	      var align = _ref.align,
	          cellIndex = _ref.cellIndex,
	          height = _ref.height,
	          scrollLeft = _ref.scrollLeft,
	          scrollTop = _ref.scrollTop,
	          width = _ref.width;
	      var cellCount = this.props.cellCount;
	
	
	      if (cellIndex >= 0 && cellIndex < cellCount) {
	        var cellMetadata = this._cellMetadata[cellIndex];
	
	        scrollLeft = (0, _getUpdatedOffsetForIndex2.default)({
	          align: align,
	          cellOffset: cellMetadata.x,
	          cellSize: cellMetadata.width,
	          containerSize: width,
	          currentOffset: scrollLeft,
	          targetIndex: cellIndex
	        });
	
	        scrollTop = (0, _getUpdatedOffsetForIndex2.default)({
	          align: align,
	          cellOffset: cellMetadata.y,
	          cellSize: cellMetadata.height,
	          containerSize: height,
	          currentOffset: scrollTop,
	          targetIndex: cellIndex
	        });
	      }
	
	      return {
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop
	      };
	    }
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      return {
	        height: this._height,
	        width: this._width
	      };
	    }
	  }, {
	    key: 'cellRenderers',
	    value: function cellRenderers(_ref2) {
	      var _this2 = this;
	
	      var height = _ref2.height,
	          isScrolling = _ref2.isScrolling,
	          width = _ref2.width,
	          x = _ref2.x,
	          y = _ref2.y;
	      var _props2 = this.props,
	          cellGroupRenderer = _props2.cellGroupRenderer,
	          cellRenderer = _props2.cellRenderer;
	
	      // Store for later calls to getLastRenderedIndices()
	
	      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
	        height: height,
	        width: width,
	        x: x,
	        y: y
	      });
	
	      return cellGroupRenderer({
	        cellCache: this._cellCache,
	        cellRenderer: cellRenderer,
	        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
	          var index = _ref3.index;
	          return _this2._sectionManager.getCellMetadata({ index: index });
	        },
	        indices: this._lastRenderedCellIndices,
	        isScrolling: isScrolling
	      });
	    }
	  }, {
	    key: '_isScrollingChange',
	    value: function _isScrollingChange(isScrolling) {
	      if (!isScrolling) {
	        this._cellCache = [];
	      }
	    }
	  }, {
	    key: '_setCollectionViewRef',
	    value: function _setCollectionViewRef(ref) {
	      this._collectionView = ref;
	    }
	  }]);
	  return Collection;
	}(React.PureComponent);
	
	Collection.defaultProps = {
	  'aria-label': 'grid',
	  cellGroupRenderer: defaultCellGroupRenderer
	};
	exports.default = Collection;
	Collection.propTypes =  false ? {
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * Number of cells in Collection.
	   */
	  cellCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Responsible for rendering a group of cells given their indices.
	   * Should implement the following interface: ({
	   *   cellSizeAndPositionGetter:Function,
	   *   indices: Array<number>,
	   *   cellRenderer: Function
	   * }): Array<PropTypes.node>
	   */
	  cellGroupRenderer: _propTypes2.default.func.isRequired,
	
	  /**
	   * Responsible for rendering a cell given an row and column index.
	   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
	   */
	  cellRenderer: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback responsible for returning size and offset/position information for a given cell (index).
	   * ({ index: number }): { height: number, width: number, x: number, y: number }
	   */
	  cellSizeAndPositionGetter: _propTypes2.default.func.isRequired,
	
	  /**
	   * Optionally override the size of the sections a Collection's cells are split into.
	   */
	  sectionSize: _propTypes2.default.number
	} : {};
	
	
	function defaultCellGroupRenderer(_ref4) {
	  var cellCache = _ref4.cellCache,
	      cellRenderer = _ref4.cellRenderer,
	      cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
	      indices = _ref4.indices,
	      isScrolling = _ref4.isScrolling;
	
	  return indices.map(function (index) {
	    var cellMetadata = cellSizeAndPositionGetter({ index: index });
	
	    var cellRendererProps = {
	      index: index,
	      isScrolling: isScrolling,
	      key: index,
	      style: {
	        height: cellMetadata.height,
	        left: cellMetadata.x,
	        position: 'absolute',
	        top: cellMetadata.y,
	        width: cellMetadata.width
	      }
	    };
	
	    // Avoid re-creating cells while scrolling.
	    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
	    // If a scroll is in progress- cache and reuse cells.
	    // This cache will be thrown away once scrolling complets.
	    if (isScrolling) {
	      if (!(index in cellCache)) {
	        cellCache[index] = cellRenderer(cellRendererProps);
	      }
	
	      return cellCache[index];
	    } else {
	      return cellRenderer(cellRendererProps);
	    }
	  }).filter(function (renderedCell) {
	    return !!renderedCell;
	  });
	}

/***/ }),

/***/ 1138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactLifecyclesCompat = __webpack_require__(118);
	
	var _createCallbackMemoizer = __webpack_require__(324);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	var _scrollbarSize = __webpack_require__(389);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @TODO Merge Collection and CollectionView
	
	/**
	 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var IS_SCROLLING_TIMEOUT = 150;
	
	/**
	 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
	 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
	 */
	var SCROLL_POSITION_CHANGE_REASONS = {
	  OBSERVED: 'observed',
	  REQUESTED: 'requested'
	};
	
	/**
	 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
	 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
	 */
	
	var CollectionView = function (_React$PureComponent) {
	  (0, _inherits3.default)(CollectionView, _React$PureComponent);
	
	  // Invokes callbacks only when their values have changed.
	  function CollectionView() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, CollectionView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    // If this component is being rendered server-side, getScrollbarSize() will return undefined.
	    // We handle this case in componentDidMount()
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = CollectionView.__proto__ || (0, _getPrototypeOf2.default)(CollectionView)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = {
	      isScrolling: false,
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	    _this._calculateSizeAndPositionDataOnNextUpdate = false;
	    _this._onSectionRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
	    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);
	
	    _this._invokeOnSectionRenderedHelper = function () {
	      var _this$props = _this.props,
	          cellLayoutManager = _this$props.cellLayoutManager,
	          onSectionRendered = _this$props.onSectionRendered;
	
	
	      _this._onSectionRenderedMemoizer({
	        callback: onSectionRendered,
	        indices: {
	          indices: cellLayoutManager.getLastRenderedIndices()
	        }
	      });
	    };
	
	    _this._setScrollingContainerRef = function (ref) {
	      _this._scrollingContainer = ref;
	    };
	
	    _this._updateScrollPositionForScrollToCell = function () {
	      var _this$props2 = _this.props,
	          cellLayoutManager = _this$props2.cellLayoutManager,
	          height = _this$props2.height,
	          scrollToAlignment = _this$props2.scrollToAlignment,
	          scrollToCell = _this$props2.scrollToCell,
	          width = _this$props2.width;
	      var _this$state = _this.state,
	          scrollLeft = _this$state.scrollLeft,
	          scrollTop = _this$state.scrollTop;
	
	
	      if (scrollToCell >= 0) {
	        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
	          align: scrollToAlignment,
	          cellIndex: scrollToCell,
	          height: height,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          width: width
	        });
	
	        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
	          _this._setScrollPosition(scrollPosition);
	        }
	      }
	    };
	
	    _this._onScroll = function (event) {
	      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
	      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
	      // See issue #404 for more information.
	      if (event.target !== _this._scrollingContainer) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      _this._enablePointerEventsAfterDelay();
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
	      var _this$props3 = _this.props,
	          cellLayoutManager = _this$props3.cellLayoutManager,
	          height = _this$props3.height,
	          isScrollingChange = _this$props3.isScrollingChange,
	          width = _this$props3.width;
	
	      var scrollbarSize = _this._scrollbarSize;
	
	      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
	          totalHeight = _cellLayoutManager$ge.height,
	          totalWidth = _cellLayoutManager$ge.width;
	
	      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
	      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
	        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
	        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
	        // All things considered, this seems to be the best current work around that I'm aware of.
	        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
	        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;
	
	        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
	        if (!_this.state.isScrolling) {
	          isScrollingChange(true);
	        }
	
	        _this.setState({
	          isScrolling: true,
	          scrollLeft: scrollLeft,
	          scrollPositionChangeReason: scrollPositionChangeReason,
	          scrollTop: scrollTop
	        });
	      }
	
	      _this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        totalWidth: totalWidth,
	        totalHeight: totalHeight
	      });
	    };
	
	    _this._scrollbarSize = (0, _scrollbarSize2.default)();
	    if (_this._scrollbarSize === undefined) {
	      _this._scrollbarSizeMeasured = false;
	      _this._scrollbarSize = 0;
	    } else {
	      _this._scrollbarSizeMeasured = true;
	    }
	    return _this;
	  }
	
	  /**
	   * Forced recompute of cell sizes and positions.
	   * This function should be called if cell sizes have changed but nothing else has.
	   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
	   */
	
	
	  (0, _createClass3.default)(CollectionView, [{
	    key: 'recomputeCellSizesAndPositions',
	    value: function recomputeCellSizesAndPositions() {
	      this._calculateSizeAndPositionDataOnNextUpdate = true;
	      this.forceUpdate();
	    }
	
	    /* ---------------------------- Component lifecycle methods ---------------------------- */
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) Empty content (0 rows or columns)
	     * 2) New scroll props overriding the current state
	     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
	     */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          cellLayoutManager = _props.cellLayoutManager,
	          scrollLeft = _props.scrollLeft,
	          scrollToCell = _props.scrollToCell,
	          scrollTop = _props.scrollTop;
	
	      // If this component was first rendered server-side, scrollbar size will be undefined.
	      // In that event we need to remeasure.
	
	      if (!this._scrollbarSizeMeasured) {
	        this._scrollbarSize = (0, _scrollbarSize2.default)();
	        this._scrollbarSizeMeasured = true;
	        this.setState({});
	      }
	
	      if (scrollToCell >= 0) {
	        this._updateScrollPositionForScrollToCell();
	      } else if (scrollLeft >= 0 || scrollTop >= 0) {
	        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
	      }
	
	      // Update onSectionRendered callback.
	      this._invokeOnSectionRenderedHelper();
	
	      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
	          totalHeight = _cellLayoutManager$ge2.height,
	          totalWidth = _cellLayoutManager$ge2.width;
	
	      // Initialize onScroll callback.
	
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft || 0,
	        scrollTop: scrollTop || 0,
	        totalHeight: totalHeight,
	        totalWidth: totalWidth
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props2 = this.props,
	          height = _props2.height,
	          scrollToAlignment = _props2.scrollToAlignment,
	          scrollToCell = _props2.scrollToCell,
	          width = _props2.width;
	      var _state = this.state,
	          scrollLeft = _state.scrollLeft,
	          scrollPositionChangeReason = _state.scrollPositionChangeReason,
	          scrollTop = _state.scrollTop;
	
	      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
	      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
	      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
	      // So we only set these when we require an adjustment of the scroll position.
	      // See issue #2 for more information.
	
	      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
	        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
	          this._scrollingContainer.scrollLeft = scrollLeft;
	        }
	        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
	          this._scrollingContainer.scrollTop = scrollTop;
	        }
	      }
	
	      // Update scroll offsets if the current :scrollToCell values requires it
	      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
	        this._updateScrollPositionForScrollToCell();
	      }
	
	      // Update onRowsRendered callback if start/stop indices have changed
	      this._invokeOnSectionRenderedHelper();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          autoHeight = _props3.autoHeight,
	          cellCount = _props3.cellCount,
	          cellLayoutManager = _props3.cellLayoutManager,
	          className = _props3.className,
	          height = _props3.height,
	          horizontalOverscanSize = _props3.horizontalOverscanSize,
	          id = _props3.id,
	          noContentRenderer = _props3.noContentRenderer,
	          style = _props3.style,
	          verticalOverscanSize = _props3.verticalOverscanSize,
	          width = _props3.width;
	      var _state2 = this.state,
	          isScrolling = _state2.isScrolling,
	          scrollLeft = _state2.scrollLeft,
	          scrollTop = _state2.scrollTop;
	
	      // Memoization reset
	
	      if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
	        this._lastRenderedCellCount = cellCount;
	        this._lastRenderedCellLayoutManager = cellLayoutManager;
	        this._calculateSizeAndPositionDataOnNextUpdate = false;
	
	        cellLayoutManager.calculateSizeAndPositionData();
	      }
	
	      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
	          totalHeight = _cellLayoutManager$ge3.height,
	          totalWidth = _cellLayoutManager$ge3.width;
	
	      // Safely expand the rendered area by the specified overscan amount
	
	
	      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
	      var top = Math.max(0, scrollTop - verticalOverscanSize);
	      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
	      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
	
	      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
	        height: bottom - top,
	        isScrolling: isScrolling,
	        width: right - left,
	        x: left,
	        y: top
	      }) : [];
	
	      var collectionStyle = {
	        boxSizing: 'border-box',
	        direction: 'ltr',
	        height: autoHeight ? 'auto' : height,
	        position: 'relative',
	        WebkitOverflowScrolling: 'touch',
	        width: width,
	        willChange: 'transform'
	      };
	
	      // Force browser to hide scrollbars when we know they aren't necessary.
	      // Otherwise once scrollbars appear they may not disappear again.
	      // For more info see issue #116
	      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
	      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;
	
	      // Also explicitly init styles to 'auto' if scrollbars are required.
	      // This works around an obscure edge case where external CSS styles have not yet been loaded,
	      // But an initial scroll index of offset is set as an external prop.
	      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
	      // This was originally reported via clauderic/react-infinite-calendar/issues/23
	      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
	      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
	
	      return React.createElement(
	        'div',
	        {
	          ref: this._setScrollingContainerRef,
	          'aria-label': this.props['aria-label'],
	          className: (0, _classnames2.default)('ReactVirtualized__Collection', className),
	          id: id,
	          onScroll: this._onScroll,
	          role: 'grid',
	          style: (0, _extends3.default)({}, collectionStyle, style),
	          tabIndex: 0 },
	        cellCount > 0 && React.createElement(
	          'div',
	          {
	            className: 'ReactVirtualized__Collection__innerScrollContainer',
	            style: {
	              height: totalHeight,
	              maxHeight: totalHeight,
	              maxWidth: totalWidth,
	              overflow: 'hidden',
	              pointerEvents: isScrolling ? 'none' : '',
	              width: totalWidth
	            } },
	          childrenToDisplay
	        ),
	        cellCount === 0 && noContentRenderer()
	      );
	    }
	
	    /* ---------------------------- Helper methods ---------------------------- */
	
	    /**
	     * Sets an :isScrolling flag for a small window of time.
	     * This flag is used to disable pointer events on the scrollable portion of the Collection.
	     * This prevents jerky/stuttery mouse-wheel scrolling.
	     */
	
	  }, {
	    key: '_enablePointerEventsAfterDelay',
	    value: function _enablePointerEventsAfterDelay() {
	      var _this2 = this;
	
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	
	      this._disablePointerEventsTimeoutId = setTimeout(function () {
	        var isScrollingChange = _this2.props.isScrollingChange;
	
	
	        isScrollingChange(false);
	
	        _this2._disablePointerEventsTimeoutId = null;
	        _this2.setState({
	          isScrolling: false
	        });
	      }, IS_SCROLLING_TIMEOUT);
	    }
	  }, {
	    key: '_invokeOnScrollMemoizer',
	    value: function _invokeOnScrollMemoizer(_ref2) {
	      var _this3 = this;
	
	      var scrollLeft = _ref2.scrollLeft,
	          scrollTop = _ref2.scrollTop,
	          totalHeight = _ref2.totalHeight,
	          totalWidth = _ref2.totalWidth;
	
	      this._onScrollMemoizer({
	        callback: function callback(_ref3) {
	          var scrollLeft = _ref3.scrollLeft,
	              scrollTop = _ref3.scrollTop;
	          var _props4 = _this3.props,
	              height = _props4.height,
	              onScroll = _props4.onScroll,
	              width = _props4.width;
	
	
	          onScroll({
	            clientHeight: height,
	            clientWidth: width,
	            scrollHeight: totalHeight,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: totalWidth
	          });
	        },
	        indices: {
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        }
	      });
	    }
	  }, {
	    key: '_setScrollPosition',
	    value: function _setScrollPosition(_ref4) {
	      var scrollLeft = _ref4.scrollLeft,
	          scrollTop = _ref4.scrollTop;
	
	      var newState = {
	        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
	      };
	
	      if (scrollLeft >= 0) {
	        newState.scrollLeft = scrollLeft;
	      }
	
	      if (scrollTop >= 0) {
	        newState.scrollTop = scrollTop;
	      }
	
	      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
	        this.setState(newState);
	      }
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) {
	        return {
	          scrollLeft: 0,
	          scrollTop: 0
	        };
	      } else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
	        return {
	          scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
	          scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop
	        };
	      }
	
	      return null;
	    }
	  }]);
	  return CollectionView;
	}(React.PureComponent);
	
	CollectionView.defaultProps = {
	  'aria-label': 'grid',
	  horizontalOverscanSize: 0,
	  noContentRenderer: function noContentRenderer() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  onSectionRendered: function onSectionRendered() {
	    return null;
	  },
	  scrollToAlignment: 'auto',
	  scrollToCell: -1,
	  style: {},
	  verticalOverscanSize: 0
	};
	CollectionView.propTypes =  false ? {
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _propTypes2.default.bool,
	
	  /**
	   * Number of cells in collection.
	   */
	  cellCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
	   */
	  cellLayoutManager: _propTypes2.default.object.isRequired,
	
	  /**
	   * Optional custom CSS class name to attach to root Collection element.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
	   */
	  height: _propTypes2.default.number.isRequired,
	
	  /**
	   * Optional custom id to attach to root Collection element.
	   */
	  id: _propTypes2.default.string,
	
	  /**
	   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
	   * This can reduce flicker around the edges when a user scrolls quickly.
	   */
	  horizontalOverscanSize: _propTypes2.default.number.isRequired,
	
	  isScrollingChange: _propTypes2.default.func,
	
	  /**
	   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
	   */
	  noContentRenderer: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
	   */
	  onScroll: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback invoked with information about the section of the Collection that was just rendered.
	   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
	   */
	  onSectionRendered: _propTypes2.default.func.isRequired,
	
	  /**
	   * Horizontal offset.
	   */
	  scrollLeft: _propTypes2.default.number,
	
	  /**
	   * Controls scroll-to-cell behavior of the Grid.
	   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
	   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
	   */
	  scrollToAlignment: _propTypes2.default.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /**
	   * Cell index to ensure visible (by forcefully scrolling if necessary).
	   */
	  scrollToCell: _propTypes2.default.number.isRequired,
	
	  /**
	   * Vertical offset.
	   */
	  scrollTop: _propTypes2.default.number,
	
	  /**
	   * Optional custom inline style to attach to root Collection element.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
	   * This can reduce flicker around the edges when a user scrolls quickly.
	   */
	  verticalOverscanSize: _propTypes2.default.number.isRequired,
	
	  /**
	   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
	   */
	  width: _propTypes2.default.number.isRequired
	} : {};
	
	
	(0, _reactLifecyclesCompat.polyfill)(CollectionView);
	
	exports.default = CollectionView;

/***/ }),

/***/ 1139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _types = __webpack_require__(322);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A section of the Window.
	 * Window Sections are used to group nearby cells.
	 * This enables us to more quickly determine which cells to display in a given region of the Window.
	 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
	 */
	var Section = function () {
	  function Section(_ref) {
	    var height = _ref.height,
	        width = _ref.width,
	        x = _ref.x,
	        y = _ref.y;
	    (0, _classCallCheck3.default)(this, Section);
	
	    this.height = height;
	    this.width = width;
	    this.x = x;
	    this.y = y;
	
	    this._indexMap = {};
	    this._indices = [];
	  }
	
	  /** Add a cell to this section. */
	
	
	  (0, _createClass3.default)(Section, [{
	    key: 'addCellIndex',
	    value: function addCellIndex(_ref2) {
	      var index = _ref2.index;
	
	      if (!this._indexMap[index]) {
	        this._indexMap[index] = true;
	        this._indices.push(index);
	      }
	    }
	
	    /** Get all cell indices that have been added to this section. */
	
	  }, {
	    key: 'getCellIndices',
	    value: function getCellIndices() {
	      return this._indices;
	    }
	
	    /** Intended for debugger/test purposes only */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return this.x + ',' + this.y + ' ' + this.width + 'x' + this.height;
	    }
	  }]);
	  return Section;
	}();
	
	exports.default = Section;

/***/ }),

/***/ 1140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(100);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Section = __webpack_require__(1139);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _types = __webpack_require__(322);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SECTION_SIZE = 100; /**
	                         * Window Sections are used to group nearby cells.
	                         * This enables us to more quickly determine which cells to display in a given region of the Window.
	                         * 
	                         */
	
	/**
	 * Contains 0 to many Sections.
	 * Grows (and adds Sections) dynamically as cells are registered.
	 * Automatically adds cells to the appropriate Section(s).
	 */
	var SectionManager = function () {
	  function SectionManager() {
	    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;
	    (0, _classCallCheck3.default)(this, SectionManager);
	
	    this._sectionSize = sectionSize;
	
	    this._cellMetadata = [];
	    this._sections = {};
	  }
	
	  /**
	   * Gets all cell indices contained in the specified region.
	   * A region may encompass 1 or more Sections.
	   */
	
	
	  (0, _createClass3.default)(SectionManager, [{
	    key: 'getCellIndices',
	    value: function getCellIndices(_ref) {
	      var height = _ref.height,
	          width = _ref.width,
	          x = _ref.x,
	          y = _ref.y;
	
	      var indices = {};
	
	      this.getSections({ height: height, width: width, x: x, y: y }).forEach(function (section) {
	        return section.getCellIndices().forEach(function (index) {
	          indices[index] = index;
	        });
	      });
	
	      // Object keys are strings; this function returns numbers
	      return (0, _keys2.default)(indices).map(function (index) {
	        return indices[index];
	      });
	    }
	
	    /** Get size and position information for the cell specified. */
	
	  }, {
	    key: 'getCellMetadata',
	    value: function getCellMetadata(_ref2) {
	      var index = _ref2.index;
	
	      return this._cellMetadata[index];
	    }
	
	    /** Get all Sections overlapping the specified region. */
	
	  }, {
	    key: 'getSections',
	    value: function getSections(_ref3) {
	      var height = _ref3.height,
	          width = _ref3.width,
	          x = _ref3.x,
	          y = _ref3.y;
	
	      var sectionXStart = Math.floor(x / this._sectionSize);
	      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
	      var sectionYStart = Math.floor(y / this._sectionSize);
	      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
	
	      var sections = [];
	
	      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
	        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
	          var key = sectionX + '.' + sectionY;
	
	          if (!this._sections[key]) {
	            this._sections[key] = new _Section2.default({
	              height: this._sectionSize,
	              width: this._sectionSize,
	              x: sectionX * this._sectionSize,
	              y: sectionY * this._sectionSize
	            });
	          }
	
	          sections.push(this._sections[key]);
	        }
	      }
	
	      return sections;
	    }
	
	    /** Total number of Sections based on the currently registered cells. */
	
	  }, {
	    key: 'getTotalSectionCount',
	    value: function getTotalSectionCount() {
	      return (0, _keys2.default)(this._sections).length;
	    }
	
	    /** Intended for debugger/test purposes only */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var _this = this;
	
	      return (0, _keys2.default)(this._sections).map(function (index) {
	        return _this._sections[index].toString();
	      });
	    }
	
	    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */
	
	  }, {
	    key: 'registerCell',
	    value: function registerCell(_ref4) {
	      var cellMetadatum = _ref4.cellMetadatum,
	          index = _ref4.index;
	
	      this._cellMetadata[index] = cellMetadatum;
	
	      this.getSections(cellMetadatum).forEach(function (section) {
	        return section.addCellIndex({ index: index });
	      });
	    }
	  }]);
	  return SectionManager;
	}();
	
	exports.default = SectionManager;

/***/ }),

/***/ 1141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Collection = undefined;
	
	var _Collection = __webpack_require__(1137);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Collection2.default;
	exports.Collection = _Collection2.default;

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bpfrpt_proptype_SizeInfo = exports.bpfrpt_proptype_SizeAndPositionInfo = exports.bpfrpt_proptype_ScrollPosition = exports.bpfrpt_proptype_PositionInfo = exports.bpfrpt_proptype_Index = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bpfrpt_proptype_Index =  true ? null : {
	  index: _propTypes2.default.number.isRequired
	};
	var bpfrpt_proptype_PositionInfo =  true ? null : {
	  x: _propTypes2.default.number.isRequired,
	  y: _propTypes2.default.number.isRequired
	};
	var bpfrpt_proptype_ScrollPosition =  true ? null : {
	  scrollLeft: _propTypes2.default.number.isRequired,
	  scrollTop: _propTypes2.default.number.isRequired
	};
	var bpfrpt_proptype_SizeAndPositionInfo =  true ? null : {
	  height: _propTypes2.default.number.isRequired,
	  width: _propTypes2.default.number.isRequired,
	  x: _propTypes2.default.number.isRequired,
	  y: _propTypes2.default.number.isRequired
	};
	var bpfrpt_proptype_SizeInfo =  true ? null : {
	  height: _propTypes2.default.number.isRequired,
	  width: _propTypes2.default.number.isRequired
	};
	exports.bpfrpt_proptype_Index = bpfrpt_proptype_Index;
	exports.bpfrpt_proptype_PositionInfo = bpfrpt_proptype_PositionInfo;
	exports.bpfrpt_proptype_ScrollPosition = bpfrpt_proptype_ScrollPosition;
	exports.bpfrpt_proptype_SizeAndPositionInfo = bpfrpt_proptype_SizeAndPositionInfo;
	exports.bpfrpt_proptype_SizeInfo = bpfrpt_proptype_SizeInfo;

/***/ }),

/***/ 1142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateSizeAndPositionData;
	
	var _SectionManager = __webpack_require__(1140);
	
	var _SectionManager2 = _interopRequireDefault(_SectionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calculateSizeAndPositionData(_ref) {
	  var cellCount = _ref.cellCount,
	      cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
	      sectionSize = _ref.sectionSize;
	
	  var cellMetadata = [];
	  var sectionManager = new _SectionManager2.default(sectionSize);
	  var height = 0;
	  var width = 0;
	
	  for (var index = 0; index < cellCount; index++) {
	    var cellMetadatum = cellSizeAndPositionGetter({ index: index });
	
	    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
	      throw Error('Invalid metadata returned for cell ' + index + ':\n        x:' + cellMetadatum.x + ', y:' + cellMetadatum.y + ', width:' + cellMetadatum.width + ', height:' + cellMetadatum.height);
	    }
	
	    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
	    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
	
	    cellMetadata[index] = cellMetadatum;
	    sectionManager.registerCell({
	      cellMetadatum: cellMetadatum,
	      index: index
	    });
	  }
	
	  return {
	    cellMetadata: cellMetadata,
	    height: height,
	    sectionManager: sectionManager,
	    width: width
	  };
	}

/***/ }),

/***/ 1143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * High-order component that auto-calculates column-widths for `Grid` cells.
	 */
	var ColumnSizer = function (_React$PureComponent) {
	  (0, _inherits3.default)(ColumnSizer, _React$PureComponent);
	
	  function ColumnSizer(props, context) {
	    (0, _classCallCheck3.default)(this, ColumnSizer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ColumnSizer.__proto__ || (0, _getPrototypeOf2.default)(ColumnSizer)).call(this, props, context));
	
	    _this._registerChild = _this._registerChild.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ColumnSizer, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          columnMaxWidth = _props.columnMaxWidth,
	          columnMinWidth = _props.columnMinWidth,
	          columnCount = _props.columnCount,
	          width = _props.width;
	
	
	      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
	        if (this._registeredChild) {
	          this._registeredChild.recomputeGridSize();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          columnMaxWidth = _props2.columnMaxWidth,
	          columnMinWidth = _props2.columnMinWidth,
	          columnCount = _props2.columnCount,
	          width = _props2.width;
	
	
	      var safeColumnMinWidth = columnMinWidth || 1;
	
	      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
	
	      var columnWidth = width / columnCount;
	      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
	      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
	      columnWidth = Math.floor(columnWidth);
	
	      var adjustedWidth = Math.min(width, columnWidth * columnCount);
	
	      return children({
	        adjustedWidth: adjustedWidth,
	        columnWidth: columnWidth,
	        getColumnWidth: function getColumnWidth() {
	          return columnWidth;
	        },
	        registerChild: this._registerChild
	      });
	    }
	  }, {
	    key: '_registerChild',
	    value: function _registerChild(child) {
	      if (child && typeof child.recomputeGridSize !== 'function') {
	        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
	      }
	
	      this._registeredChild = child;
	
	      if (this._registeredChild) {
	        this._registeredChild.recomputeGridSize();
	      }
	    }
	  }]);
	  return ColumnSizer;
	}(React.PureComponent);
	
	exports.default = ColumnSizer;
	ColumnSizer.propTypes =  false ? {
	  /**
	   * Function responsible for rendering a virtualized Grid.
	   * This function should implement the following signature:
	   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
	   *
	   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
	   * The :registerChild should be passed to the Grid's :ref property.
	   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
	   */
	  children: _propTypes2.default.func.isRequired,
	
	  /** Optional maximum allowed column width */
	  columnMaxWidth: _propTypes2.default.number,
	
	  /** Optional minimum allowed column width */
	  columnMinWidth: _propTypes2.default.number,
	
	  /** Number of columns in Grid or Table child */
	  columnCount: _propTypes2.default.number.isRequired,
	
	  /** Width of Grid or Table child */
	  width: _propTypes2.default.number.isRequired
	} : {};

/***/ }),

/***/ 1144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColumnSizer = undefined;
	
	var _ColumnSizer = __webpack_require__(1143);
	
	var _ColumnSizer2 = _interopRequireDefault(_ColumnSizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ColumnSizer2.default;
	exports.ColumnSizer = _ColumnSizer2.default;

/***/ }),

/***/ 1145:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;
	
	var _assign = __webpack_require__(347);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset = __webpack_require__(1148);
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset2 = _interopRequireDefault(_calculateSizeAndPositionDataAndUpdateScrollOffset);
	
	var _ScalingCellSizeAndPositionManager = __webpack_require__(323);
	
	var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);
	
	var _createCallbackMemoizer = __webpack_require__(324);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	var _defaultOverscanIndicesGetter = __webpack_require__(481);
	
	var _defaultOverscanIndicesGetter2 = _interopRequireDefault(_defaultOverscanIndicesGetter);
	
	var _updateScrollIndexHelper = __webpack_require__(1150);
	
	var _updateScrollIndexHelper2 = _interopRequireDefault(_updateScrollIndexHelper);
	
	var _defaultCellRangeRenderer = __webpack_require__(480);
	
	var _defaultCellRangeRenderer2 = _interopRequireDefault(_defaultCellRangeRenderer);
	
	var _scrollbarSize = __webpack_require__(389);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _reactLifecyclesCompat = __webpack_require__(118);
	
	var _requestAnimationTimeout = __webpack_require__(325);
	
	var _types = __webpack_require__(82);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
	
	/**
	 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
	 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
	 */
	
	
	var SCROLL_POSITION_CHANGE_REASONS = {
	  OBSERVED: 'observed',
	  REQUESTED: 'requested'
	};
	
	var renderNull = function renderNull() {
	  return null;
	};
	
	/**
	 * Renders tabular data with virtualization along the vertical and horizontal axes.
	 * Row heights and column widths must be known ahead of time and specified as properties.
	 */
	var Grid = function (_React$PureComponent) {
	  (0, _inherits3.default)(Grid, _React$PureComponent);
	
	  // Invokes onSectionRendered callback only when start/stop row or column indices change
	  function Grid(props) {
	    (0, _classCallCheck3.default)(this, Grid);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, _getPrototypeOf2.default)(Grid)).call(this, props));
	
	    _this._onGridRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
	    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);
	    _this._deferredInvalidateColumnIndex = null;
	    _this._deferredInvalidateRowIndex = null;
	    _this._recomputeScrollLeftFlag = false;
	    _this._recomputeScrollTopFlag = false;
	    _this._horizontalScrollBarSize = 0;
	    _this._verticalScrollBarSize = 0;
	    _this._scrollbarPresenceChanged = false;
	    _this._renderedColumnStartIndex = 0;
	    _this._renderedColumnStopIndex = 0;
	    _this._renderedRowStartIndex = 0;
	    _this._renderedRowStopIndex = 0;
	    _this._styleCache = {};
	    _this._cellCache = {};
	
	    _this._debounceScrollEndedCallback = function () {
	      _this._disablePointerEventsTimeoutId = null;
	      // isScrolling is used to determine if we reset styleCache
	      _this.setState({
	        isScrolling: false,
	        needToResetStyleCache: false
	      });
	    };
	
	    _this._invokeOnGridRenderedHelper = function () {
	      var onSectionRendered = _this.props.onSectionRendered;
	
	
	      _this._onGridRenderedMemoizer({
	        callback: onSectionRendered,
	        indices: {
	          columnOverscanStartIndex: _this._columnStartIndex,
	          columnOverscanStopIndex: _this._columnStopIndex,
	          columnStartIndex: _this._renderedColumnStartIndex,
	          columnStopIndex: _this._renderedColumnStopIndex,
	          rowOverscanStartIndex: _this._rowStartIndex,
	          rowOverscanStopIndex: _this._rowStopIndex,
	          rowStartIndex: _this._renderedRowStartIndex,
	          rowStopIndex: _this._renderedRowStopIndex
	        }
	      });
	    };
	
	    _this._setScrollingContainerRef = function (ref) {
	      _this._scrollingContainer = ref;
	    };
	
	    _this._onScroll = function (event) {
	      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
	      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
	      // See issue #404 for more information.
	      if (event.target === _this._scrollingContainer) {
	        _this.handleScrollEvent(event.target);
	      }
	    };
	
	    var columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
	      cellCount: props.columnCount,
	      cellSizeGetter: function cellSizeGetter(params) {
	        return Grid._wrapSizeGetter(props.columnWidth)(params);
	      },
	      estimatedCellSize: Grid._getEstimatedColumnSize(props)
	    });
	    var rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
	      cellCount: props.rowCount,
	      cellSizeGetter: function cellSizeGetter(params) {
	        return Grid._wrapSizeGetter(props.rowHeight)(params);
	      },
	      estimatedCellSize: Grid._getEstimatedRowSize(props)
	    });
	
	    _this.state = {
	      instanceProps: {
	        columnSizeAndPositionManager: columnSizeAndPositionManager,
	        rowSizeAndPositionManager: rowSizeAndPositionManager,
	
	        prevColumnWidth: props.columnWidth,
	        prevRowHeight: props.rowHeight,
	        prevColumnCount: props.columnCount,
	        prevRowCount: props.rowCount,
	        prevIsScrolling: props.isScrolling === true,
	        prevScrollToColumn: props.scrollToColumn,
	        prevScrollToRow: props.scrollToRow,
	
	        scrollbarSize: 0,
	        scrollbarSizeMeasured: false
	      },
	      isScrolling: false,
	      scrollDirectionHorizontal: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
	      scrollDirectionVertical: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
	      scrollLeft: 0,
	      scrollTop: 0,
	      scrollPositionChangeReason: null,
	
	      needToResetStyleCache: false
	    };
	
	    if (props.scrollToRow > 0) {
	      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
	    }
	    if (props.scrollToColumn > 0) {
	      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
	    }
	    return _this;
	  }
	
	  /**
	   * Gets offsets for a given cell and alignment.
	   */
	
	
	  (0, _createClass3.default)(Grid, [{
	    key: 'getOffsetForCell',
	    value: function getOffsetForCell() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$alignment = _ref.alignment,
	          alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment,
	          _ref$columnIndex = _ref.columnIndex,
	          columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex,
	          _ref$rowIndex = _ref.rowIndex,
	          rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;
	
	      var offsetProps = (0, _extends3.default)({}, this.props, {
	        scrollToAlignment: alignment,
	        scrollToColumn: columnIndex,
	        scrollToRow: rowIndex
	      });
	
	      return {
	        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
	        scrollTop: this._getCalculatedScrollTop(offsetProps)
	      };
	    }
	
	    /**
	     * Gets estimated total rows' height.
	     */
	
	  }, {
	    key: 'getTotalRowsHeight',
	    value: function getTotalRowsHeight() {
	      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
	    }
	
	    /**
	     * Gets estimated total columns' width.
	     */
	
	  }, {
	    key: 'getTotalColumnsWidth',
	    value: function getTotalColumnsWidth() {
	      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
	    }
	
	    /**
	     * This method handles a scroll event originating from an external scroll control.
	     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
	     */
	
	  }, {
	    key: 'handleScrollEvent',
	    value: function handleScrollEvent(_ref2) {
	      var _ref2$scrollLeft = _ref2.scrollLeft,
	          scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
	          _ref2$scrollTop = _ref2.scrollTop,
	          scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;
	
	      // On iOS, we can arrive at negative offsets by swiping past the start.
	      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
	      if (scrollTopParam < 0) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      this._debounceScrollEnded();
	
	      var _props = this.props,
	          autoHeight = _props.autoHeight,
	          autoWidth = _props.autoWidth,
	          height = _props.height,
	          width = _props.width;
	      var instanceProps = this.state.instanceProps;
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
	
	      var scrollbarSize = instanceProps.scrollbarSize;
	      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
	      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
	      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
	      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
	        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
	        // Don't change direction for an axis unless scroll offset has changed.
	        var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
	        var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
	
	        var newState = {
	          isScrolling: true,
	          scrollDirectionHorizontal: _scrollDirectionHorizontal,
	          scrollDirectionVertical: _scrollDirectionVertical,
	          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
	        };
	
	        if (!autoHeight) {
	          newState.scrollTop = scrollTop;
	        }
	
	        if (!autoWidth) {
	          newState.scrollLeft = scrollLeft;
	        }
	
	        newState.needToResetStyleCache = false;
	        this.setState(newState);
	      }
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        totalColumnsWidth: totalColumnsWidth,
	        totalRowsHeight: totalRowsHeight
	      });
	    }
	
	    /**
	     * Invalidate Grid size and recompute visible cells.
	     * This is a deferred wrapper for recomputeGridSize().
	     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
	     * This method is intended for advanced use-cases like CellMeasurer.
	     */
	    // @TODO (bvaughn) Add automated test coverage for this.
	
	  }, {
	    key: 'invalidateCellSizeAfterRender',
	    value: function invalidateCellSizeAfterRender(_ref3) {
	      var columnIndex = _ref3.columnIndex,
	          rowIndex = _ref3.rowIndex;
	
	      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
	      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
	    }
	
	    /**
	     * Pre-measure all columns and rows in a Grid.
	     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
	     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
	     */
	
	  }, {
	    key: 'measureAllCells',
	    value: function measureAllCells() {
	      var _props2 = this.props,
	          columnCount = _props2.columnCount,
	          rowCount = _props2.rowCount;
	      var instanceProps = this.state.instanceProps;
	
	      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
	      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
	    }
	
	    /**
	     * Forced recompute of row heights and column widths.
	     * This function should be called if dynamic column or row sizes have changed but nothing else has.
	     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
	     */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref4$columnIndex = _ref4.columnIndex,
	          columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex,
	          _ref4$rowIndex = _ref4.rowIndex,
	          rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;
	
	      var _props3 = this.props,
	          scrollToColumn = _props3.scrollToColumn,
	          scrollToRow = _props3.scrollToRow;
	      var instanceProps = this.state.instanceProps;
	
	
	      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
	      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);
	
	      // Cell sizes may be determined by a function property.
	      // In this case the cDU handler can't know if they changed.
	      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
	      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && columnIndex <= scrollToColumn;
	      this._recomputeScrollTopFlag = scrollToRow >= 0 && rowIndex <= scrollToRow;
	
	      // Clear cell cache in case we are scrolling;
	      // Invalid row heights likely mean invalid cached content as well.
	      this._styleCache = {};
	      this._cellCache = {};
	
	      this.forceUpdate();
	    }
	
	    /**
	     * Ensure column and row are visible.
	     */
	
	  }, {
	    key: 'scrollToCell',
	    value: function scrollToCell(_ref5) {
	      var columnIndex = _ref5.columnIndex,
	          rowIndex = _ref5.rowIndex;
	      var columnCount = this.props.columnCount;
	
	
	      var props = this.props;
	
	      // Don't adjust scroll offset for single-column grids (eg List, Table).
	      // This can cause a funky scroll offset because of the vertical scrollbar width.
	      if (columnCount > 1 && columnIndex !== undefined) {
	        this._updateScrollLeftForScrollToColumn((0, _extends3.default)({}, props, {
	          scrollToColumn: columnIndex
	        }));
	      }
	
	      if (rowIndex !== undefined) {
	        this._updateScrollTopForScrollToRow((0, _extends3.default)({}, props, {
	          scrollToRow: rowIndex
	        }));
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props4 = this.props,
	          getScrollbarSize = _props4.getScrollbarSize,
	          height = _props4.height,
	          scrollLeft = _props4.scrollLeft,
	          scrollToColumn = _props4.scrollToColumn,
	          scrollTop = _props4.scrollTop,
	          scrollToRow = _props4.scrollToRow,
	          width = _props4.width;
	      var instanceProps = this.state.instanceProps;
	
	      // Reset initial offsets to be ignored in browser
	
	      this._initialScrollTop = 0;
	      this._initialScrollLeft = 0;
	
	      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
	      // We must do this at the start of the method as we may calculate and update scroll position below.
	      this._handleInvalidatedGridSize();
	
	      // If this component was first rendered server-side, scrollbar size will be undefined.
	      // In that event we need to remeasure.
	      if (!instanceProps.scrollbarSizeMeasured) {
	        this.setState(function (prevState) {
	          prevState.instanceProps.scrollbarSize = getScrollbarSize();
	          prevState.instanceProps.scrollbarSizeMeasured = true;
	          prevState.needToResetStyleCache = false;
	          return prevState;
	        });
	      }
	
	      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
	        this.setState(function (prevState) {
	          var stateUpdate = Grid._getScrollToPositionStateUpdate({
	            prevState: prevState,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop
	          });
	          if (stateUpdate) {
	            stateUpdate.needToResetStyleCache = false;
	            return stateUpdate;
	          }
	          return null;
	        });
	      }
	
	      // setting the ref's scrollLeft and scrollTop.
	      // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
	      if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
	        this._scrollingContainer.scrollLeft = this.state.scrollLeft;
	      }
	      if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
	        this._scrollingContainer.scrollTop = this.state.scrollTop;
	      }
	
	      // Don't update scroll offset if the size is 0; we don't render any cells in this case.
	      // Setting a state may cause us to later thing we've updated the offce when we haven't.
	      var sizeIsBiggerThanZero = height > 0 && width > 0;
	      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
	        this._updateScrollLeftForScrollToColumn();
	      }
	      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
	        this._updateScrollTopForScrollToRow();
	      }
	
	      // Update onRowsRendered callback
	      this._invokeOnGridRenderedHelper();
	
	      // Initialize onScroll callback
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft || 0,
	        scrollTop: scrollTop || 0,
	        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
	        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
	      });
	
	      this._maybeCallOnScrollbarPresenceChange();
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) New scroll-to-cell props have been set
	     */
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      var _props5 = this.props,
	          autoHeight = _props5.autoHeight,
	          autoWidth = _props5.autoWidth,
	          columnCount = _props5.columnCount,
	          height = _props5.height,
	          rowCount = _props5.rowCount,
	          scrollToAlignment = _props5.scrollToAlignment,
	          scrollToColumn = _props5.scrollToColumn,
	          scrollToRow = _props5.scrollToRow,
	          width = _props5.width;
	      var _state = this.state,
	          scrollLeft = _state.scrollLeft,
	          scrollPositionChangeReason = _state.scrollPositionChangeReason,
	          scrollTop = _state.scrollTop,
	          instanceProps = _state.instanceProps;
	      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
	      // We must do this at the start of the method as we may calculate and update scroll position below.
	
	      this._handleInvalidatedGridSize();
	
	      // Handle edge case where column or row count has only just increased over 0.
	      // In this case we may have to restore a previously-specified scroll offset.
	      // For more info see bvaughn/react-virtualized/issues/218
	      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
	
	      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
	      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
	      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
	      // So we only set these when we require an adjustment of the scroll position.
	      // See issue #2 for more information.
	      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
	        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
	        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
	        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollLeft = scrollLeft;
	        }
	        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollTop = scrollTop;
	        }
	      }
	
	      // Special case where the previous size was 0:
	      // In this case we don't show any windowed cells at all.
	      // So we should always recalculate offset afterwards.
	      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;
	
	      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
	      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
	      if (this._recomputeScrollLeftFlag) {
	        this._recomputeScrollLeftFlag = false;
	        this._updateScrollLeftForScrollToColumn(this.props);
	      } else {
	        (0, _updateScrollIndexHelper2.default)({
	          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
	          previousCellsCount: prevProps.columnCount,
	          previousCellSize: prevProps.columnWidth,
	          previousScrollToAlignment: prevProps.scrollToAlignment,
	          previousScrollToIndex: prevProps.scrollToColumn,
	          previousSize: prevProps.width,
	          scrollOffset: scrollLeft,
	          scrollToAlignment: scrollToAlignment,
	          scrollToIndex: scrollToColumn,
	          size: width,
	          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
	          updateScrollIndexCallback: function updateScrollIndexCallback() {
	            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
	          }
	        });
	      }
	
	      if (this._recomputeScrollTopFlag) {
	        this._recomputeScrollTopFlag = false;
	        this._updateScrollTopForScrollToRow(this.props);
	      } else {
	        (0, _updateScrollIndexHelper2.default)({
	          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
	          previousCellsCount: prevProps.rowCount,
	          previousCellSize: prevProps.rowHeight,
	          previousScrollToAlignment: prevProps.scrollToAlignment,
	          previousScrollToIndex: prevProps.scrollToRow,
	          previousSize: prevProps.height,
	          scrollOffset: scrollTop,
	          scrollToAlignment: scrollToAlignment,
	          scrollToIndex: scrollToRow,
	          size: height,
	          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
	          updateScrollIndexCallback: function updateScrollIndexCallback() {
	            return _this2._updateScrollTopForScrollToRow(_this2.props);
	          }
	        });
	      }
	
	      // Update onRowsRendered callback if start/stop indices have changed
	      this._invokeOnGridRenderedHelper();
	
	      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
	      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
	        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
	        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
	
	        this._invokeOnScrollMemoizer({
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          totalColumnsWidth: totalColumnsWidth,
	          totalRowsHeight: totalRowsHeight
	        });
	      }
	
	      this._maybeCallOnScrollbarPresenceChange();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._disablePointerEventsTimeoutId) {
	        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
	      }
	    }
	
	    /**
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) Empty content (0 rows or columns)
	     * 2) New scroll props overriding the current state
	     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          autoContainerWidth = _props6.autoContainerWidth,
	          autoHeight = _props6.autoHeight,
	          autoWidth = _props6.autoWidth,
	          className = _props6.className,
	          containerProps = _props6.containerProps,
	          containerRole = _props6.containerRole,
	          containerStyle = _props6.containerStyle,
	          height = _props6.height,
	          id = _props6.id,
	          noContentRenderer = _props6.noContentRenderer,
	          role = _props6.role,
	          style = _props6.style,
	          tabIndex = _props6.tabIndex,
	          width = _props6.width;
	      var _state2 = this.state,
	          instanceProps = _state2.instanceProps,
	          needToResetStyleCache = _state2.needToResetStyleCache;
	
	
	      var isScrolling = this._isScrolling();
	
	      var gridStyle = {
	        boxSizing: 'border-box',
	        direction: 'ltr',
	        height: autoHeight ? 'auto' : height,
	        position: 'relative',
	        width: autoWidth ? 'auto' : width,
	        WebkitOverflowScrolling: 'touch',
	        willChange: 'transform'
	      };
	
	      if (needToResetStyleCache) {
	        this._styleCache = {};
	      }
	
	      // calculate _styleCache here
	      // if state.isScrolling (not from _isScrolling) then reset
	      if (!this.state.isScrolling) {
	        this._resetStyleCache();
	      }
	
	      // calculate children to render here
	      this._calculateChildrenToRender(this.props, this.state);
	
	      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
	      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
	
	      // Force browser to hide scrollbars when we know they aren't necessary.
	      // Otherwise once scrollbars appear they may not disappear again.
	      // For more info see issue #116
	      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
	      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
	
	      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
	        this._horizontalScrollBarSize = horizontalScrollBarSize;
	        this._verticalScrollBarSize = verticalScrollBarSize;
	        this._scrollbarPresenceChanged = true;
	      }
	
	      // Also explicitly init styles to 'auto' if scrollbars are required.
	      // This works around an obscure edge case where external CSS styles have not yet been loaded,
	      // But an initial scroll index of offset is set as an external prop.
	      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
	      // This was originally reported via clauderic/react-infinite-calendar/issues/23
	      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
	      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
	
	      var childrenToDisplay = this._childrenToDisplay;
	
	      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
	
	      return React.createElement(
	        'div',
	        (0, _extends3.default)({
	          ref: this._setScrollingContainerRef
	        }, containerProps, {
	          'aria-label': this.props['aria-label'],
	          'aria-readonly': this.props['aria-readonly'],
	          className: (0, _classnames2.default)('ReactVirtualized__Grid', className),
	          id: id,
	          onScroll: this._onScroll,
	          role: role,
	          style: (0, _extends3.default)({}, gridStyle, style),
	          tabIndex: tabIndex }),
	        childrenToDisplay.length > 0 && React.createElement(
	          'div',
	          {
	            className: 'ReactVirtualized__Grid__innerScrollContainer',
	            role: containerRole,
	            style: (0, _extends3.default)({
	              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
	              height: totalRowsHeight,
	              maxWidth: totalColumnsWidth,
	              maxHeight: totalRowsHeight,
	              overflow: 'hidden',
	              pointerEvents: isScrolling ? 'none' : '',
	              position: 'relative'
	            }, containerStyle) },
	          childrenToDisplay
	        ),
	        showNoContentRenderer && noContentRenderer()
	      );
	    }
	
	    /* ---------------------------- Helper methods ---------------------------- */
	
	  }, {
	    key: '_calculateChildrenToRender',
	    value: function _calculateChildrenToRender() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var cellRenderer = props.cellRenderer,
	          cellRangeRenderer = props.cellRangeRenderer,
	          columnCount = props.columnCount,
	          deferredMeasurementCache = props.deferredMeasurementCache,
	          height = props.height,
	          overscanColumnCount = props.overscanColumnCount,
	          overscanIndicesGetter = props.overscanIndicesGetter,
	          overscanRowCount = props.overscanRowCount,
	          rowCount = props.rowCount,
	          width = props.width;
	      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
	          scrollDirectionVertical = state.scrollDirectionVertical,
	          instanceProps = state.instanceProps;
	
	
	      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
	      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
	
	      var isScrolling = this._isScrolling(props, state);
	
	      this._childrenToDisplay = [];
	
	      // Render only enough columns and rows to cover the visible area of the grid.
	      if (height > 0 && width > 0) {
	        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
	          containerSize: height,
	          offset: scrollTop
	        });
	
	        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: height,
	          offset: scrollTop
	        });
	
	        // Store for _invokeOnGridRenderedHelper()
	        this._renderedColumnStartIndex = visibleColumnIndices.start;
	        this._renderedColumnStopIndex = visibleColumnIndices.stop;
	        this._renderedRowStartIndex = visibleRowIndices.start;
	        this._renderedRowStopIndex = visibleRowIndices.stop;
	
	        var overscanColumnIndices = overscanIndicesGetter({
	          direction: 'horizontal',
	          cellCount: columnCount,
	          overscanCellsCount: overscanColumnCount,
	          scrollDirection: scrollDirectionHorizontal,
	          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
	          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
	        });
	
	        var overscanRowIndices = overscanIndicesGetter({
	          direction: 'vertical',
	          cellCount: rowCount,
	          overscanCellsCount: overscanRowCount,
	          scrollDirection: scrollDirectionVertical,
	          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
	          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
	        });
	
	        // Store for _invokeOnGridRenderedHelper()
	        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
	        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
	        var rowStartIndex = overscanRowIndices.overscanStartIndex;
	        var rowStopIndex = overscanRowIndices.overscanStopIndex;
	
	        // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
	        if (deferredMeasurementCache) {
	          // If rows have a dynamic height, scan the rows we are about to render.
	          // If any have not yet been measured, then we need to render all columns initially,
	          // Because the height of the row is equal to the tallest cell within that row,
	          // (And so we can't know the height without measuring all column-cells first).
	          if (!deferredMeasurementCache.hasFixedHeight()) {
	            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
	              if (!deferredMeasurementCache.has(rowIndex, 0)) {
	                columnStartIndex = 0;
	                columnStopIndex = columnCount - 1;
	                break;
	              }
	            }
	          }
	
	          // If columns have a dynamic width, scan the columns we are about to render.
	          // If any have not yet been measured, then we need to render all rows initially,
	          // Because the width of the column is equal to the widest cell within that column,
	          // (And so we can't know the width without measuring all row-cells first).
	          if (!deferredMeasurementCache.hasFixedWidth()) {
	            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
	              if (!deferredMeasurementCache.has(0, columnIndex)) {
	                rowStartIndex = 0;
	                rowStopIndex = rowCount - 1;
	                break;
	              }
	            }
	          }
	        }
	
	        this._childrenToDisplay = cellRangeRenderer({
	          cellCache: this._cellCache,
	          cellRenderer: cellRenderer,
	          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
	          columnStartIndex: columnStartIndex,
	          columnStopIndex: columnStopIndex,
	          deferredMeasurementCache: deferredMeasurementCache,
	          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
	          isScrolling: isScrolling,
	          parent: this,
	          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
	          rowStartIndex: rowStartIndex,
	          rowStopIndex: rowStopIndex,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          styleCache: this._styleCache,
	          verticalOffsetAdjustment: verticalOffsetAdjustment,
	          visibleColumnIndices: visibleColumnIndices,
	          visibleRowIndices: visibleRowIndices
	        });
	
	        // update the indices
	        this._columnStartIndex = columnStartIndex;
	        this._columnStopIndex = columnStopIndex;
	        this._rowStartIndex = rowStartIndex;
	        this._rowStopIndex = rowStopIndex;
	      }
	    }
	
	    /**
	     * Sets an :isScrolling flag for a small window of time.
	     * This flag is used to disable pointer events on the scrollable portion of the Grid.
	     * This prevents jerky/stuttery mouse-wheel scrolling.
	     */
	
	  }, {
	    key: '_debounceScrollEnded',
	    value: function _debounceScrollEnded() {
	      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
	
	
	      if (this._disablePointerEventsTimeoutId) {
	        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
	      }
	
	      this._disablePointerEventsTimeoutId = (0, _requestAnimationTimeout.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
	    }
	  }, {
	    key: '_handleInvalidatedGridSize',
	
	
	    /**
	     * Check for batched CellMeasurer size invalidations.
	     * This will occur the first time one or more previously unmeasured cells are rendered.
	     */
	    value: function _handleInvalidatedGridSize() {
	      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
	        var columnIndex = this._deferredInvalidateColumnIndex;
	        var rowIndex = this._deferredInvalidateRowIndex;
	
	        this._deferredInvalidateColumnIndex = null;
	        this._deferredInvalidateRowIndex = null;
	
	        this.recomputeGridSize({ columnIndex: columnIndex, rowIndex: rowIndex });
	      }
	    }
	  }, {
	    key: '_invokeOnScrollMemoizer',
	    value: function _invokeOnScrollMemoizer(_ref6) {
	      var _this3 = this;
	
	      var scrollLeft = _ref6.scrollLeft,
	          scrollTop = _ref6.scrollTop,
	          totalColumnsWidth = _ref6.totalColumnsWidth,
	          totalRowsHeight = _ref6.totalRowsHeight;
	
	      this._onScrollMemoizer({
	        callback: function callback(_ref7) {
	          var scrollLeft = _ref7.scrollLeft,
	              scrollTop = _ref7.scrollTop;
	          var _props7 = _this3.props,
	              height = _props7.height,
	              onScroll = _props7.onScroll,
	              width = _props7.width;
	
	
	          onScroll({
	            clientHeight: height,
	            clientWidth: width,
	            scrollHeight: totalRowsHeight,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: totalColumnsWidth
	          });
	        },
	        indices: {
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        }
	      });
	    }
	  }, {
	    key: '_isScrolling',
	    value: function _isScrolling() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	
	      // If isScrolling is defined in props, use it to override the value in state
	      // This is a performance optimization for WindowScroller + Grid
	      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
	    }
	  }, {
	    key: '_maybeCallOnScrollbarPresenceChange',
	    value: function _maybeCallOnScrollbarPresenceChange() {
	      if (this._scrollbarPresenceChanged) {
	        var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
	
	
	        this._scrollbarPresenceChanged = false;
	
	        _onScrollbarPresenceChange({
	          horizontal: this._horizontalScrollBarSize > 0,
	          size: this.state.instanceProps.scrollbarSize,
	          vertical: this._verticalScrollBarSize > 0
	        });
	      }
	    }
	  }, {
	    key: 'scrollToPosition',
	
	
	    /**
	     * Scroll to the specified offset(s).
	     * Useful for animating position changes.
	     */
	    value: function scrollToPosition(_ref8) {
	      var scrollLeft = _ref8.scrollLeft,
	          scrollTop = _ref8.scrollTop;
	
	      this.setState(function (prevState) {
	        var stateUpdate = Grid._getScrollToPositionStateUpdate({
	          prevState: prevState,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        });
	
	        if (stateUpdate) {
	          stateUpdate.needToResetStyleCache = false;
	          return stateUpdate;
	        }
	        return null;
	      });
	    }
	  }, {
	    key: '_getCalculatedScrollLeft',
	    value: function _getCalculatedScrollLeft() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	
	      return Grid._getCalculatedScrollLeft(props, state);
	    }
	  }, {
	    key: '_updateScrollLeftForScrollToColumn',
	    value: function _updateScrollLeftForScrollToColumn() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	
	      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
	      if (stateUpdate) {
	        stateUpdate.needToResetStyleCache = false;
	      }
	      this.setState(stateUpdate);
	    }
	  }, {
	    key: '_getCalculatedScrollTop',
	    value: function _getCalculatedScrollTop() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	
	      return Grid._getCalculatedScrollTop(props, state);
	    }
	  }, {
	    key: '_resetStyleCache',
	    value: function _resetStyleCache() {
	      var styleCache = this._styleCache;
	
	      // Reset cell and style caches once scrolling stops.
	      // This makes Grid simpler to use (since cells commonly change).
	      // And it keeps the caches from growing too large.
	      // Performance is most sensitive when a user is scrolling.
	      this._cellCache = {};
	      this._styleCache = {};
	
	      // Copy over the visible cell styles so avoid unnecessary re-render.
	      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
	        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
	          var key = rowIndex + '-' + columnIndex;
	          this._styleCache[key] = styleCache[key];
	        }
	      }
	    }
	  }, {
	    key: '_updateScrollTopForScrollToRow',
	    value: function _updateScrollTopForScrollToRow() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	
	      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
	      if (stateUpdate) {
	        stateUpdate.needToResetStyleCache = false;
	      }
	      this.setState(stateUpdate);
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var newState = {};
	
	      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
	        newState.scrollLeft = 0;
	        newState.scrollTop = 0;
	      } else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
	        // this handles the weird edge case where setting scrollToColumn in
	        // multigrid was causing multiple getDerivedStateFromProps calls. Overriding
	        // the state set in the first time.
	        // We should warn since if scrollTo{column,row} and scroll{left,top} is specified,
	        // scrollTo{column,row} should override.
	        if (nextProps.scrollToColumn > 0 && prevState.scrollLeft && nextProps.scrollLeft === 0) {
	          //NOOP
	        } else if (nextProps.scrollToRow > 0 && prevState.scrollTop && nextProps.scrollTop === 0) {
	          //NOOP
	        } else {
	          (0, _assign2.default)(newState, Grid._getScrollToPositionStateUpdate({
	            prevState: prevState,
	            scrollLeft: nextProps.scrollLeft,
	            scrollTop: nextProps.scrollTop
	          }));
	        }
	      }
	
	      var instanceProps = prevState.instanceProps;
	
	      // Initially we should not clearStyleCache
	
	      newState.needToResetStyleCache = false;
	      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
	        // Reset cache. set it to {} in render
	        newState.needToResetStyleCache = true;
	      }
	
	      instanceProps.columnSizeAndPositionManager.configure({
	        cellCount: nextProps.columnCount,
	        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
	        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
	      });
	
	      instanceProps.rowSizeAndPositionManager.configure({
	        cellCount: nextProps.rowCount,
	        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
	        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
	      });
	
	      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
	        instanceProps.prevColumnCount = 0;
	        instanceProps.prevRowCount = 0;
	      }
	
	      // If scrolling is controlled outside this component, clear cache when scrolling stops
	      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
	        (0, _assign2.default)(newState, {
	          isScrolling: false
	        });
	      }
	
	      var maybeStateA = void 0;
	      var maybeStateB = void 0;
	
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
	        cellCount: instanceProps.prevColumnCount,
	        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return instanceProps.columnSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.columnCount,
	        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
	        nextScrollToIndex: nextProps.scrollToColumn,
	        scrollToIndex: instanceProps.prevScrollToColumn,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
	        }
	      });
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
	        cellCount: instanceProps.prevRowCount,
	        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return instanceProps.rowSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.rowCount,
	        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
	        nextScrollToIndex: nextProps.scrollToRow,
	        scrollToIndex: instanceProps.prevScrollToRow,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
	        }
	      });
	
	      instanceProps.prevColumnCount = nextProps.columnCount;
	      instanceProps.prevColumnWidth = nextProps.columnWidth;
	      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
	      instanceProps.prevRowCount = nextProps.rowCount;
	      instanceProps.prevRowHeight = nextProps.rowHeight;
	      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
	      instanceProps.prevScrollToRow = nextProps.scrollToRow;
	
	      // getting scrollBarSize (moved from componentWillMount)
	      instanceProps.scrollbarSize = nextProps.getScrollbarSize();
	      if (instanceProps.scrollbarSize === undefined) {
	        instanceProps.scrollbarSizeMeasured = false;
	        instanceProps.scrollbarSize = 0;
	      } else {
	        instanceProps.scrollbarSizeMeasured = true;
	      }
	
	      newState.instanceProps = instanceProps;
	
	      return (0, _extends3.default)({}, newState, maybeStateA, maybeStateB);
	    }
	  }, {
	    key: '_getEstimatedColumnSize',
	    value: function _getEstimatedColumnSize(props) {
	      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
	    }
	  }, {
	    key: '_getEstimatedRowSize',
	    value: function _getEstimatedRowSize(props) {
	      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
	    }
	  }, {
	    key: '_getScrollToPositionStateUpdate',
	
	
	    /**
	     * Get the updated state after scrolling to
	     * scrollLeft and scrollTop
	     */
	    value: function _getScrollToPositionStateUpdate(_ref9) {
	      var prevState = _ref9.prevState,
	          scrollLeft = _ref9.scrollLeft,
	          scrollTop = _ref9.scrollTop;
	
	      var newState = {
	        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
	      };
	
	      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
	        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
	        newState.scrollLeft = scrollLeft;
	      }
	
	      if (typeof scrollTop === 'number' && scrollTop >= 0) {
	        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
	        newState.scrollTop = scrollTop;
	      }
	
	      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
	        return newState;
	      }
	      return null;
	    }
	  }, {
	    key: '_wrapSizeGetter',
	    value: function _wrapSizeGetter(value) {
	      return typeof value === 'function' ? value : function () {
	        return value;
	      };
	    }
	  }, {
	    key: '_getCalculatedScrollLeft',
	    value: function _getCalculatedScrollLeft(nextProps, prevState) {
	      var columnCount = nextProps.columnCount,
	          height = nextProps.height,
	          scrollToAlignment = nextProps.scrollToAlignment,
	          scrollToColumn = nextProps.scrollToColumn,
	          width = nextProps.width;
	      var scrollLeft = prevState.scrollLeft,
	          instanceProps = prevState.instanceProps;
	
	
	      if (columnCount > 0) {
	        var finalColumn = columnCount - 1;
	        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
	        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
	        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
	
	        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: width - scrollBarSize,
	          currentOffset: scrollLeft,
	          targetIndex: targetIndex
	        });
	      }
	      return 0;
	    }
	  }, {
	    key: '_getScrollLeftForScrollToColumnStateUpdate',
	    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
	      var scrollLeft = prevState.scrollLeft;
	
	      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
	
	      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
	        return Grid._getScrollToPositionStateUpdate({
	          prevState: prevState,
	          scrollLeft: calculatedScrollLeft,
	          scrollTop: -1
	        });
	      }
	      return null;
	    }
	  }, {
	    key: '_getCalculatedScrollTop',
	    value: function _getCalculatedScrollTop(nextProps, prevState) {
	      var height = nextProps.height,
	          rowCount = nextProps.rowCount,
	          scrollToAlignment = nextProps.scrollToAlignment,
	          scrollToRow = nextProps.scrollToRow,
	          width = nextProps.width;
	      var scrollTop = prevState.scrollTop,
	          instanceProps = prevState.instanceProps;
	
	
	      if (rowCount > 0) {
	        var finalRow = rowCount - 1;
	        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
	        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
	        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
	
	        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: height - scrollBarSize,
	          currentOffset: scrollTop,
	          targetIndex: targetIndex
	        });
	      }
	      return 0;
	    }
	  }, {
	    key: '_getScrollTopForScrollToRowStateUpdate',
	    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
	      var scrollTop = prevState.scrollTop;
	
	      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
	
	      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
	        return Grid._getScrollToPositionStateUpdate({
	          prevState: prevState,
	          scrollLeft: -1,
	          scrollTop: calculatedScrollTop
	        });
	      }
	      return null;
	    }
	  }]);
	  return Grid;
	}(React.PureComponent);
	
	Grid.defaultProps = {
	  'aria-label': 'grid',
	  'aria-readonly': true,
	  autoContainerWidth: false,
	  autoHeight: false,
	  autoWidth: false,
	  cellRangeRenderer: _defaultCellRangeRenderer2.default,
	  containerRole: 'rowgroup',
	  containerStyle: {},
	  estimatedColumnSize: 100,
	  estimatedRowSize: 30,
	  getScrollbarSize: _scrollbarSize2.default,
	  noContentRenderer: renderNull,
	  onScroll: function onScroll() {},
	  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
	  onSectionRendered: function onSectionRendered() {},
	  overscanColumnCount: 0,
	  overscanIndicesGetter: _defaultOverscanIndicesGetter2.default,
	  overscanRowCount: 10,
	  role: 'grid',
	  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
	  scrollToAlignment: 'auto',
	  scrollToColumn: -1,
	  scrollToRow: -1,
	  style: {},
	  tabIndex: 0
	};
	Grid.propTypes =  true ? null : {
	  "aria-label": _propTypes2.default.string.isRequired,
	  "aria-readonly": _propTypes2.default.bool,
	
	
	  /**
	   * Set the width of the inner scrollable container to 'auto'.
	   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
	   */
	  autoContainerWidth: _propTypes2.default.bool.isRequired,
	
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
	   * Intended for use with WindowScroller
	   */
	  autoHeight: _propTypes2.default.bool.isRequired,
	
	
	  /**
	   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
	   * Intended for use with WindowScroller
	   */
	  autoWidth: _propTypes2.default.bool.isRequired,
	
	
	  /** Responsible for rendering a cell given an row and column index.  */
	  cellRenderer: function cellRenderer() {
	    return (typeof _types.bpfrpt_proptype_CellRenderer === 'function' ? _types.bpfrpt_proptype_CellRenderer.isRequired ? _types.bpfrpt_proptype_CellRenderer.isRequired : _types.bpfrpt_proptype_CellRenderer : _propTypes2.default.shape(_types.bpfrpt_proptype_CellRenderer).isRequired).apply(this, arguments);
	  },
	
	
	  /** Responsible for rendering a group of cells given their index ranges.  */
	  cellRangeRenderer: function cellRangeRenderer() {
	    return (typeof _types.bpfrpt_proptype_CellRangeRenderer === 'function' ? _types.bpfrpt_proptype_CellRangeRenderer.isRequired ? _types.bpfrpt_proptype_CellRangeRenderer.isRequired : _types.bpfrpt_proptype_CellRangeRenderer : _propTypes2.default.shape(_types.bpfrpt_proptype_CellRangeRenderer).isRequired).apply(this, arguments);
	  },
	
	
	  /** Optional custom CSS class name to attach to root Grid element.  */
	  className: _propTypes2.default.string,
	
	
	  /** Number of columns in grid.  */
	  columnCount: _propTypes2.default.number.isRequired,
	
	
	  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
	  columnWidth: function columnWidth() {
	    return (typeof _types.bpfrpt_proptype_CellSize === 'function' ? _types.bpfrpt_proptype_CellSize.isRequired ? _types.bpfrpt_proptype_CellSize.isRequired : _types.bpfrpt_proptype_CellSize : _propTypes2.default.shape(_types.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
	  },
	
	
	  /** Unfiltered props for the Grid container. */
	  containerProps: _propTypes2.default.object,
	
	
	  /** ARIA role for the cell-container.  */
	  containerRole: _propTypes2.default.string.isRequired,
	
	
	  /** Optional inline style applied to inner cell-container */
	  containerStyle: _propTypes2.default.object.isRequired,
	
	
	  /**
	   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
	   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
	   */
	  deferredMeasurementCache: _propTypes2.default.object,
	
	
	  /**
	   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
	   * The estimated total width is adjusted as columns are rendered.
	   */
	  estimatedColumnSize: _propTypes2.default.number.isRequired,
	
	
	  /**
	   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _propTypes2.default.number.isRequired,
	
	
	  /** Exposed for testing purposes only.  */
	  getScrollbarSize: _propTypes2.default.func.isRequired,
	
	
	  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
	  height: _propTypes2.default.number.isRequired,
	
	
	  /** Optional custom id to attach to root Grid element.  */
	  id: _propTypes2.default.string,
	
	
	  /**
	   * Override internal is-scrolling state tracking.
	   * This property is primarily intended for use with the WindowScroller component.
	   */
	  isScrolling: _propTypes2.default.bool,
	
	
	  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
	  noContentRenderer: function noContentRenderer() {
	    return (typeof _types.bpfrpt_proptype_NoContentRenderer === 'function' ? _types.bpfrpt_proptype_NoContentRenderer.isRequired ? _types.bpfrpt_proptype_NoContentRenderer.isRequired : _types.bpfrpt_proptype_NoContentRenderer : _propTypes2.default.shape(_types.bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
	  },
	
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   */
	  onScroll: _propTypes2.default.func.isRequired,
	
	
	  /**
	   * Called whenever a horizontal or vertical scrollbar is added or removed.
	   * This prop is not intended for end-user use;
	   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
	   */
	  onScrollbarPresenceChange: _propTypes2.default.func.isRequired,
	
	
	  /** Callback invoked with information about the section of the Grid that was just rendered.  */
	  onSectionRendered: _propTypes2.default.func.isRequired,
	
	
	  /**
	   * Number of columns to render before/after the visible section of the grid.
	   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  overscanColumnCount: _propTypes2.default.number.isRequired,
	
	
	  /**
	   * Calculates the number of cells to overscan before and after a specified range.
	   * This function ensures that overscanning doesn't exceed the available cells.
	   */
	  overscanIndicesGetter: function overscanIndicesGetter() {
	    return (typeof _types.bpfrpt_proptype_OverscanIndicesGetter === 'function' ? _types.bpfrpt_proptype_OverscanIndicesGetter.isRequired ? _types.bpfrpt_proptype_OverscanIndicesGetter.isRequired : _types.bpfrpt_proptype_OverscanIndicesGetter : _propTypes2.default.shape(_types.bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
	  },
	
	
	  /**
	   * Number of rows to render above/below the visible section of the grid.
	   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  overscanRowCount: _propTypes2.default.number.isRequired,
	
	
	  /** ARIA role for the grid element.  */
	  role: _propTypes2.default.string.isRequired,
	
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * Should implement the following interface: ({ index: number }): number
	   */
	  rowHeight: function rowHeight() {
	    return (typeof _types.bpfrpt_proptype_CellSize === 'function' ? _types.bpfrpt_proptype_CellSize.isRequired ? _types.bpfrpt_proptype_CellSize.isRequired : _types.bpfrpt_proptype_CellSize : _propTypes2.default.shape(_types.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
	  },
	
	
	  /** Number of rows in grid.  */
	  rowCount: _propTypes2.default.number.isRequired,
	
	
	  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
	  scrollingResetTimeInterval: _propTypes2.default.number.isRequired,
	
	
	  /** Horizontal offset. */
	  scrollLeft: _propTypes2.default.number,
	
	
	  /**
	   * Controls scroll-to-cell behavior of the Grid.
	   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
	   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
	   */
	  scrollToAlignment: function scrollToAlignment() {
	    return (typeof _types.bpfrpt_proptype_Alignment === 'function' ? _types.bpfrpt_proptype_Alignment.isRequired ? _types.bpfrpt_proptype_Alignment.isRequired : _types.bpfrpt_proptype_Alignment : _propTypes2.default.shape(_types.bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
	  },
	
	
	  /** Column index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToColumn: _propTypes2.default.number.isRequired,
	
	
	  /** Vertical offset. */
	  scrollTop: _propTypes2.default.number,
	
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToRow: _propTypes2.default.number.isRequired,
	
	
	  /** Optional inline style */
	  style: _propTypes2.default.object.isRequired,
	
	
	  /** Tab index for focus */
	  tabIndex: _propTypes2.default.number,
	
	
	  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
	  width: _propTypes2.default.number.isRequired
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Grid);
	exports.default = Grid;

/***/ }),

/***/ 1146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_BACKWARD = undefined;
	exports.default = defaultOverscanIndicesGetter;
	
	var _types = __webpack_require__(82);
	
	var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;
	
	var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;
	
	var SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
	var SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
	
	/**
	 * Calculates the number of cells to overscan before and after a specified range.
	 * This function ensures that overscanning doesn't exceed the available cells.
	 */
	
	function defaultOverscanIndicesGetter(_ref) {
	  var cellCount = _ref.cellCount,
	      overscanCellsCount = _ref.overscanCellsCount,
	      scrollDirection = _ref.scrollDirection,
	      startIndex = _ref.startIndex,
	      stopIndex = _ref.stopIndex;
	
	  // Make sure we render at least 1 cell extra before and after (except near boundaries)
	  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
	  // For more info see issues #625
	  overscanCellsCount = Math.max(1, overscanCellsCount);
	
	  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
	    return {
	      overscanStartIndex: Math.max(0, startIndex - 1),
	      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
	    };
	  } else {
	    return {
	      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
	      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
	    };
	  }
	}

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellRangeRenderer;
	
	var _types = __webpack_require__(82);
	
	/**
	 * Default implementation of cellRangeRenderer used by Grid.
	 * This renderer supports cell-caching while the user is scrolling.
	 */
	
	function defaultCellRangeRenderer(_ref) {
	  var cellCache = _ref.cellCache,
	      cellRenderer = _ref.cellRenderer,
	      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
	      columnStartIndex = _ref.columnStartIndex,
	      columnStopIndex = _ref.columnStopIndex,
	      deferredMeasurementCache = _ref.deferredMeasurementCache,
	      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
	      isScrolling = _ref.isScrolling,
	      parent = _ref.parent,
	      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
	      rowStartIndex = _ref.rowStartIndex,
	      rowStopIndex = _ref.rowStopIndex,
	      styleCache = _ref.styleCache,
	      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
	      visibleColumnIndices = _ref.visibleColumnIndices,
	      visibleRowIndices = _ref.visibleRowIndices;
	
	  var renderedCells = [];
	
	  // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
	  // User cannot scroll beyond these size limitations.
	  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
	  // We should never cache styles for compressed offsets though as this can lead to bugs.
	  // See issue #576 for more.
	  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
	
	  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
	
	  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
	    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
	
	    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
	      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
	      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
	      var key = rowIndex + '-' + columnIndex;
	      var style = void 0;
	
	      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
	      if (canCacheStyle && styleCache[key]) {
	        style = styleCache[key];
	      } else {
	        // In deferred mode, cells will be initially rendered before we know their size.
	        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
	        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
	          // Position not-yet-measured cells at top/left 0,0,
	          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
	          // Positioning them further to the right/bottom influences their measured size.
	          style = {
	            height: 'auto',
	            left: 0,
	            position: 'absolute',
	            top: 0,
	            width: 'auto'
	          };
	        } else {
	          style = {
	            height: rowDatum.size,
	            left: columnDatum.offset + horizontalOffsetAdjustment,
	            position: 'absolute',
	            top: rowDatum.offset + verticalOffsetAdjustment,
	            width: columnDatum.size
	          };
	
	          styleCache[key] = style;
	        }
	      }
	
	      var cellRendererParams = {
	        columnIndex: columnIndex,
	        isScrolling: isScrolling,
	        isVisible: isVisible,
	        key: key,
	        parent: parent,
	        rowIndex: rowIndex,
	        style: style
	      };
	
	      var renderedCell = void 0;
	
	      // Avoid re-creating cells while scrolling.
	      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
	      // If a scroll is in progress- cache and reuse cells.
	      // This cache will be thrown away once scrolling completes.
	      // However if we are scaling scroll positions and sizes, we should also avoid caching.
	      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
	      // For more info refer to issue #395
	      if (isScrolling && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
	        if (!cellCache[key]) {
	          cellCache[key] = cellRenderer(cellRendererParams);
	        }
	
	        renderedCell = cellCache[key];
	
	        // If the user is no longer scrolling, don't cache cells.
	        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
	      } else {
	        renderedCell = cellRenderer(cellRendererParams);
	      }
	
	      if (renderedCell == null || renderedCell === false) {
	        continue;
	      }
	
	      if (false) {
	        warnAboutMissingStyle(parent, renderedCell);
	      }
	
	      renderedCells.push(renderedCell);
	    }
	  }
	
	  return renderedCells;
	}
	
	function warnAboutMissingStyle(parent, renderedCell) {
	  if (false) {
	    if (renderedCell) {
	      // If the direct child is a CellMeasurer, then we should check its child
	      // See issue #611
	      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
	        renderedCell = renderedCell.props.children;
	      }
	
	      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
	        parent.__warnedAboutMissingStyle = true;
	
	        console.warn('Rendered cell should include style property for positioning.');
	      }
	    }
	  }
	}

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_BACKWARD = undefined;
	exports.default = defaultOverscanIndicesGetter;
	
	var _types = __webpack_require__(82);
	
	var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;
	
	var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;
	
	var SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
	var SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
	
	/**
	 * Calculates the number of cells to overscan before and after a specified range.
	 * This function ensures that overscanning doesn't exceed the available cells.
	 */
	
	function defaultOverscanIndicesGetter(_ref) {
	  var cellCount = _ref.cellCount,
	      overscanCellsCount = _ref.overscanCellsCount,
	      scrollDirection = _ref.scrollDirection,
	      startIndex = _ref.startIndex,
	      stopIndex = _ref.stopIndex;
	
	  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
	    return {
	      overscanStartIndex: Math.max(0, startIndex),
	      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
	    };
	  } else {
	    return {
	      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
	      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
	    };
	  }
	}

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bpfrpt_proptype_Scroll = exports.bpfrpt_proptype_CellRendererParams = exports.bpfrpt_proptype_RenderedSection = exports.bpfrpt_proptype_OverscanIndicesGetter = exports.bpfrpt_proptype_CellSize = exports.bpfrpt_proptype_CellPosition = exports.bpfrpt_proptype_Alignment = exports.bpfrpt_proptype_NoContentRenderer = exports.defaultOverscanIndicesGetter = exports.defaultCellRangeRenderer = exports.accessibilityOverscanIndicesGetter = exports.Grid = exports.default = undefined;
	
	var _Grid = __webpack_require__(1145);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grid).default;
	  }
	});
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grid).default;
	  }
	});
	
	var _accessibilityOverscanIndicesGetter = __webpack_require__(1146);
	
	Object.defineProperty(exports, 'accessibilityOverscanIndicesGetter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_accessibilityOverscanIndicesGetter).default;
	  }
	});
	
	var _defaultCellRangeRenderer = __webpack_require__(480);
	
	Object.defineProperty(exports, 'defaultCellRangeRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultCellRangeRenderer).default;
	  }
	});
	
	var _defaultOverscanIndicesGetter = __webpack_require__(481);
	
	Object.defineProperty(exports, 'defaultOverscanIndicesGetter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultOverscanIndicesGetter).default;
	  }
	});
	
	var _types = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.bpfrpt_proptype_NoContentRenderer = _types.bpfrpt_proptype_NoContentRenderer;
	exports.bpfrpt_proptype_Alignment = _types.bpfrpt_proptype_Alignment;
	exports.bpfrpt_proptype_CellPosition = _types.bpfrpt_proptype_CellPosition;
	exports.bpfrpt_proptype_CellSize = _types.bpfrpt_proptype_CellSize;
	exports.bpfrpt_proptype_OverscanIndicesGetter = _types.bpfrpt_proptype_OverscanIndicesGetter;
	exports.bpfrpt_proptype_RenderedSection = _types.bpfrpt_proptype_RenderedSection;
	exports.bpfrpt_proptype_CellRendererParams = _types.bpfrpt_proptype_CellRendererParams;
	exports.bpfrpt_proptype_Scroll = _types.bpfrpt_proptype_Scroll;

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bpfrpt_proptype_VisibleCellRange = exports.bpfrpt_proptype_Alignment = exports.bpfrpt_proptype_OverscanIndicesGetter = exports.bpfrpt_proptype_OverscanIndices = exports.bpfrpt_proptype_OverscanIndicesGetterParams = exports.bpfrpt_proptype_RenderedSection = exports.bpfrpt_proptype_ScrollbarPresenceChange = exports.bpfrpt_proptype_Scroll = exports.bpfrpt_proptype_NoContentRenderer = exports.bpfrpt_proptype_CellSize = exports.bpfrpt_proptype_CellSizeGetter = exports.bpfrpt_proptype_CellRangeRenderer = exports.bpfrpt_proptype_CellRangeRendererParams = exports.bpfrpt_proptype_StyleCache = exports.bpfrpt_proptype_CellCache = exports.bpfrpt_proptype_CellRenderer = exports.bpfrpt_proptype_CellRendererParams = exports.bpfrpt_proptype_CellPosition = undefined;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _ScalingCellSizeAndPositionManager = __webpack_require__(323);
	
	var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var bpfrpt_proptype_CellPosition =  true ? null : {
	  columnIndex: _propTypes2.default.number.isRequired,
	  rowIndex: _propTypes2.default.number.isRequired
	};
	var bpfrpt_proptype_CellRendererParams =  true ? null : {
	  columnIndex: _propTypes2.default.number.isRequired,
	  isScrolling: _propTypes2.default.bool.isRequired,
	  isVisible: _propTypes2.default.bool.isRequired,
	  key: _propTypes2.default.string.isRequired,
	  parent: _propTypes2.default.object.isRequired,
	  rowIndex: _propTypes2.default.number.isRequired,
	  style: _propTypes2.default.object.isRequired
	};
	var bpfrpt_proptype_CellRenderer =  true ? null : _propTypes2.default.func;
	var bpfrpt_proptype_CellCache =  true ? null : _propTypes2.default.objectOf(_propTypes2.default.node.isRequired);
	var bpfrpt_proptype_StyleCache =  true ? null : _propTypes2.default.objectOf(_propTypes2.default.object.isRequired);
	var bpfrpt_proptype_CellRangeRendererParams =  true ? null : {
	  cellCache: _propTypes2.default.objectOf(_propTypes2.default.node.isRequired).isRequired,
	  cellRenderer: _propTypes2.default.func.isRequired,
	  columnSizeAndPositionManager: function columnSizeAndPositionManager() {
	    return (typeof _ScalingCellSizeAndPositionManager2.default === 'function' ? _propTypes2.default.instanceOf(_ScalingCellSizeAndPositionManager2.default).isRequired : _propTypes2.default.any.isRequired).apply(this, arguments);
	  },
	  columnStartIndex: _propTypes2.default.number.isRequired,
	  columnStopIndex: _propTypes2.default.number.isRequired,
	  deferredMeasurementCache: _propTypes2.default.object,
	  horizontalOffsetAdjustment: _propTypes2.default.number.isRequired,
	  isScrolling: _propTypes2.default.bool.isRequired,
	  parent: _propTypes2.default.object.isRequired,
	  rowSizeAndPositionManager: function rowSizeAndPositionManager() {
	    return (typeof _ScalingCellSizeAndPositionManager2.default === 'function' ? _propTypes2.default.instanceOf(_ScalingCellSizeAndPositionManager2.default).isRequired : _propTypes2.default.any.isRequired).apply(this, arguments);
	  },
	  rowStartIndex: _propTypes2.default.number.isRequired,
	  rowStopIndex: _propTypes2.default.number.isRequired,
	  scrollLeft: _propTypes2.default.number.isRequired,
	  scrollTop: _propTypes2.default.number.isRequired,
	  styleCache: _propTypes2.default.objectOf(_propTypes2.default.object.isRequired).isRequired,
	  verticalOffsetAdjustment: _propTypes2.default.number.isRequired,
	  visibleColumnIndices: _propTypes2.default.object.isRequired,
	  visibleRowIndices: _propTypes2.default.object.isRequired
	};
	var bpfrpt_proptype_CellRangeRenderer =  true ? null : _propTypes2.default.func;
	var bpfrpt_proptype_CellSizeGetter =  true ? null : _propTypes2.default.func;
	var bpfrpt_proptype_CellSize =  true ? null : _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.number]);
	var bpfrpt_proptype_NoContentRenderer =  true ? null : _propTypes2.default.func;
	var bpfrpt_proptype_Scroll =  true ? null : {
	  clientHeight: _propTypes2.default.number.isRequired,
	  clientWidth: _propTypes2.default.number.isRequired,
	  scrollHeight: _propTypes2.default.number.isRequired,
	  scrollLeft: _propTypes2.default.number.isRequired,
	  scrollTop: _propTypes2.default.number.isRequired,
	  scrollWidth: _propTypes2.default.number.isRequired
	};
	var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : {
	  horizontal: _propTypes2.default.bool.isRequired,
	  vertical: _propTypes2.default.bool.isRequired,
	  size: _propTypes2.default.number.isRequired
	};
	var bpfrpt_proptype_RenderedSection =  true ? null : {
	  columnOverscanStartIndex: _propTypes2.default.number.isRequired,
	  columnOverscanStopIndex: _propTypes2.default.number.isRequired,
	  columnStartIndex: _propTypes2.default.number.isRequired,
	  columnStopIndex: _propTypes2.default.number.isRequired,
	  rowOverscanStartIndex: _propTypes2.default.number.isRequired,
	  rowOverscanStopIndex: _propTypes2.default.number.isRequired,
	  rowStartIndex: _propTypes2.default.number.isRequired,
	  rowStopIndex: _propTypes2.default.number.isRequired
	};
	var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : {
	  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
	  direction: _propTypes2.default.oneOf(['horizontal', 'vertical']).isRequired,
	
	
	  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
	  scrollDirection: _propTypes2.default.oneOf([-1, 1]).isRequired,
	
	
	  // Number of rows or columns in the current axis
	  cellCount: _propTypes2.default.number.isRequired,
	
	
	  // Maximum number of cells to over-render in either direction
	  overscanCellsCount: _propTypes2.default.number.isRequired,
	
	
	  // Begin of range of visible cells
	  startIndex: _propTypes2.default.number.isRequired,
	
	
	  // End of range of visible cells
	  stopIndex: _propTypes2.default.number.isRequired
	};
	var bpfrpt_proptype_OverscanIndices =  true ? null : {
	  overscanStartIndex: _propTypes2.default.number.isRequired,
	  overscanStopIndex: _propTypes2.default.number.isRequired
	};
	var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : _propTypes2.default.func;
	var bpfrpt_proptype_Alignment =  true ? null : _propTypes2.default.oneOf(['auto', 'end', 'start', 'center']);
	var bpfrpt_proptype_VisibleCellRange =  true ? null : {
	  start: _propTypes2.default.number,
	  stop: _propTypes2.default.number
	};
	exports.bpfrpt_proptype_CellPosition = bpfrpt_proptype_CellPosition;
	exports.bpfrpt_proptype_CellRendererParams = bpfrpt_proptype_CellRendererParams;
	exports.bpfrpt_proptype_CellRenderer = bpfrpt_proptype_CellRenderer;
	exports.bpfrpt_proptype_CellCache = bpfrpt_proptype_CellCache;
	exports.bpfrpt_proptype_StyleCache = bpfrpt_proptype_StyleCache;
	exports.bpfrpt_proptype_CellRangeRendererParams = bpfrpt_proptype_CellRangeRendererParams;
	exports.bpfrpt_proptype_CellRangeRenderer = bpfrpt_proptype_CellRangeRenderer;
	exports.bpfrpt_proptype_CellSizeGetter = bpfrpt_proptype_CellSizeGetter;
	exports.bpfrpt_proptype_CellSize = bpfrpt_proptype_CellSize;
	exports.bpfrpt_proptype_NoContentRenderer = bpfrpt_proptype_NoContentRenderer;
	exports.bpfrpt_proptype_Scroll = bpfrpt_proptype_Scroll;
	exports.bpfrpt_proptype_ScrollbarPresenceChange = bpfrpt_proptype_ScrollbarPresenceChange;
	exports.bpfrpt_proptype_RenderedSection = bpfrpt_proptype_RenderedSection;
	exports.bpfrpt_proptype_OverscanIndicesGetterParams = bpfrpt_proptype_OverscanIndicesGetterParams;
	exports.bpfrpt_proptype_OverscanIndices = bpfrpt_proptype_OverscanIndices;
	exports.bpfrpt_proptype_OverscanIndicesGetter = bpfrpt_proptype_OverscanIndicesGetter;
	exports.bpfrpt_proptype_Alignment = bpfrpt_proptype_Alignment;
	exports.bpfrpt_proptype_VisibleCellRange = bpfrpt_proptype_VisibleCellRange;

/***/ }),

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _types = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Just-in-time calculates and caches size and position information for a collection of cells.
	 */
	
	var CellSizeAndPositionManager = function () {
	
	  // Used in deferred mode to track which cells have been queued for measurement.
	
	  // Cache of size and position data for cells, mapped by cell index.
	  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
	  function CellSizeAndPositionManager(_ref) {
	    var cellCount = _ref.cellCount,
	        cellSizeGetter = _ref.cellSizeGetter,
	        estimatedCellSize = _ref.estimatedCellSize;
	    (0, _classCallCheck3.default)(this, CellSizeAndPositionManager);
	    this._cellSizeAndPositionData = {};
	    this._lastMeasuredIndex = -1;
	    this._lastBatchedIndex = -1;
	
	    this._cellSizeGetter = cellSizeGetter;
	    this._cellCount = cellCount;
	    this._estimatedCellSize = estimatedCellSize;
	  }
	
	  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
	
	
	  (0, _createClass3.default)(CellSizeAndPositionManager, [{
	    key: 'areOffsetsAdjusted',
	    value: function areOffsetsAdjusted() {
	      return false;
	    }
	  }, {
	    key: 'configure',
	    value: function configure(_ref2) {
	      var cellCount = _ref2.cellCount,
	          estimatedCellSize = _ref2.estimatedCellSize,
	          cellSizeGetter = _ref2.cellSizeGetter;
	
	      this._cellCount = cellCount;
	      this._estimatedCellSize = estimatedCellSize;
	      this._cellSizeGetter = cellSizeGetter;
	    }
	  }, {
	    key: 'getCellCount',
	    value: function getCellCount() {
	      return this._cellCount;
	    }
	  }, {
	    key: 'getEstimatedCellSize',
	    value: function getEstimatedCellSize() {
	      return this._estimatedCellSize;
	    }
	  }, {
	    key: 'getLastMeasuredIndex',
	    value: function getLastMeasuredIndex() {
	      return this._lastMeasuredIndex;
	    }
	  }, {
	    key: 'getOffsetAdjustment',
	    value: function getOffsetAdjustment() {
	      return 0;
	    }
	
	    /**
	     * This method returns the size and position for the cell at the specified index.
	     * It just-in-time calculates (or used cached values) for cells leading up to the index.
	     */
	
	  }, {
	    key: 'getSizeAndPositionOfCell',
	    value: function getSizeAndPositionOfCell(index) {
	      if (index < 0 || index >= this._cellCount) {
	        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
	      }
	
	      if (index > this._lastMeasuredIndex) {
	        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
	
	        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
	          var _size = this._cellSizeGetter({ index: i });
	
	          // undefined or NaN probably means a logic error in the size getter.
	          // null means we're using CellMeasurer and haven't yet measured a given index.
	          if (_size === undefined || isNaN(_size)) {
	            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
	          } else if (_size === null) {
	            this._cellSizeAndPositionData[i] = {
	              offset: _offset,
	              size: 0
	            };
	
	            this._lastBatchedIndex = index;
	          } else {
	            this._cellSizeAndPositionData[i] = {
	              offset: _offset,
	              size: _size
	            };
	
	            _offset += _size;
	
	            this._lastMeasuredIndex = index;
	          }
	        }
	      }
	
	      return this._cellSizeAndPositionData[index];
	    }
	  }, {
	    key: 'getSizeAndPositionOfLastMeasuredCell',
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
	        offset: 0,
	        size: 0
	      };
	    }
	
	    /**
	     * Total size of all cells being measured.
	     * This value will be completely estimated initially.
	     * As cells are measured, the estimate will be updated.
	     */
	
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
	      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
	      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
	      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
	    }
	
	    /**
	     * Determines a new offset that ensures a certain cell is visible, given the current offset.
	     * If the cell is already visible then the current offset will be returned.
	     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
	     *
	     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
	     * @param containerSize Size (width or height) of the container viewport
	     * @param currentOffset Container's current (x or y) offset
	     * @param totalSize Total size (width or height) of all cells
	     * @return Offset to use to ensure the specified cell is visible
	     */
	
	  }, {
	    key: 'getUpdatedOffsetForIndex',
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align,
	          align = _ref3$align === undefined ? 'auto' : _ref3$align,
	          containerSize = _ref3.containerSize,
	          currentOffset = _ref3.currentOffset,
	          targetIndex = _ref3.targetIndex;
	
	      if (containerSize <= 0) {
	        return 0;
	      }
	
	      var datum = this.getSizeAndPositionOfCell(targetIndex);
	      var maxOffset = datum.offset;
	      var minOffset = maxOffset - containerSize + datum.size;
	
	      var idealOffset = void 0;
	
	      switch (align) {
	        case 'start':
	          idealOffset = maxOffset;
	          break;
	        case 'end':
	          idealOffset = minOffset;
	          break;
	        case 'center':
	          idealOffset = maxOffset - (containerSize - datum.size) / 2;
	          break;
	        default:
	          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
	          break;
	      }
	
	      var totalSize = this.getTotalSize();
	
	      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
	    }
	  }, {
	    key: 'getVisibleCellRange',
	    value: function getVisibleCellRange(params) {
	      var containerSize = params.containerSize,
	          offset = params.offset;
	
	
	      var totalSize = this.getTotalSize();
	
	      if (totalSize === 0) {
	        return {};
	      }
	
	      var maxOffset = offset + containerSize;
	      var start = this._findNearestCell(offset);
	
	      var datum = this.getSizeAndPositionOfCell(start);
	      offset = datum.offset + datum.size;
	
	      var stop = start;
	
	      while (offset < maxOffset && stop < this._cellCount - 1) {
	        stop++;
	
	        offset += this.getSizeAndPositionOfCell(stop).size;
	      }
	
	      return {
	        start: start,
	        stop: stop
	      };
	    }
	
	    /**
	     * Clear all cached values for cells after the specified index.
	     * This method should be called for any cell that has changed its size.
	     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
	     */
	
	  }, {
	    key: 'resetCell',
	    value: function resetCell(index) {
	      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
	    }
	  }, {
	    key: '_binarySearch',
	    value: function _binarySearch(high, low, offset) {
	      while (low <= high) {
	        var middle = low + Math.floor((high - low) / 2);
	        var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;
	
	        if (_currentOffset === offset) {
	          return middle;
	        } else if (_currentOffset < offset) {
	          low = middle + 1;
	        } else if (_currentOffset > offset) {
	          high = middle - 1;
	        }
	      }
	
	      if (low > 0) {
	        return low - 1;
	      } else {
	        return 0;
	      }
	    }
	  }, {
	    key: '_exponentialSearch',
	    value: function _exponentialSearch(index, offset) {
	      var interval = 1;
	
	      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
	        index += interval;
	        interval *= 2;
	      }
	
	      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
	    }
	
	    /**
	     * Searches for the cell (index) nearest the specified offset.
	     *
	     * If no exact match is found the next lowest cell index will be returned.
	     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
	     */
	
	  }, {
	    key: '_findNearestCell',
	    value: function _findNearestCell(offset) {
	      if (isNaN(offset)) {
	        throw Error('Invalid offset ' + offset + ' specified');
	      }
	
	      // Our search algorithms find the nearest match at or below the specified offset.
	      // So make sure the offset is at least 0 or no match will be found.
	      offset = Math.max(0, offset);
	
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
	
	      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
	        // If we've already measured cells within this range just use a binary search as it's faster.
	        return this._binarySearch(lastMeasuredIndex, 0, offset);
	      } else {
	        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
	        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
	        // The overall complexity for this approach is O(log n).
	        return this._exponentialSearch(lastMeasuredIndex, offset);
	      }
	    }
	  }]);
	  return CellSizeAndPositionManager;
	}();
	
	exports.default = CellSizeAndPositionManager;

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(49);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _CellSizeAndPositionManager = __webpack_require__(1147);
	
	var _CellSizeAndPositionManager2 = _interopRequireDefault(_CellSizeAndPositionManager);
	
	var _maxElementSize = __webpack_require__(1149);
	
	var _types = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
	 */
	
	
	/**
	 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
	 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
	 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
	 */
	
	var ScalingCellSizeAndPositionManager = function () {
	  function ScalingCellSizeAndPositionManager(_ref) {
	    var _ref$maxScrollSize = _ref.maxScrollSize,
	        maxScrollSize = _ref$maxScrollSize === undefined ? (0, _maxElementSize.getMaxElementSize)() : _ref$maxScrollSize,
	        params = (0, _objectWithoutProperties3.default)(_ref, ['maxScrollSize']);
	    (0, _classCallCheck3.default)(this, ScalingCellSizeAndPositionManager);
	
	    // Favor composition over inheritance to simplify IE10 support
	    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager2.default(params);
	    this._maxScrollSize = maxScrollSize;
	  }
	
	  (0, _createClass3.default)(ScalingCellSizeAndPositionManager, [{
	    key: 'areOffsetsAdjusted',
	    value: function areOffsetsAdjusted() {
	      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
	    }
	  }, {
	    key: 'configure',
	    value: function configure(params) {
	      this._cellSizeAndPositionManager.configure(params);
	    }
	  }, {
	    key: 'getCellCount',
	    value: function getCellCount() {
	      return this._cellSizeAndPositionManager.getCellCount();
	    }
	  }, {
	    key: 'getEstimatedCellSize',
	    value: function getEstimatedCellSize() {
	      return this._cellSizeAndPositionManager.getEstimatedCellSize();
	    }
	  }, {
	    key: 'getLastMeasuredIndex',
	    value: function getLastMeasuredIndex() {
	      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
	    }
	
	    /**
	     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
	     * The offset passed to this function is scaled (safe) as well.
	     */
	
	  }, {
	    key: 'getOffsetAdjustment',
	    value: function getOffsetAdjustment(_ref2) {
	      var containerSize = _ref2.containerSize,
	          offset = _ref2.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	      var offsetPercentage = this._getOffsetPercentage({
	        containerSize: containerSize,
	        offset: offset,
	        totalSize: safeTotalSize
	      });
	
	      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
	    }
	  }, {
	    key: 'getSizeAndPositionOfCell',
	    value: function getSizeAndPositionOfCell(index) {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
	    }
	  }, {
	    key: 'getSizeAndPositionOfLastMeasuredCell',
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
	    }
	
	    /** See CellSizeAndPositionManager#getTotalSize */
	
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
	    }
	
	    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
	
	  }, {
	    key: 'getUpdatedOffsetForIndex',
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align,
	          align = _ref3$align === undefined ? 'auto' : _ref3$align,
	          containerSize = _ref3.containerSize,
	          currentOffset = _ref3.currentOffset,
	          targetIndex = _ref3.targetIndex;
	
	      currentOffset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: currentOffset
	      });
	
	      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
	        align: align,
	        containerSize: containerSize,
	        currentOffset: currentOffset,
	        targetIndex: targetIndex
	      });
	
	      return this._offsetToSafeOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	
	    /** See CellSizeAndPositionManager#getVisibleCellRange */
	
	  }, {
	    key: 'getVisibleCellRange',
	    value: function getVisibleCellRange(_ref4) {
	      var containerSize = _ref4.containerSize,
	          offset = _ref4.offset;
	
	      offset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	
	      return this._cellSizeAndPositionManager.getVisibleCellRange({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	  }, {
	    key: 'resetCell',
	    value: function resetCell(index) {
	      this._cellSizeAndPositionManager.resetCell(index);
	    }
	  }, {
	    key: '_getOffsetPercentage',
	    value: function _getOffsetPercentage(_ref5) {
	      var containerSize = _ref5.containerSize,
	          offset = _ref5.offset,
	          totalSize = _ref5.totalSize;
	
	      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
	    }
	  }, {
	    key: '_offsetToSafeOffset',
	    value: function _offsetToSafeOffset(_ref6) {
	      var containerSize = _ref6.containerSize,
	          offset = _ref6.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: totalSize
	        });
	
	        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
	      }
	    }
	  }, {
	    key: '_safeOffsetToOffset',
	    value: function _safeOffsetToOffset(_ref7) {
	      var containerSize = _ref7.containerSize,
	          offset = _ref7.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: safeTotalSize
	        });
	
	        return Math.round(offsetPercentage * (totalSize - containerSize));
	      }
	    }
	  }]);
	  return ScalingCellSizeAndPositionManager;
	}();
	
	exports.default = ScalingCellSizeAndPositionManager;

/***/ }),

/***/ 1148:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateSizeAndPositionDataAndUpdateScrollOffset;
	function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
	  var cellCount = _ref.cellCount,
	      cellSize = _ref.cellSize,
	      computeMetadataCallback = _ref.computeMetadataCallback,
	      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
	      nextCellsCount = _ref.nextCellsCount,
	      nextCellSize = _ref.nextCellSize,
	      nextScrollToIndex = _ref.nextScrollToIndex,
	      scrollToIndex = _ref.scrollToIndex,
	      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
	
	  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
	  // In that event users should use the manual recompute methods to inform of changes.
	  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
	    computeMetadataCallback(computeMetadataCallbackProps);
	
	    // Updated cell metadata may have hidden the previous scrolled-to item.
	    // In this case we should also update the scrollTop to ensure it stays visible.
	    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
	      updateScrollOffsetForScrollToIndex();
	    }
	  }
	}
	
	/**
	 * Helper method that determines when to recalculate row or column metadata.
	 */

/***/ }),

/***/ 1149:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
	var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
	
	var isBrowser = function isBrowser() {
	  return typeof window !== 'undefined';
	};
	
	var isChrome = function isChrome() {
	  return !!window.chrome && !!window.chrome.webstore;
	};
	
	var getMaxElementSize = exports.getMaxElementSize = function getMaxElementSize() {
	  if (isBrowser()) {
	    if (isChrome()) {
	      return CHROME_MAX_ELEMENT_SIZE;
	    }
	  }
	  return DEFAULT_MAX_ELEMENT_SIZE;
	};

/***/ }),

/***/ 1150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateScrollIndexHelper;
	
	var _ScalingCellSizeAndPositionManager = __webpack_require__(323);
	
	var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);
	
	var _types = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
	 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
	 */
	
	function updateScrollIndexHelper(_ref) {
	  var cellSize = _ref.cellSize,
	      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
	      previousCellsCount = _ref.previousCellsCount,
	      previousCellSize = _ref.previousCellSize,
	      previousScrollToAlignment = _ref.previousScrollToAlignment,
	      previousScrollToIndex = _ref.previousScrollToIndex,
	      previousSize = _ref.previousSize,
	      scrollOffset = _ref.scrollOffset,
	      scrollToAlignment = _ref.scrollToAlignment,
	      scrollToIndex = _ref.scrollToIndex,
	      size = _ref.size,
	      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
	      updateScrollIndexCallback = _ref.updateScrollIndexCallback;
	
	  var cellCount = cellSizeAndPositionManager.getCellCount();
	  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
	  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
	
	  // If we have a new scroll target OR if height/row-height has changed,
	  // We should ensure that the scroll target is visible.
	  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
	    updateScrollIndexCallback(scrollToIndex);
	
	    // If we don't have a selected item but list size or number of children have decreased,
	    // Make sure we aren't scrolled too far past the current content.
	  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
	    // We need to ensure that the current scroll offset is still within the collection's range.
	    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
	    // Just check to make sure we're still okay.
	    // Only adjust the scroll position if we've scrolled below the last set of rows.
	    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
	      updateScrollIndexCallback(cellCount - 1);
	    }
	  }
	}

/***/ }),

/***/ 1151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.isRangeVisible = isRangeVisible;
	exports.scanForUnloadedRanges = scanForUnloadedRanges;
	exports.forceUpdateReactVirtualizedComponent = forceUpdateReactVirtualizedComponent;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createCallbackMemoizer = __webpack_require__(324);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Higher-order component that manages lazy-loading for "infinite" data.
	 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
	 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
	 */
	var InfiniteLoader = function (_React$PureComponent) {
	  (0, _inherits3.default)(InfiniteLoader, _React$PureComponent);
	
	  function InfiniteLoader(props, context) {
	    (0, _classCallCheck3.default)(this, InfiniteLoader);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InfiniteLoader.__proto__ || (0, _getPrototypeOf2.default)(InfiniteLoader)).call(this, props, context));
	
	    _this._loadMoreRowsMemoizer = (0, _createCallbackMemoizer2.default)();
	
	    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
	    _this._registerChild = _this._registerChild.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InfiniteLoader, [{
	    key: 'resetLoadMoreRowsCache',
	    value: function resetLoadMoreRowsCache(autoReload) {
	      this._loadMoreRowsMemoizer = (0, _createCallbackMemoizer2.default)();
	
	      if (autoReload) {
	        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return children({
	        onRowsRendered: this._onRowsRendered,
	        registerChild: this._registerChild
	      });
	    }
	  }, {
	    key: '_loadUnloadedRanges',
	    value: function _loadUnloadedRanges(unloadedRanges) {
	      var _this2 = this;
	
	      var loadMoreRows = this.props.loadMoreRows;
	
	
	      unloadedRanges.forEach(function (unloadedRange) {
	        var promise = loadMoreRows(unloadedRange);
	        if (promise) {
	          promise.then(function () {
	            // Refresh the visible rows if any of them have just been loaded.
	            // Otherwise they will remain in their unloaded visual state.
	            if (isRangeVisible({
	              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
	              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
	              startIndex: unloadedRange.startIndex,
	              stopIndex: unloadedRange.stopIndex
	            })) {
	              if (_this2._registeredChild) {
	                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
	              }
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: '_onRowsRendered',
	    value: function _onRowsRendered(_ref) {
	      var startIndex = _ref.startIndex,
	          stopIndex = _ref.stopIndex;
	
	      this._lastRenderedStartIndex = startIndex;
	      this._lastRenderedStopIndex = stopIndex;
	
	      this._doStuff(startIndex, stopIndex);
	    }
	  }, {
	    key: '_doStuff',
	    value: function _doStuff(startIndex, stopIndex) {
	      var _this3 = this;
	
	      var _props = this.props,
	          isRowLoaded = _props.isRowLoaded,
	          minimumBatchSize = _props.minimumBatchSize,
	          rowCount = _props.rowCount,
	          threshold = _props.threshold;
	
	
	      var unloadedRanges = scanForUnloadedRanges({
	        isRowLoaded: isRowLoaded,
	        minimumBatchSize: minimumBatchSize,
	        rowCount: rowCount,
	        startIndex: Math.max(0, startIndex - threshold),
	        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
	      });
	
	      // For memoize comparison
	      var squashedUnloadedRanges = unloadedRanges.reduce(function (reduced, unloadedRange) {
	        return reduced.concat([unloadedRange.startIndex, unloadedRange.stopIndex]);
	      }, []);
	
	      this._loadMoreRowsMemoizer({
	        callback: function callback() {
	          _this3._loadUnloadedRanges(unloadedRanges);
	        },
	        indices: { squashedUnloadedRanges: squashedUnloadedRanges }
	      });
	    }
	  }, {
	    key: '_registerChild',
	    value: function _registerChild(registeredChild) {
	      this._registeredChild = registeredChild;
	    }
	  }]);
	  return InfiniteLoader;
	}(React.PureComponent);
	
	/**
	 * Determines if the specified start/stop range is visible based on the most recently rendered range.
	 */
	
	
	InfiniteLoader.defaultProps = {
	  minimumBatchSize: 10,
	  rowCount: 0,
	  threshold: 15
	};
	exports.default = InfiniteLoader;
	InfiniteLoader.propTypes =  false ? {
	  /**
	   * Function responsible for rendering a virtualized component.
	   * This function should implement the following signature:
	   * ({ onRowsRendered, registerChild }) => PropTypes.element
	   *
	   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
	   * The :registerChild callback should be set as the virtualized component's :ref.
	   */
	  children: _propTypes2.default.func.isRequired,
	
	  /**
	   * Function responsible for tracking the loaded state of each row.
	   * It should implement the following signature: ({ index: number }): boolean
	   */
	  isRowLoaded: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback to be invoked when more rows must be loaded.
	   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
	   * The returned Promise should be resolved once row data has finished loading.
	   * It will be used to determine when to refresh the list with the newly-loaded data.
	   * This callback may be called multiple times in reaction to a single scroll event.
	   */
	  loadMoreRows: _propTypes2.default.func.isRequired,
	
	  /**
	   * Minimum number of rows to be loaded at a time.
	   * This property can be used to batch requests to reduce HTTP requests.
	   */
	  minimumBatchSize: _propTypes2.default.number.isRequired,
	
	  /**
	   * Number of rows in list; can be arbitrary high number if actual number is unknown.
	   */
	  rowCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Threshold at which to pre-fetch data.
	   * A threshold X means that data will start loading when a user scrolls within X rows.
	   * This value defaults to 15.
	   */
	  threshold: _propTypes2.default.number.isRequired
	} : {};
	function isRangeVisible(_ref2) {
	  var lastRenderedStartIndex = _ref2.lastRenderedStartIndex,
	      lastRenderedStopIndex = _ref2.lastRenderedStopIndex,
	      startIndex = _ref2.startIndex,
	      stopIndex = _ref2.stopIndex;
	
	  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
	}
	
	/**
	 * Returns all of the ranges within a larger range that contain unloaded rows.
	 */
	function scanForUnloadedRanges(_ref3) {
	  var isRowLoaded = _ref3.isRowLoaded,
	      minimumBatchSize = _ref3.minimumBatchSize,
	      rowCount = _ref3.rowCount,
	      startIndex = _ref3.startIndex,
	      stopIndex = _ref3.stopIndex;
	
	  var unloadedRanges = [];
	
	  var rangeStartIndex = null;
	  var rangeStopIndex = null;
	
	  for (var index = startIndex; index <= stopIndex; index++) {
	    var loaded = isRowLoaded({ index: index });
	
	    if (!loaded) {
	      rangeStopIndex = index;
	      if (rangeStartIndex === null) {
	        rangeStartIndex = index;
	      }
	    } else if (rangeStopIndex !== null) {
	      unloadedRanges.push({
	        startIndex: rangeStartIndex,
	        stopIndex: rangeStopIndex
	      });
	
	      rangeStartIndex = rangeStopIndex = null;
	    }
	  }
	
	  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
	  // Scan forward to try filling our :minimumBatchSize.
	  if (rangeStopIndex !== null) {
	    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);
	
	    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
	      if (!isRowLoaded({ index: _index })) {
	        rangeStopIndex = _index;
	      } else {
	        break;
	      }
	    }
	
	    unloadedRanges.push({
	      startIndex: rangeStartIndex,
	      stopIndex: rangeStopIndex
	    });
	  }
	
	  // Check to see if our first range ended prematurely.
	  // In this case we should scan backwards to try filling our :minimumBatchSize.
	  if (unloadedRanges.length) {
	    var firstUnloadedRange = unloadedRanges[0];
	
	    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
	      var _index2 = firstUnloadedRange.startIndex - 1;
	
	      if (!isRowLoaded({ index: _index2 })) {
	        firstUnloadedRange.startIndex = _index2;
	      } else {
	        break;
	      }
	    }
	  }
	
	  return unloadedRanges;
	}
	
	/**
	 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
	 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
	 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
	 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
	 * Else the inner Grid will not be re-rendered and visuals may be stale.
	 *
	 * Additionally, while a Grid is scrolling the cells can be cached,
	 * So it's important to invalidate that cache by recalculating sizes
	 * before forcing a rerender.
	 */
	function forceUpdateReactVirtualizedComponent(component) {
	  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;
	
	  if (recomputeSize) {
	    recomputeSize.call(component, currentIndex);
	  } else {
	    component.forceUpdate();
	  }
	}

/***/ }),

/***/ 1152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfiniteLoader = undefined;
	
	var _InfiniteLoader = __webpack_require__(1151);
	
	var _InfiniteLoader2 = _interopRequireDefault(_InfiniteLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InfiniteLoader2.default;
	exports.InfiniteLoader = _InfiniteLoader2.default;

/***/ }),

/***/ 1153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(624);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Grid = __webpack_require__(169);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _types = __webpack_require__(482);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
	 * if only a few of those elements are visible. The primary purpose of this component is to improve
	 * performance by only rendering the DOM nodes that a user is able to see based on their current
	 * scroll position.
	 *
	 * This component renders a virtualized list of elements with either fixed or dynamic heights.
	 */
	
	var List = function (_React$PureComponent) {
	  (0, _inherits3.default)(List, _React$PureComponent);
	
	  function List() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, List);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._cellRenderer = function (_ref2) {
	      var parent = _ref2.parent,
	          rowIndex = _ref2.rowIndex,
	          style = _ref2.style,
	          isScrolling = _ref2.isScrolling,
	          isVisible = _ref2.isVisible,
	          key = _ref2.key;
	      var rowRenderer = _this.props.rowRenderer;
	
	      // TRICKY The style object is sometimes cached by Grid.
	      // This prevents new style objects from bypassing shallowCompare().
	      // However as of React 16, style props are auto-frozen (at least in dev mode)
	      // Check to make sure we can still modify the style before proceeding.
	      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
	
	      var _Object$getOwnPropert = (0, _getOwnPropertyDescriptor2.default)(style, 'width'),
	          writable = _Object$getOwnPropert.writable;
	
	      if (writable) {
	        // By default, List cells should be 100% width.
	        // This prevents them from flowing under a scrollbar (if present).
	        style.width = '100%';
	      }
	
	      return rowRenderer({
	        index: rowIndex,
	        style: style,
	        isScrolling: isScrolling,
	        isVisible: isVisible,
	        key: key,
	        parent: parent
	      });
	    }, _this._setRef = function (ref) {
	      _this.Grid = ref;
	    }, _this._onScroll = function (_ref3) {
	      var clientHeight = _ref3.clientHeight,
	          scrollHeight = _ref3.scrollHeight,
	          scrollTop = _ref3.scrollTop;
	      var onScroll = _this.props.onScroll;
	
	
	      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
	    }, _this._onSectionRendered = function (_ref4) {
	      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex,
	          rowOverscanStopIndex = _ref4.rowOverscanStopIndex,
	          rowStartIndex = _ref4.rowStartIndex,
	          rowStopIndex = _ref4.rowStopIndex;
	      var onRowsRendered = _this.props.onRowsRendered;
	
	
	      onRowsRendered({
	        overscanStartIndex: rowOverscanStartIndex,
	        overscanStopIndex: rowOverscanStopIndex,
	        startIndex: rowStartIndex,
	        stopIndex: rowStopIndex
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'forceUpdateGrid',
	    value: function forceUpdateGrid() {
	      if (this.Grid) {
	        this.Grid.forceUpdate();
	      }
	    }
	
	    /** See Grid#getOffsetForCell */
	
	  }, {
	    key: 'getOffsetForRow',
	    value: function getOffsetForRow(_ref5) {
	      var alignment = _ref5.alignment,
	          index = _ref5.index;
	
	      if (this.Grid) {
	        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
	          alignment: alignment,
	          rowIndex: index,
	          columnIndex: 0
	        }),
	            _scrollTop = _Grid$getOffsetForCel.scrollTop;
	
	        return _scrollTop;
	      }
	      return 0;
	    }
	
	    /** CellMeasurer compatibility */
	
	  }, {
	    key: 'invalidateCellSizeAfterRender',
	    value: function invalidateCellSizeAfterRender(_ref6) {
	      var columnIndex = _ref6.columnIndex,
	          rowIndex = _ref6.rowIndex;
	
	      if (this.Grid) {
	        this.Grid.invalidateCellSizeAfterRender({
	          rowIndex: rowIndex,
	          columnIndex: columnIndex
	        });
	      }
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      if (this.Grid) {
	        this.Grid.measureAllCells();
	      }
	    }
	
	    /** CellMeasurer compatibility */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref7$columnIndex = _ref7.columnIndex,
	          columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex,
	          _ref7$rowIndex = _ref7.rowIndex,
	          rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;
	
	      if (this.Grid) {
	        this.Grid.recomputeGridSize({
	          rowIndex: rowIndex,
	          columnIndex: columnIndex
	        });
	      }
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeRowHeights',
	    value: function recomputeRowHeights() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.recomputeGridSize({
	          rowIndex: index,
	          columnIndex: 0
	        });
	      }
	    }
	
	    /** See Grid#scrollToPosition */
	
	  }, {
	    key: 'scrollToPosition',
	    value: function scrollToPosition() {
	      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.scrollToPosition({ scrollTop: scrollTop });
	      }
	    }
	
	    /** See Grid#scrollToCell */
	
	  }, {
	    key: 'scrollToRow',
	    value: function scrollToRow() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.scrollToCell({
	          columnIndex: 0,
	          rowIndex: index
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          noRowsRenderer = _props.noRowsRenderer,
	          scrollToIndex = _props.scrollToIndex,
	          width = _props.width;
	
	
	      var classNames = (0, _classnames2.default)('ReactVirtualized__List', className);
	
	      return React.createElement(_Grid2.default, (0, _extends3.default)({}, this.props, {
	        autoContainerWidth: true,
	        cellRenderer: this._cellRenderer,
	        className: classNames,
	        columnWidth: width,
	        columnCount: 1,
	        noContentRenderer: noRowsRenderer,
	        onScroll: this._onScroll,
	        onSectionRendered: this._onSectionRendered,
	        ref: this._setRef,
	        scrollToRow: scrollToIndex
	      }));
	    }
	  }]);
	  return List;
	}(React.PureComponent);
	
	List.defaultProps = {
	  autoHeight: false,
	  estimatedRowSize: 30,
	  onScroll: function onScroll() {},
	  noRowsRenderer: function noRowsRenderer() {
	    return null;
	  },
	  onRowsRendered: function onRowsRendered() {},
	  overscanIndicesGetter: _Grid.accessibilityOverscanIndicesGetter,
	  overscanRowCount: 10,
	  scrollToAlignment: 'auto',
	  scrollToIndex: -1,
	  style: {}
	};
	List.propTypes =  true ? null : {
	  "aria-label": _propTypes2.default.string,
	
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _propTypes2.default.bool.isRequired,
	
	
	  /** Optional CSS class name */
	  className: _propTypes2.default.string,
	
	
	  /**
	   * Used to estimate the total height of a List before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _propTypes2.default.number.isRequired,
	
	
	  /** Height constraint for list (determines how many actual rows are rendered) */
	  height: _propTypes2.default.number.isRequired,
	
	
	  /** Optional renderer to be used in place of rows when rowCount is 0 */
	  noRowsRenderer: function noRowsRenderer() {
	    return (typeof _Grid.bpfrpt_proptype_NoContentRenderer === 'function' ? _Grid.bpfrpt_proptype_NoContentRenderer.isRequired ? _Grid.bpfrpt_proptype_NoContentRenderer.isRequired : _Grid.bpfrpt_proptype_NoContentRenderer : _propTypes2.default.shape(_Grid.bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
	  },
	
	
	  /** Callback invoked with information about the slice of rows that were just rendered.  */
	
	  onRowsRendered: _propTypes2.default.func.isRequired,
	
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   */
	  onScroll: _propTypes2.default.func.isRequired,
	
	
	  /** See Grid#overscanIndicesGetter */
	  overscanIndicesGetter: function overscanIndicesGetter() {
	    return (typeof _Grid.bpfrpt_proptype_OverscanIndicesGetter === 'function' ? _Grid.bpfrpt_proptype_OverscanIndicesGetter.isRequired ? _Grid.bpfrpt_proptype_OverscanIndicesGetter.isRequired : _Grid.bpfrpt_proptype_OverscanIndicesGetter : _propTypes2.default.shape(_Grid.bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
	  },
	
	
	  /**
	   * Number of rows to render above/below the visible bounds of the list.
	   * These rows can help for smoother scrolling on touch devices.
	   */
	  overscanRowCount: _propTypes2.default.number.isRequired,
	
	
	  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
	  rowHeight: function rowHeight() {
	    return (typeof _Grid.bpfrpt_proptype_CellSize === 'function' ? _Grid.bpfrpt_proptype_CellSize.isRequired ? _Grid.bpfrpt_proptype_CellSize.isRequired : _Grid.bpfrpt_proptype_CellSize : _propTypes2.default.shape(_Grid.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
	  },
	
	
	  /** Responsible for rendering a row given an index; ({ index: number }): node */
	  rowRenderer: function rowRenderer() {
	    return (typeof _types.bpfrpt_proptype_RowRenderer === 'function' ? _types.bpfrpt_proptype_RowRenderer.isRequired ? _types.bpfrpt_proptype_RowRenderer.isRequired : _types.bpfrpt_proptype_RowRenderer : _propTypes2.default.shape(_types.bpfrpt_proptype_RowRenderer).isRequired).apply(this, arguments);
	  },
	
	
	  /** Number of rows in list. */
	  rowCount: _propTypes2.default.number.isRequired,
	
	
	  /** See Grid#scrollToAlignment */
	  scrollToAlignment: function scrollToAlignment() {
	    return (typeof _Grid.bpfrpt_proptype_Alignment === 'function' ? _Grid.bpfrpt_proptype_Alignment.isRequired ? _Grid.bpfrpt_proptype_Alignment.isRequired : _Grid.bpfrpt_proptype_Alignment : _propTypes2.default.shape(_Grid.bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
	  },
	
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToIndex: _propTypes2.default.number.isRequired,
	
	
	  /** Vertical offset. */
	  scrollTop: _propTypes2.default.number,
	
	
	  /** Optional inline style */
	  style: _propTypes2.default.object.isRequired,
	
	
	  /** Tab index for focus */
	  tabIndex: _propTypes2.default.number,
	
	
	  /** Width of list */
	  width: _propTypes2.default.number.isRequired
	};
	exports.default = List;

/***/ }),

/***/ 1154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bpfrpt_proptype_RowRendererParams = exports.List = exports.default = undefined;
	
	var _List = __webpack_require__(1153);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});
	Object.defineProperty(exports, 'List', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});
	
	var _types = __webpack_require__(482);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.bpfrpt_proptype_RowRendererParams = _types.bpfrpt_proptype_RowRendererParams;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bpfrpt_proptype_Scroll = exports.bpfrpt_proptype_RenderedRows = exports.bpfrpt_proptype_RowRenderer = exports.bpfrpt_proptype_RowRendererParams = undefined;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var bpfrpt_proptype_RowRendererParams =  true ? null : {
	  index: _propTypes2.default.number.isRequired,
	  isScrolling: _propTypes2.default.bool.isRequired,
	  isVisible: _propTypes2.default.bool.isRequired,
	  key: _propTypes2.default.string.isRequired,
	  parent: _propTypes2.default.object.isRequired,
	  style: _propTypes2.default.object.isRequired
	};
	var bpfrpt_proptype_RowRenderer =  true ? null : _propTypes2.default.func;
	var bpfrpt_proptype_RenderedRows =  true ? null : {
	  overscanStartIndex: _propTypes2.default.number.isRequired,
	  overscanStopIndex: _propTypes2.default.number.isRequired,
	  startIndex: _propTypes2.default.number.isRequired,
	  stopIndex: _propTypes2.default.number.isRequired
	};
	var bpfrpt_proptype_Scroll =  true ? null : {
	  clientHeight: _propTypes2.default.number.isRequired,
	  scrollHeight: _propTypes2.default.number.isRequired,
	  scrollTop: _propTypes2.default.number.isRequired
	};
	exports.bpfrpt_proptype_RowRendererParams = bpfrpt_proptype_RowRendererParams;
	exports.bpfrpt_proptype_RowRenderer = bpfrpt_proptype_RowRenderer;
	exports.bpfrpt_proptype_RenderedRows = bpfrpt_proptype_RenderedRows;
	exports.bpfrpt_proptype_Scroll = bpfrpt_proptype_Scroll;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bpfrpt_proptype_Positioner = exports.bpfrpt_proptype_CellMeasurerCache = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(25);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactLifecyclesCompat = __webpack_require__(118);
	
	var _PositionCache = __webpack_require__(1155);
	
	var _PositionCache2 = _interopRequireDefault(_PositionCache);
	
	var _requestAnimationTimeout = __webpack_require__(325);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyObject = {};
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	
	var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
	
	/**
	 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
	 * Cell position is determined by an injected `cellPositioner` property.
	 * Windowing is vertical; this component does not support horizontal scrolling.
	 *
	 * Rendering occurs in two phases:
	 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
	 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
	 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
	 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
	 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
	 * 2) Second pass uses the external `cellPositioner` to layout cells.
	 *    At this time the positioner has access to cached size measurements for all cells.
	 *    The positions it returns are cached by Masonry for fast access later.
	 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
	 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
	 *
	 * Animation constraints:
	 *   Simple animations are supported (eg translate/slide into place on initial reveal).
	 *   More complex animations are not (eg flying from one position to another on resize).
	 *
	 * Layout constraints:
	 *   This component supports multi-column layout.
	 *   The height of each item may vary.
	 *   The width of each item must not exceed the width of the column it is "in".
	 *   The left position of all items within a column must align.
	 *   (Items may not span multiple columns.)
	 */
	
	var Masonry = function (_React$PureComponent) {
	  (0, _inherits3.default)(Masonry, _React$PureComponent);
	
	  function Masonry() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Masonry);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Masonry.__proto__ || (0, _getPrototypeOf2.default)(Masonry)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isScrolling: false,
	      scrollTop: 0
	    }, _this._invalidateOnUpdateStartIndex = null, _this._invalidateOnUpdateStopIndex = null, _this._positionCache = new _PositionCache2.default(), _this._startIndex = null, _this._startIndexMemoized = null, _this._stopIndex = null, _this._stopIndexMemoized = null, _this._debounceResetIsScrollingCallback = function () {
	      _this.setState({
	        isScrolling: false
	      });
	    }, _this._setScrollingContainerRef = function (ref) {
	      _this._scrollingContainer = ref;
	    }, _this._onScroll = function (event) {
	      var height = _this.props.height;
	
	
	      var eventScrollTop = event.target.scrollTop;
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
	      var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop);
	
	      // On iOS, we can arrive at negative offsets by swiping past the start or end.
	      // Avoid re-rendering in this case as it can cause problems; see #532 for more.
	      if (eventScrollTop !== scrollTop) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      _this._debounceResetIsScrolling();
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (_this.state.scrollTop !== scrollTop) {
	        _this.setState({
	          isScrolling: true,
	          scrollTop: scrollTop
	        });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Masonry, [{
	    key: 'clearCellPositions',
	    value: function clearCellPositions() {
	      this._positionCache = new _PositionCache2.default();
	      this.forceUpdate();
	    }
	
	    // HACK This method signature was intended for Grid
	
	  }, {
	    key: 'invalidateCellSizeAfterRender',
	    value: function invalidateCellSizeAfterRender(_ref2) {
	      var index = _ref2.rowIndex;
	
	      if (this._invalidateOnUpdateStartIndex === null) {
	        this._invalidateOnUpdateStartIndex = index;
	        this._invalidateOnUpdateStopIndex = index;
	      } else {
	        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
	        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
	      }
	    }
	  }, {
	    key: 'recomputeCellPositions',
	    value: function recomputeCellPositions() {
	      var stopIndex = this._positionCache.count - 1;
	
	      this._positionCache = new _PositionCache2.default();
	      this._populatePositionCache(0, stopIndex);
	
	      this.forceUpdate();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._checkInvalidateOnUpdate();
	      this._invokeOnScrollCallback();
	      this._invokeOnCellsRenderedCallback();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      this._checkInvalidateOnUpdate();
	      this._invokeOnScrollCallback();
	      this._invokeOnCellsRenderedCallback();
	
	      if (this.props.scrollTop !== prevProps.scrollTop) {
	        this._debounceResetIsScrolling();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._debounceResetIsScrollingId) {
	        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._debounceResetIsScrollingId);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          autoHeight = _props.autoHeight,
	          cellCount = _props.cellCount,
	          cellMeasurerCache = _props.cellMeasurerCache,
	          cellRenderer = _props.cellRenderer,
	          className = _props.className,
	          height = _props.height,
	          id = _props.id,
	          keyMapper = _props.keyMapper,
	          overscanByPixels = _props.overscanByPixels,
	          role = _props.role,
	          style = _props.style,
	          tabIndex = _props.tabIndex,
	          width = _props.width,
	          rowDirection = _props.rowDirection;
	      var _state = this.state,
	          isScrolling = _state.isScrolling,
	          scrollTop = _state.scrollTop;
	
	
	      var children = [];
	
	      var estimateTotalHeight = this._getEstimatedTotalHeight();
	
	      var shortestColumnSize = this._positionCache.shortestColumnSize;
	      var measuredCellCount = this._positionCache.count;
	
	      var startIndex = 0;
	      var stopIndex = void 0;
	
	      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function (index, left, top) {
	        var _style;
	
	        if (typeof stopIndex === 'undefined') {
	          startIndex = index;
	          stopIndex = index;
	        } else {
	          startIndex = Math.min(startIndex, index);
	          stopIndex = Math.max(stopIndex, index);
	        }
	
	        children.push(cellRenderer({
	          index: index,
	          isScrolling: isScrolling,
	          key: keyMapper(index),
	          parent: _this2,
	          style: (_style = {
	            height: cellMeasurerCache.getHeight(index)
	          }, (0, _defineProperty3.default)(_style, rowDirection === 'ltr' ? 'left' : 'right', left), (0, _defineProperty3.default)(_style, 'position', 'absolute'), (0, _defineProperty3.default)(_style, 'top', top), (0, _defineProperty3.default)(_style, 'width', cellMeasurerCache.getWidth(index)), _style)
	        }));
	      });
	
	      // We need to measure additional cells for this layout
	      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
	        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));
	
	        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
	          stopIndex = _index;
	
	          children.push(cellRenderer({
	            index: _index,
	            isScrolling: isScrolling,
	            key: keyMapper(_index),
	            parent: this,
	            style: {
	              width: cellMeasurerCache.getWidth(_index)
	            }
	          }));
	        }
	      }
	
	      this._startIndex = startIndex;
	      this._stopIndex = stopIndex;
	
	      return React.createElement(
	        'div',
	        {
	          ref: this._setScrollingContainerRef,
	          'aria-label': this.props['aria-label'],
	          className: (0, _classnames2.default)('ReactVirtualized__Masonry', className),
	          id: id,
	          onScroll: this._onScroll,
	          role: role,
	          style: (0, _extends3.default)({
	            boxSizing: 'border-box',
	            direction: 'ltr',
	            height: autoHeight ? 'auto' : height,
	            overflowX: 'hidden',
	            overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
	            position: 'relative',
	            width: width,
	            WebkitOverflowScrolling: 'touch',
	            willChange: 'transform'
	          }, style),
	          tabIndex: tabIndex },
	        React.createElement(
	          'div',
	          {
	            className: 'ReactVirtualized__Masonry__innerScrollContainer',
	            style: {
	              width: '100%',
	              height: estimateTotalHeight,
	              maxWidth: '100%',
	              maxHeight: estimateTotalHeight,
	              overflow: 'hidden',
	              pointerEvents: isScrolling ? 'none' : '',
	              position: 'relative'
	            } },
	          children
	        )
	      );
	    }
	  }, {
	    key: '_checkInvalidateOnUpdate',
	    value: function _checkInvalidateOnUpdate() {
	      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
	        var _startIndex = this._invalidateOnUpdateStartIndex;
	        var _stopIndex = this._invalidateOnUpdateStopIndex;
	
	        this._invalidateOnUpdateStartIndex = null;
	        this._invalidateOnUpdateStopIndex = null;
	
	        // Query external layout logic for position of newly-measured cells
	        this._populatePositionCache(_startIndex, _stopIndex);
	
	        this.forceUpdate();
	      }
	    }
	  }, {
	    key: '_debounceResetIsScrolling',
	    value: function _debounceResetIsScrolling() {
	      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
	
	
	      if (this._debounceResetIsScrollingId) {
	        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._debounceResetIsScrollingId);
	      }
	
	      this._debounceResetIsScrollingId = (0, _requestAnimationTimeout.requestAnimationTimeout)(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
	    }
	  }, {
	    key: '_getEstimatedTotalHeight',
	    value: function _getEstimatedTotalHeight() {
	      var _props2 = this.props,
	          cellCount = _props2.cellCount,
	          cellMeasurerCache = _props2.cellMeasurerCache,
	          width = _props2.width;
	
	
	      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));
	
	      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
	    }
	  }, {
	    key: '_invokeOnScrollCallback',
	    value: function _invokeOnScrollCallback() {
	      var _props3 = this.props,
	          height = _props3.height,
	          onScroll = _props3.onScroll;
	      var scrollTop = this.state.scrollTop;
	
	
	      if (this._onScrollMemoized !== scrollTop) {
	        onScroll({
	          clientHeight: height,
	          scrollHeight: this._getEstimatedTotalHeight(),
	          scrollTop: scrollTop
	        });
	
	        this._onScrollMemoized = scrollTop;
	      }
	    }
	  }, {
	    key: '_invokeOnCellsRenderedCallback',
	    value: function _invokeOnCellsRenderedCallback() {
	      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
	        var _onCellsRendered = this.props.onCellsRendered;
	
	
	        _onCellsRendered({
	          startIndex: this._startIndex,
	          stopIndex: this._stopIndex
	        });
	
	        this._startIndexMemoized = this._startIndex;
	        this._stopIndexMemoized = this._stopIndex;
	      }
	    }
	  }, {
	    key: '_populatePositionCache',
	    value: function _populatePositionCache(startIndex, stopIndex) {
	      var _props4 = this.props,
	          cellMeasurerCache = _props4.cellMeasurerCache,
	          cellPositioner = _props4.cellPositioner;
	
	
	      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
	        var _cellPositioner = cellPositioner(_index2),
	            _left = _cellPositioner.left,
	            _top = _cellPositioner.top;
	
	        this._positionCache.setPosition(_index2, _left, _top, cellMeasurerCache.getHeight(_index2));
	      }
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (nextProps.scrollTop !== undefined && prevState.scrollTop !== nextProps.scrollTop) {
	        return {
	          isScrolling: true,
	          scrollTop: nextProps.scrollTop
	        };
	      }
	
	      return null;
	    }
	  }]);
	  return Masonry;
	}(React.PureComponent);
	
	Masonry.defaultProps = {
	  autoHeight: false,
	  keyMapper: identity,
	  onCellsRendered: noop,
	  onScroll: noop,
	  overscanByPixels: 20,
	  role: 'grid',
	  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
	  style: emptyObject,
	  tabIndex: 0,
	  rowDirection: 'ltr'
	};
	Masonry.propTypes =  true ? null : {
	  autoHeight: _propTypes2.default.bool.isRequired,
	  cellCount: _propTypes2.default.number.isRequired,
	  cellMeasurerCache: function cellMeasurerCache() {
	    return (typeof CellMeasurerCache === 'function' ? _propTypes2.default.instanceOf(CellMeasurerCache).isRequired : _propTypes2.default.any.isRequired).apply(this, arguments);
	  },
	  cellPositioner: function cellPositioner() {
	    return (typeof Positioner === 'function' ? _propTypes2.default.instanceOf(Positioner).isRequired : _propTypes2.default.any.isRequired).apply(this, arguments);
	  },
	  cellRenderer: function cellRenderer() {
	    return (typeof CellRenderer === 'function' ? _propTypes2.default.instanceOf(CellRenderer).isRequired : _propTypes2.default.any.isRequired).apply(this, arguments);
	  },
	  className: _propTypes2.default.string,
	  height: _propTypes2.default.number.isRequired,
	  id: _propTypes2.default.string,
	  keyMapper: function keyMapper() {
	    return (typeof KeyMapper === 'function' ? _propTypes2.default.instanceOf(KeyMapper).isRequired : _propTypes2.default.any.isRequired).apply(this, arguments);
	  },
	  onCellsRendered: function onCellsRendered() {
	    return (typeof OnCellsRenderedCallback === 'function' ? _propTypes2.default.instanceOf(OnCellsRenderedCallback) : _propTypes2.default.any).apply(this, arguments);
	  },
	  onScroll: function onScroll() {
	    return (typeof OnScrollCallback === 'function' ? _propTypes2.default.instanceOf(OnScrollCallback) : _propTypes2.default.any).apply(this, arguments);
	  },
	  overscanByPixels: _propTypes2.default.number.isRequired,
	  role: _propTypes2.default.string.isRequired,
	  scrollingResetTimeInterval: _propTypes2.default.number.isRequired,
	  style: function style(props, propName, componentName) {
	    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
	      throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
	    }
	  },
	  tabIndex: _propTypes2.default.number.isRequired,
	  width: _propTypes2.default.number.isRequired,
	  rowDirection: _propTypes2.default.string.isRequired
	};
	
	
	function identity(value) {
	  return value;
	}
	
	function noop() {}
	
	var bpfrpt_proptype_CellMeasurerCache =  true ? null : {
	  defaultHeight: _propTypes2.default.number.isRequired,
	  defaultWidth: _propTypes2.default.number.isRequired,
	  getHeight: _propTypes2.default.func.isRequired,
	  getWidth: _propTypes2.default.func.isRequired
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Masonry);
	
	exports.default = Masonry;
	var bpfrpt_proptype_Positioner =  true ? null : _propTypes2.default.func;
	exports.bpfrpt_proptype_CellMeasurerCache = bpfrpt_proptype_CellMeasurerCache;
	exports.bpfrpt_proptype_Positioner = bpfrpt_proptype_Positioner;

/***/ }),

/***/ 1155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(349);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _intervalTree = __webpack_require__(1172);
	
	var _intervalTree2 = _interopRequireDefault(_intervalTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Position cache requirements:
	//   O(log(n)) lookup of cells to render for a given viewport size
	//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
	var PositionCache = function () {
	  function PositionCache() {
	    (0, _classCallCheck3.default)(this, PositionCache);
	    this._columnSizeMap = {};
	    this._intervalTree = (0, _intervalTree2.default)();
	    this._leftMap = {};
	  }
	  // Tracks the height of each column
	
	
	  // Store tops and bottoms of each cell for fast intersection lookup.
	
	
	  // Maps cell index to x coordinates for quick lookup.
	
	
	  (0, _createClass3.default)(PositionCache, [{
	    key: 'estimateTotalHeight',
	    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
	      var unmeasuredCellCount = cellCount - this.count;
	      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
	    }
	
	    // Render all cells visible within the viewport range defined.
	
	  }, {
	    key: 'range',
	    value: function range(scrollTop, clientHeight, renderCallback) {
	      var _this = this;
	
	      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 3),
	            top = _ref2[0],
	            _ = _ref2[1],
	            index = _ref2[2];
	
	        return renderCallback(index, _this._leftMap[index], top);
	      });
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(index, left, top, height) {
	      this._intervalTree.insert([top, top + height, index]);
	      this._leftMap[index] = left;
	
	      var columnSizeMap = this._columnSizeMap;
	      var columnHeight = columnSizeMap[left];
	      if (columnHeight === undefined) {
	        columnSizeMap[left] = top + height;
	      } else {
	        columnSizeMap[left] = Math.max(columnHeight, top + height);
	      }
	    }
	  }, {
	    key: 'count',
	    get: function get() {
	      return this._intervalTree.count;
	    }
	  }, {
	    key: 'shortestColumnSize',
	    get: function get() {
	      var columnSizeMap = this._columnSizeMap;
	
	      var size = 0;
	
	      for (var i in columnSizeMap) {
	        var height = columnSizeMap[i];
	        size = size === 0 ? height : Math.min(size, height);
	      }
	
	      return size;
	    }
	  }, {
	    key: 'tallestColumnSize',
	    get: function get() {
	      var columnSizeMap = this._columnSizeMap;
	
	      var size = 0;
	
	      for (var i in columnSizeMap) {
	        var height = columnSizeMap[i];
	        size = Math.max(size, height);
	      }
	
	      return size;
	    }
	  }]);
	  return PositionCache;
	}();
	
	exports.default = PositionCache;

/***/ }),

/***/ 1156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createCellPositioner;
	
	var _Masonry = __webpack_require__(483);
	
	function createCellPositioner(_ref) {
	  var cellMeasurerCache = _ref.cellMeasurerCache,
	      columnCount = _ref.columnCount,
	      columnWidth = _ref.columnWidth,
	      _ref$spacer = _ref.spacer,
	      spacer = _ref$spacer === undefined ? 0 : _ref$spacer;
	
	  var columnHeights = void 0;
	
	  initOrResetDerivedValues();
	
	  function cellPositioner(index) {
	    // Find the shortest column and use it.
	    var columnIndex = 0;
	    for (var i = 1; i < columnHeights.length; i++) {
	      if (columnHeights[i] < columnHeights[columnIndex]) {
	        columnIndex = i;
	      }
	    }
	
	    var left = columnIndex * (columnWidth + spacer);
	    var top = columnHeights[columnIndex] || 0;
	
	    columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;
	
	    return {
	      left: left,
	      top: top
	    };
	  }
	
	  function initOrResetDerivedValues() {
	    // Track the height of each column.
	    // Layout algorithm below always inserts into the shortest column.
	    columnHeights = [];
	    for (var i = 0; i < columnCount; i++) {
	      columnHeights[i] = 0;
	    }
	  }
	
	  function reset(params) {
	    columnCount = params.columnCount;
	    columnWidth = params.columnWidth;
	    spacer = params.spacer;
	
	    initOrResetDerivedValues();
	  }
	
	  cellPositioner.reset = reset;
	
	  return cellPositioner;
	}

/***/ }),

/***/ 1157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Masonry = exports.createCellPositioner = undefined;
	
	var _createCellPositioner = __webpack_require__(1156);
	
	var _createCellPositioner2 = _interopRequireDefault(_createCellPositioner);
	
	var _Masonry = __webpack_require__(483);
	
	var _Masonry2 = _interopRequireDefault(_Masonry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Masonry2.default;
	exports.createCellPositioner = _createCellPositioner2.default;
	exports.Masonry = _Masonry2.default;

/***/ }),

/***/ 1158:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _CellMeasurer = __webpack_require__(478);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Caches measurements for a given cell.
	 */
	var CellMeasurerCacheDecorator = function () {
	  function CellMeasurerCacheDecorator() {
	    var _this = this;
	
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, CellMeasurerCacheDecorator);
	
	    this.columnWidth = function (_ref) {
	      var index = _ref.index;
	
	      _this._cellMeasurerCache.columnWidth({
	        index: index + _this._columnIndexOffset
	      });
	    };
	
	    this.rowHeight = function (_ref2) {
	      var index = _ref2.index;
	
	      _this._cellMeasurerCache.rowHeight({
	        index: index + _this._rowIndexOffset
	      });
	    };
	
	    var cellMeasurerCache = params.cellMeasurerCache,
	        _params$columnIndexOf = params.columnIndexOffset,
	        columnIndexOffset = _params$columnIndexOf === undefined ? 0 : _params$columnIndexOf,
	        _params$rowIndexOffse = params.rowIndexOffset,
	        rowIndexOffset = _params$rowIndexOffse === undefined ? 0 : _params$rowIndexOffse;
	
	
	    this._cellMeasurerCache = cellMeasurerCache;
	    this._columnIndexOffset = columnIndexOffset;
	    this._rowIndexOffset = rowIndexOffset;
	  }
	
	  (0, _createClass3.default)(CellMeasurerCacheDecorator, [{
	    key: 'clear',
	    value: function clear(rowIndex, columnIndex) {
	      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
	    }
	  }, {
	    key: 'clearAll',
	    value: function clearAll() {
	      this._cellMeasurerCache.clearAll();
	    }
	  }, {
	    key: 'hasFixedHeight',
	    value: function hasFixedHeight() {
	      return this._cellMeasurerCache.hasFixedHeight();
	    }
	  }, {
	    key: 'hasFixedWidth',
	    value: function hasFixedWidth() {
	      return this._cellMeasurerCache.hasFixedWidth();
	    }
	  }, {
	    key: 'getHeight',
	    value: function getHeight(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
	    }
	  }, {
	    key: 'has',
	    value: function has(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
	    }
	  }, {
	    key: 'set',
	    value: function set(rowIndex, columnIndex, width, height) {
	      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
	    }
	  }, {
	    key: 'defaultHeight',
	    get: function get() {
	      return this._cellMeasurerCache.defaultHeight;
	    }
	  }, {
	    key: 'defaultWidth',
	    get: function get() {
	      return this._cellMeasurerCache.defaultWidth;
	    }
	  }]);
	  return CellMeasurerCacheDecorator;
	}();
	
	exports.default = CellMeasurerCacheDecorator;

/***/ }),

/***/ 1159:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(49);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactLifecyclesCompat = __webpack_require__(118);
	
	var _CellMeasurerCacheDecorator = __webpack_require__(1158);
	
	var _CellMeasurerCacheDecorator2 = _interopRequireDefault(_CellMeasurerCacheDecorator);
	
	var _Grid = __webpack_require__(169);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SCROLLBAR_SIZE_BUFFER = 20;
	
	/**
	 * Renders 1, 2, or 4 Grids depending on configuration.
	 * A main (body) Grid will always be rendered.
	 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
	 * If no sticky columns, only 1 sticky header Grid will be rendered.
	 * If sticky columns, 2 sticky header Grids will be rendered.
	 */
	
	var MultiGrid = function (_React$PureComponent) {
	  (0, _inherits3.default)(MultiGrid, _React$PureComponent);
	
	  function MultiGrid(props, context) {
	    (0, _classCallCheck3.default)(this, MultiGrid);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MultiGrid.__proto__ || (0, _getPrototypeOf2.default)(MultiGrid)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var deferredMeasurementCache = props.deferredMeasurementCache,
	        fixedColumnCount = props.fixedColumnCount,
	        fixedRowCount = props.fixedRowCount;
	
	
	    _this._maybeCalculateCachedStyles(true);
	
	    if (deferredMeasurementCache) {
	      _this._deferredMeasurementCacheBottomLeftGrid = fixedRowCount > 0 ? new _CellMeasurerCacheDecorator2.default({
	        cellMeasurerCache: deferredMeasurementCache,
	        columnIndexOffset: 0,
	        rowIndexOffset: fixedRowCount
	      }) : deferredMeasurementCache;
	
	      _this._deferredMeasurementCacheBottomRightGrid = fixedColumnCount > 0 || fixedRowCount > 0 ? new _CellMeasurerCacheDecorator2.default({
	        cellMeasurerCache: deferredMeasurementCache,
	        columnIndexOffset: fixedColumnCount,
	        rowIndexOffset: fixedRowCount
	      }) : deferredMeasurementCache;
	
	      _this._deferredMeasurementCacheTopRightGrid = fixedColumnCount > 0 ? new _CellMeasurerCacheDecorator2.default({
	        cellMeasurerCache: deferredMeasurementCache,
	        columnIndexOffset: fixedColumnCount,
	        rowIndexOffset: 0
	      }) : deferredMeasurementCache;
	    }
	    return _this;
	  }
	
	  (0, _createClass3.default)(MultiGrid, [{
	    key: 'forceUpdateGrids',
	    value: function forceUpdateGrids() {
	      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
	      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
	      this._topLeftGrid && this._topLeftGrid.forceUpdate();
	      this._topRightGrid && this._topRightGrid.forceUpdate();
	    }
	
	    /** See Grid#invalidateCellSizeAfterRender */
	
	  }, {
	    key: 'invalidateCellSizeAfterRender',
	    value: function invalidateCellSizeAfterRender() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$columnIndex = _ref.columnIndex,
	          columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex,
	          _ref$rowIndex = _ref.rowIndex,
	          rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;
	
	      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
	      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllCells',
	    value: function measureAllCells() {
	      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
	      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
	      this._topLeftGrid && this._topLeftGrid.measureAllCells();
	      this._topRightGrid && this._topRightGrid.measureAllCells();
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$columnIndex = _ref2.columnIndex,
	          columnIndex = _ref2$columnIndex === undefined ? 0 : _ref2$columnIndex,
	          _ref2$rowIndex = _ref2.rowIndex,
	          rowIndex = _ref2$rowIndex === undefined ? 0 : _ref2$rowIndex;
	
	      var _props = this.props,
	          fixedColumnCount = _props.fixedColumnCount,
	          fixedRowCount = _props.fixedRowCount;
	
	
	      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
	      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
	
	      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
	        columnIndex: columnIndex,
	        rowIndex: adjustedRowIndex
	      });
	      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
	        columnIndex: adjustedColumnIndex,
	        rowIndex: adjustedRowIndex
	      });
	      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
	        columnIndex: columnIndex,
	        rowIndex: rowIndex
	      });
	      this._topRightGrid && this._topRightGrid.recomputeGridSize({
	        columnIndex: adjustedColumnIndex,
	        rowIndex: rowIndex
	      });
	
	      this._leftGridWidth = null;
	      this._topGridHeight = null;
	      this._maybeCalculateCachedStyles(true);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props2 = this.props,
	          scrollLeft = _props2.scrollLeft,
	          scrollTop = _props2.scrollTop;
	
	
	      if (scrollLeft > 0 || scrollTop > 0) {
	        var newState = {};
	
	        if (scrollLeft > 0) {
	          newState.scrollLeft = scrollLeft;
	        }
	
	        if (scrollTop > 0) {
	          newState.scrollTop = scrollTop;
	        }
	
	        this.setState(newState);
	      }
	      this._handleInvalidatedGridSize();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._handleInvalidatedGridSize();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          onScroll = _props3.onScroll,
	          onSectionRendered = _props3.onSectionRendered,
	          onScrollbarPresenceChange = _props3.onScrollbarPresenceChange,
	          scrollLeftProp = _props3.scrollLeft,
	          scrollToColumn = _props3.scrollToColumn,
	          scrollTopProp = _props3.scrollTop,
	          scrollToRow = _props3.scrollToRow,
	          rest = (0, _objectWithoutProperties3.default)(_props3, ['onScroll', 'onSectionRendered', 'onScrollbarPresenceChange', 'scrollLeft', 'scrollToColumn', 'scrollTop', 'scrollToRow']);
	
	
	      this._prepareForRender();
	
	      // Don't render any of our Grids if there are no cells.
	      // This mirrors what Grid does,
	      // And prevents us from recording inaccurage measurements when used with CellMeasurer.
	      if (this.props.width === 0 || this.props.height === 0) {
	        return null;
	      }
	
	      // scrollTop and scrollLeft props are explicitly filtered out and ignored
	
	      var _state = this.state,
	          scrollLeft = _state.scrollLeft,
	          scrollTop = _state.scrollTop;
	
	
	      return React.createElement(
	        'div',
	        { style: this._containerOuterStyle },
	        React.createElement(
	          'div',
	          { style: this._containerTopStyle },
	          this._renderTopLeftGrid(rest),
	          this._renderTopRightGrid((0, _extends3.default)({}, rest, {
	            onScroll: onScroll,
	            scrollLeft: scrollLeft
	          }))
	        ),
	        React.createElement(
	          'div',
	          { style: this._containerBottomStyle },
	          this._renderBottomLeftGrid((0, _extends3.default)({}, rest, {
	            onScroll: onScroll,
	            scrollTop: scrollTop
	          })),
	          this._renderBottomRightGrid((0, _extends3.default)({}, rest, {
	            onScroll: onScroll,
	            onSectionRendered: onSectionRendered,
	            scrollLeft: scrollLeft,
	            scrollToColumn: scrollToColumn,
	            scrollToRow: scrollToRow,
	            scrollTop: scrollTop
	          }))
	        )
	      );
	    }
	  }, {
	    key: '_getBottomGridHeight',
	    value: function _getBottomGridHeight(props) {
	      var height = props.height;
	
	
	      var topGridHeight = this._getTopGridHeight(props);
	
	      return height - topGridHeight;
	    }
	  }, {
	    key: '_getLeftGridWidth',
	    value: function _getLeftGridWidth(props) {
	      var fixedColumnCount = props.fixedColumnCount,
	          columnWidth = props.columnWidth;
	
	
	      if (this._leftGridWidth == null) {
	        if (typeof columnWidth === 'function') {
	          var leftGridWidth = 0;
	
	          for (var index = 0; index < fixedColumnCount; index++) {
	            leftGridWidth += columnWidth({ index: index });
	          }
	
	          this._leftGridWidth = leftGridWidth;
	        } else {
	          this._leftGridWidth = columnWidth * fixedColumnCount;
	        }
	      }
	
	      return this._leftGridWidth;
	    }
	  }, {
	    key: '_getRightGridWidth',
	    value: function _getRightGridWidth(props) {
	      var width = props.width;
	
	
	      var leftGridWidth = this._getLeftGridWidth(props);
	
	      return width - leftGridWidth;
	    }
	  }, {
	    key: '_getTopGridHeight',
	    value: function _getTopGridHeight(props) {
	      var fixedRowCount = props.fixedRowCount,
	          rowHeight = props.rowHeight;
	
	
	      if (this._topGridHeight == null) {
	        if (typeof rowHeight === 'function') {
	          var topGridHeight = 0;
	
	          for (var index = 0; index < fixedRowCount; index++) {
	            topGridHeight += rowHeight({ index: index });
	          }
	
	          this._topGridHeight = topGridHeight;
	        } else {
	          this._topGridHeight = rowHeight * fixedRowCount;
	        }
	      }
	
	      return this._topGridHeight;
	    }
	  }, {
	    key: '_handleInvalidatedGridSize',
	    value: function _handleInvalidatedGridSize() {
	      if (typeof this._deferredInvalidateColumnIndex === 'number') {
	        var columnIndex = this._deferredInvalidateColumnIndex;
	        var rowIndex = this._deferredInvalidateRowIndex;
	
	        this._deferredInvalidateColumnIndex = null;
	        this._deferredInvalidateRowIndex = null;
	
	        this.recomputeGridSize({
	          columnIndex: columnIndex,
	          rowIndex: rowIndex
	        });
	        this.forceUpdate();
	      }
	    }
	
	    /**
	     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
	     * This method recalculates styles only when specific props change.
	     */
	
	  }, {
	    key: '_maybeCalculateCachedStyles',
	    value: function _maybeCalculateCachedStyles(resetAll) {
	      var _props4 = this.props,
	          columnWidth = _props4.columnWidth,
	          enableFixedColumnScroll = _props4.enableFixedColumnScroll,
	          enableFixedRowScroll = _props4.enableFixedRowScroll,
	          height = _props4.height,
	          fixedColumnCount = _props4.fixedColumnCount,
	          fixedRowCount = _props4.fixedRowCount,
	          rowHeight = _props4.rowHeight,
	          style = _props4.style,
	          styleBottomLeftGrid = _props4.styleBottomLeftGrid,
	          styleBottomRightGrid = _props4.styleBottomRightGrid,
	          styleTopLeftGrid = _props4.styleTopLeftGrid,
	          styleTopRightGrid = _props4.styleTopRightGrid,
	          width = _props4.width;
	
	
	      var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
	      var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
	      var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;
	
	      if (resetAll || sizeChange || style !== this._lastRenderedStyle) {
	        this._containerOuterStyle = (0, _extends3.default)({
	          height: height,
	          overflow: 'visible', // Let :focus outline show through
	          width: width
	        }, style);
	      }
	
	      if (resetAll || sizeChange || topSizeChange) {
	        this._containerTopStyle = {
	          height: this._getTopGridHeight(this.props),
	          position: 'relative',
	          width: width
	        };
	
	        this._containerBottomStyle = {
	          height: height - this._getTopGridHeight(this.props),
	          overflow: 'visible', // Let :focus outline show through
	          position: 'relative',
	          width: width
	        };
	      }
	
	      if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) {
	        this._bottomLeftGridStyle = (0, _extends3.default)({
	          left: 0,
	          overflowX: 'hidden',
	          overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
	          position: 'absolute'
	        }, styleBottomLeftGrid);
	      }
	
	      if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) {
	        this._bottomRightGridStyle = (0, _extends3.default)({
	          left: this._getLeftGridWidth(this.props),
	          position: 'absolute'
	        }, styleBottomRightGrid);
	      }
	
	      if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) {
	        this._topLeftGridStyle = (0, _extends3.default)({
	          left: 0,
	          overflowX: 'hidden',
	          overflowY: 'hidden',
	          position: 'absolute',
	          top: 0
	        }, styleTopLeftGrid);
	      }
	
	      if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) {
	        this._topRightGridStyle = (0, _extends3.default)({
	          left: this._getLeftGridWidth(this.props),
	          overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
	          overflowY: 'hidden',
	          position: 'absolute',
	          top: 0
	        }, styleTopRightGrid);
	      }
	
	      this._lastRenderedColumnWidth = columnWidth;
	      this._lastRenderedFixedColumnCount = fixedColumnCount;
	      this._lastRenderedFixedRowCount = fixedRowCount;
	      this._lastRenderedHeight = height;
	      this._lastRenderedRowHeight = rowHeight;
	      this._lastRenderedStyle = style;
	      this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
	      this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
	      this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
	      this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
	      this._lastRenderedWidth = width;
	    }
	  }, {
	    key: '_prepareForRender',
	    value: function _prepareForRender() {
	      if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) {
	        this._leftGridWidth = null;
	      }
	
	      if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) {
	        this._topGridHeight = null;
	      }
	
	      this._maybeCalculateCachedStyles();
	
	      this._lastRenderedColumnWidth = this.props.columnWidth;
	      this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
	      this._lastRenderedFixedRowCount = this.props.fixedRowCount;
	      this._lastRenderedRowHeight = this.props.rowHeight;
	    }
	  }, {
	    key: '_renderBottomLeftGrid',
	    value: function _renderBottomLeftGrid(props) {
	      var enableFixedColumnScroll = props.enableFixedColumnScroll,
	          fixedColumnCount = props.fixedColumnCount,
	          fixedRowCount = props.fixedRowCount,
	          rowCount = props.rowCount,
	          hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
	      var showVerticalScrollbar = this.state.showVerticalScrollbar;
	
	
	      if (!fixedColumnCount) {
	        return null;
	      }
	
	      var additionalRowCount = showVerticalScrollbar ? 1 : 0,
	          height = this._getBottomGridHeight(props),
	          width = this._getLeftGridWidth(props),
	          scrollbarSize = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0,
	          gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize : width;
	
	      var bottomLeftGrid = React.createElement(_Grid2.default, (0, _extends3.default)({}, props, {
	        cellRenderer: this._cellRendererBottomLeftGrid,
	        className: this.props.classNameBottomLeftGrid,
	        columnCount: fixedColumnCount,
	        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
	        height: height,
	        onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
	        ref: this._bottomLeftGridRef,
	        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
	        rowHeight: this._rowHeightBottomGrid,
	        style: this._bottomLeftGridStyle,
	        tabIndex: null,
	        width: gridWidth
	      }));
	
	      if (hideBottomLeftGridScrollbar) {
	        return React.createElement(
	          'div',
	          {
	            className: 'BottomLeftGrid_ScrollWrapper',
	            style: (0, _extends3.default)({}, this._bottomLeftGridStyle, {
	              height: height,
	              width: width,
	              overflowY: 'hidden'
	            }) },
	          bottomLeftGrid
	        );
	      }
	      return bottomLeftGrid;
	    }
	  }, {
	    key: '_renderBottomRightGrid',
	    value: function _renderBottomRightGrid(props) {
	      var columnCount = props.columnCount,
	          fixedColumnCount = props.fixedColumnCount,
	          fixedRowCount = props.fixedRowCount,
	          rowCount = props.rowCount,
	          scrollToColumn = props.scrollToColumn,
	          scrollToRow = props.scrollToRow;
	
	
	      return React.createElement(_Grid2.default, (0, _extends3.default)({}, props, {
	        cellRenderer: this._cellRendererBottomRightGrid,
	        className: this.props.classNameBottomRightGrid,
	        columnCount: Math.max(0, columnCount - fixedColumnCount),
	        columnWidth: this._columnWidthRightGrid,
	        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
	        height: this._getBottomGridHeight(props),
	        onScroll: this._onScroll,
	        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
	        ref: this._bottomRightGridRef,
	        rowCount: Math.max(0, rowCount - fixedRowCount),
	        rowHeight: this._rowHeightBottomGrid,
	        scrollToColumn: scrollToColumn - fixedColumnCount,
	        scrollToRow: scrollToRow - fixedRowCount,
	        style: this._bottomRightGridStyle,
	        width: this._getRightGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_renderTopLeftGrid',
	    value: function _renderTopLeftGrid(props) {
	      var fixedColumnCount = props.fixedColumnCount,
	          fixedRowCount = props.fixedRowCount;
	
	
	      if (!fixedColumnCount || !fixedRowCount) {
	        return null;
	      }
	
	      return React.createElement(_Grid2.default, (0, _extends3.default)({}, props, {
	        className: this.props.classNameTopLeftGrid,
	        columnCount: fixedColumnCount,
	        height: this._getTopGridHeight(props),
	        ref: this._topLeftGridRef,
	        rowCount: fixedRowCount,
	        style: this._topLeftGridStyle,
	        tabIndex: null,
	        width: this._getLeftGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_renderTopRightGrid',
	    value: function _renderTopRightGrid(props) {
	      var columnCount = props.columnCount,
	          enableFixedRowScroll = props.enableFixedRowScroll,
	          fixedColumnCount = props.fixedColumnCount,
	          fixedRowCount = props.fixedRowCount,
	          scrollLeft = props.scrollLeft,
	          hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
	      var _state2 = this.state,
	          showHorizontalScrollbar = _state2.showHorizontalScrollbar,
	          scrollbarSize = _state2.scrollbarSize;
	
	
	      if (!fixedRowCount) {
	        return null;
	      }
	
	      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0,
	          height = this._getTopGridHeight(props),
	          width = this._getRightGridWidth(props),
	          additionalHeight = showHorizontalScrollbar ? scrollbarSize : 0;
	
	      var gridHeight = height,
	          style = this._topRightGridStyle;
	
	      if (hideTopRightGridScrollbar) {
	        gridHeight = height + additionalHeight;
	        style = (0, _extends3.default)({}, this._topRightGridStyle, {
	          left: 0
	        });
	      }
	
	      var topRightGrid = React.createElement(_Grid2.default, (0, _extends3.default)({}, props, {
	        cellRenderer: this._cellRendererTopRightGrid,
	        className: this.props.classNameTopRightGrid,
	        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
	        columnWidth: this._columnWidthRightGrid,
	        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
	        height: gridHeight,
	        onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
	        ref: this._topRightGridRef,
	        rowCount: fixedRowCount,
	        scrollLeft: scrollLeft,
	        style: style,
	        tabIndex: null,
	        width: width
	      }));
	
	      if (hideTopRightGridScrollbar) {
	        return React.createElement(
	          'div',
	          {
	            className: 'TopRightGrid_ScrollWrapper',
	            style: (0, _extends3.default)({}, this._topRightGridStyle, {
	              height: height,
	              width: width,
	              overflowX: 'hidden'
	            }) },
	          topRightGrid
	        );
	      }
	      return topRightGrid;
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
	        return {
	          scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
	          scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
	        };
	      }
	
	      return null;
	    }
	  }]);
	  return MultiGrid;
	}(React.PureComponent);
	
	MultiGrid.defaultProps = {
	  classNameBottomLeftGrid: '',
	  classNameBottomRightGrid: '',
	  classNameTopLeftGrid: '',
	  classNameTopRightGrid: '',
	  enableFixedColumnScroll: false,
	  enableFixedRowScroll: false,
	  fixedColumnCount: 0,
	  fixedRowCount: 0,
	  scrollToColumn: -1,
	  scrollToRow: -1,
	  style: {},
	  styleBottomLeftGrid: {},
	  styleBottomRightGrid: {},
	  styleTopLeftGrid: {},
	  styleTopRightGrid: {},
	  hideTopRightGridScrollbar: false,
	  hideBottomLeftGridScrollbar: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.state = {
	    scrollLeft: 0,
	    scrollTop: 0,
	    scrollbarSize: 0,
	    showHorizontalScrollbar: false,
	    showVerticalScrollbar: false
	  };
	  this._deferredInvalidateColumnIndex = null;
	  this._deferredInvalidateRowIndex = null;
	
	  this._bottomLeftGridRef = function (ref) {
	    _this2._bottomLeftGrid = ref;
	  };
	
	  this._bottomRightGridRef = function (ref) {
	    _this2._bottomRightGrid = ref;
	  };
	
	  this._cellRendererBottomLeftGrid = function (_ref3) {
	    var rowIndex = _ref3.rowIndex,
	        rest = (0, _objectWithoutProperties3.default)(_ref3, ['rowIndex']);
	    var _props5 = _this2.props,
	        cellRenderer = _props5.cellRenderer,
	        fixedRowCount = _props5.fixedRowCount,
	        rowCount = _props5.rowCount;
	
	
	    if (rowIndex === rowCount - fixedRowCount) {
	      return React.createElement('div', {
	        key: rest.key,
	        style: (0, _extends3.default)({}, rest.style, {
	          height: SCROLLBAR_SIZE_BUFFER
	        })
	      });
	    } else {
	      return cellRenderer((0, _extends3.default)({}, rest, {
	        parent: _this2,
	        rowIndex: rowIndex + fixedRowCount
	      }));
	    }
	  };
	
	  this._cellRendererBottomRightGrid = function (_ref4) {
	    var columnIndex = _ref4.columnIndex,
	        rowIndex = _ref4.rowIndex,
	        rest = (0, _objectWithoutProperties3.default)(_ref4, ['columnIndex', 'rowIndex']);
	    var _props6 = _this2.props,
	        cellRenderer = _props6.cellRenderer,
	        fixedColumnCount = _props6.fixedColumnCount,
	        fixedRowCount = _props6.fixedRowCount;
	
	
	    return cellRenderer((0, _extends3.default)({}, rest, {
	      columnIndex: columnIndex + fixedColumnCount,
	      parent: _this2,
	      rowIndex: rowIndex + fixedRowCount
	    }));
	  };
	
	  this._cellRendererTopRightGrid = function (_ref5) {
	    var columnIndex = _ref5.columnIndex,
	        rest = (0, _objectWithoutProperties3.default)(_ref5, ['columnIndex']);
	    var _props7 = _this2.props,
	        cellRenderer = _props7.cellRenderer,
	        columnCount = _props7.columnCount,
	        fixedColumnCount = _props7.fixedColumnCount;
	
	
	    if (columnIndex === columnCount - fixedColumnCount) {
	      return React.createElement('div', {
	        key: rest.key,
	        style: (0, _extends3.default)({}, rest.style, {
	          width: SCROLLBAR_SIZE_BUFFER
	        })
	      });
	    } else {
	      return cellRenderer((0, _extends3.default)({}, rest, {
	        columnIndex: columnIndex + fixedColumnCount,
	        parent: _this2
	      }));
	    }
	  };
	
	  this._columnWidthRightGrid = function (_ref6) {
	    var index = _ref6.index;
	    var _props8 = _this2.props,
	        columnCount = _props8.columnCount,
	        fixedColumnCount = _props8.fixedColumnCount,
	        columnWidth = _props8.columnWidth;
	    var _state3 = _this2.state,
	        scrollbarSize = _state3.scrollbarSize,
	        showHorizontalScrollbar = _state3.showHorizontalScrollbar;
	
	    // An extra cell is added to the count
	    // This gives the smaller Grid extra room for offset,
	    // In case the main (bottom right) Grid has a scrollbar
	    // If no scrollbar, the extra space is overflow:hidden anyway
	
	    if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) {
	      return scrollbarSize;
	    }
	
	    return typeof columnWidth === 'function' ? columnWidth({ index: index + fixedColumnCount }) : columnWidth;
	  };
	
	  this._onScroll = function (scrollInfo) {
	    var scrollLeft = scrollInfo.scrollLeft,
	        scrollTop = scrollInfo.scrollTop;
	
	    _this2.setState({
	      scrollLeft: scrollLeft,
	      scrollTop: scrollTop
	    });
	    var onScroll = _this2.props.onScroll;
	    if (onScroll) {
	      onScroll(scrollInfo);
	    }
	  };
	
	  this._onScrollbarPresenceChange = function (_ref7) {
	    var horizontal = _ref7.horizontal,
	        size = _ref7.size,
	        vertical = _ref7.vertical;
	    var _state4 = _this2.state,
	        showHorizontalScrollbar = _state4.showHorizontalScrollbar,
	        showVerticalScrollbar = _state4.showVerticalScrollbar;
	
	
	    if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
	      _this2.setState({
	        scrollbarSize: size,
	        showHorizontalScrollbar: horizontal,
	        showVerticalScrollbar: vertical
	      });
	
	      var onScrollbarPresenceChange = _this2.props.onScrollbarPresenceChange;
	
	      if (typeof onScrollbarPresenceChange === 'function') {
	        onScrollbarPresenceChange({
	          horizontal: horizontal,
	          size: size,
	          vertical: vertical
	        });
	      }
	    }
	  };
	
	  this._onScrollLeft = function (scrollInfo) {
	    var scrollLeft = scrollInfo.scrollLeft;
	
	    _this2._onScroll({
	      scrollLeft: scrollLeft,
	      scrollTop: _this2.state.scrollTop
	    });
	  };
	
	  this._onScrollTop = function (scrollInfo) {
	    var scrollTop = scrollInfo.scrollTop;
	
	    _this2._onScroll({
	      scrollTop: scrollTop,
	      scrollLeft: _this2.state.scrollLeft
	    });
	  };
	
	  this._rowHeightBottomGrid = function (_ref8) {
	    var index = _ref8.index;
	    var _props9 = _this2.props,
	        fixedRowCount = _props9.fixedRowCount,
	        rowCount = _props9.rowCount,
	        rowHeight = _props9.rowHeight;
	    var _state5 = _this2.state,
	        scrollbarSize = _state5.scrollbarSize,
	        showVerticalScrollbar = _state5.showVerticalScrollbar;
	
	    // An extra cell is added to the count
	    // This gives the smaller Grid extra room for offset,
	    // In case the main (bottom right) Grid has a scrollbar
	    // If no scrollbar, the extra space is overflow:hidden anyway
	
	    if (showVerticalScrollbar && index === rowCount - fixedRowCount) {
	      return scrollbarSize;
	    }
	
	    return typeof rowHeight === 'function' ? rowHeight({ index: index + fixedRowCount }) : rowHeight;
	  };
	
	  this._topLeftGridRef = function (ref) {
	    _this2._topLeftGrid = ref;
	  };
	
	  this._topRightGridRef = function (ref) {
	    _this2._topRightGrid = ref;
	  };
	};
	
	MultiGrid.propTypes =  false ? {
	  classNameBottomLeftGrid: _propTypes2.default.string.isRequired,
	  classNameBottomRightGrid: _propTypes2.default.string.isRequired,
	  classNameTopLeftGrid: _propTypes2.default.string.isRequired,
	  classNameTopRightGrid: _propTypes2.default.string.isRequired,
	  enableFixedColumnScroll: _propTypes2.default.bool.isRequired,
	  enableFixedRowScroll: _propTypes2.default.bool.isRequired,
	  fixedColumnCount: _propTypes2.default.number.isRequired,
	  fixedRowCount: _propTypes2.default.number.isRequired,
	  onScrollbarPresenceChange: _propTypes2.default.func,
	  style: _propTypes2.default.object.isRequired,
	  styleBottomLeftGrid: _propTypes2.default.object.isRequired,
	  styleBottomRightGrid: _propTypes2.default.object.isRequired,
	  styleTopLeftGrid: _propTypes2.default.object.isRequired,
	  styleTopRightGrid: _propTypes2.default.object.isRequired,
	  hideTopRightGridScrollbar: _propTypes2.default.bool,
	  hideBottomLeftGridScrollbar: _propTypes2.default.bool
	} : {};
	
	
	(0, _reactLifecyclesCompat.polyfill)(MultiGrid);
	
	exports.default = MultiGrid;

/***/ }),

/***/ 1160:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MultiGrid = undefined;
	
	var _MultiGrid = __webpack_require__(1159);
	
	var _MultiGrid2 = _interopRequireDefault(_MultiGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MultiGrid2.default;
	exports.MultiGrid = _MultiGrid2.default;

/***/ }),

/***/ 1161:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
	 */
	var ScrollSync = function (_React$PureComponent) {
	  (0, _inherits3.default)(ScrollSync, _React$PureComponent);
	
	  function ScrollSync(props, context) {
	    (0, _classCallCheck3.default)(this, ScrollSync);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ScrollSync.__proto__ || (0, _getPrototypeOf2.default)(ScrollSync)).call(this, props, context));
	
	    _this.state = {
	      clientHeight: 0,
	      clientWidth: 0,
	      scrollHeight: 0,
	      scrollLeft: 0,
	      scrollTop: 0,
	      scrollWidth: 0
	    };
	
	    _this._onScroll = _this._onScroll.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ScrollSync, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var _state = this.state,
	          clientHeight = _state.clientHeight,
	          clientWidth = _state.clientWidth,
	          scrollHeight = _state.scrollHeight,
	          scrollLeft = _state.scrollLeft,
	          scrollTop = _state.scrollTop,
	          scrollWidth = _state.scrollWidth;
	
	
	      return children({
	        clientHeight: clientHeight,
	        clientWidth: clientWidth,
	        onScroll: this._onScroll,
	        scrollHeight: scrollHeight,
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        scrollWidth: scrollWidth
	      });
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref) {
	      var clientHeight = _ref.clientHeight,
	          clientWidth = _ref.clientWidth,
	          scrollHeight = _ref.scrollHeight,
	          scrollLeft = _ref.scrollLeft,
	          scrollTop = _ref.scrollTop,
	          scrollWidth = _ref.scrollWidth;
	
	      this.setState({
	        clientHeight: clientHeight,
	        clientWidth: clientWidth,
	        scrollHeight: scrollHeight,
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        scrollWidth: scrollWidth
	      });
	    }
	  }]);
	  return ScrollSync;
	}(React.PureComponent);
	
	exports.default = ScrollSync;
	ScrollSync.propTypes =  false ? {
	  /**
	   * Function responsible for rendering 2 or more virtualized components.
	   * This function should implement the following signature:
	   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
	   */
	  children: _propTypes2.default.func.isRequired
	} : {};

/***/ }),

/***/ 1162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScrollSync = undefined;
	
	var _ScrollSync = __webpack_require__(1161);
	
	var _ScrollSync2 = _interopRequireDefault(_ScrollSync);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ScrollSync2.default;
	exports.ScrollSync = _ScrollSync2.default;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _defaultHeaderRenderer = __webpack_require__(488);
	
	var _defaultHeaderRenderer2 = _interopRequireDefault(_defaultHeaderRenderer);
	
	var _defaultCellRenderer = __webpack_require__(487);
	
	var _defaultCellRenderer2 = _interopRequireDefault(_defaultCellRenderer);
	
	var _defaultCellDataGetter = __webpack_require__(486);
	
	var _defaultCellDataGetter2 = _interopRequireDefault(_defaultCellDataGetter);
	
	var _SortDirection = __webpack_require__(210);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Describes the header and cell contents of a table column.
	 */
	var Column = function (_React$Component) {
	  (0, _inherits3.default)(Column, _React$Component);
	
	  function Column() {
	    (0, _classCallCheck3.default)(this, Column);
	    return (0, _possibleConstructorReturn3.default)(this, (Column.__proto__ || (0, _getPrototypeOf2.default)(Column)).apply(this, arguments));
	  }
	
	  return Column;
	}(React.Component);
	
	Column.defaultProps = {
	  cellDataGetter: _defaultCellDataGetter2.default,
	  cellRenderer: _defaultCellRenderer2.default,
	  defaultSortDirection: _SortDirection2.default.ASC,
	  flexGrow: 0,
	  flexShrink: 1,
	  headerRenderer: _defaultHeaderRenderer2.default,
	  style: {}
	};
	exports.default = Column;
	Column.propTypes =  false ? {
	  /** Optional aria-label value to set on the column header */
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * Callback responsible for returning a cell's data, given its :dataKey
	   * ({ columnData: any, dataKey: string, rowData: any }): any
	   */
	  cellDataGetter: _propTypes2.default.func,
	
	  /**
	   * Callback responsible for rendering a cell's contents.
	   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
	   */
	  cellRenderer: _propTypes2.default.func,
	
	  /** Optional CSS class to apply to cell */
	  className: _propTypes2.default.string,
	
	  /** Optional additional data passed to this column's :cellDataGetter */
	  columnData: _propTypes2.default.object,
	
	  /** Uniquely identifies the row-data attribute corresponding to this cell */
	  dataKey: _propTypes2.default.any.isRequired,
	
	  /** Optional direction to be used when clicked the first time */
	  defaultSortDirection: _propTypes2.default.oneOf([_SortDirection2.default.ASC, _SortDirection2.default.DESC]),
	
	  /** If sort is enabled for the table at large, disable it for this column */
	  disableSort: _propTypes2.default.bool,
	
	  /** Flex grow style; defaults to 0 */
	  flexGrow: _propTypes2.default.number,
	
	  /** Flex shrink style; defaults to 1 */
	  flexShrink: _propTypes2.default.number,
	
	  /** Optional CSS class to apply to this column's header */
	  headerClassName: _propTypes2.default.string,
	
	  /**
	   * Optional callback responsible for rendering a column header contents.
	   * ({ columnData: object, dataKey: string, disableSort: boolean, label: node, sortBy: string, sortDirection: string }): PropTypes.node
	   */
	  headerRenderer: _propTypes2.default.func.isRequired,
	
	  /** Optional inline style to apply to this column's header */
	  headerStyle: _propTypes2.default.object,
	
	  /** Optional id to set on the column header */
	  id: _propTypes2.default.string,
	
	  /** Header label for this column */
	  label: _propTypes2.default.node,
	
	  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
	  maxWidth: _propTypes2.default.number,
	
	  /** Minimum width of column. */
	  minWidth: _propTypes2.default.number,
	
	  /** Optional inline style to apply to cell */
	  style: _propTypes2.default.object,
	
	  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
	  width: _propTypes2.default.number.isRequired
	} : {};

/***/ }),

/***/ 210:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SortDirection = {
	  /**
	   * Sort items in ascending order.
	   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
	   */
	  ASC: 'ASC',
	
	  /**
	   * Sort items in descending order.
	   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
	   */
	  DESC: 'DESC'
	};
	
	exports.default = SortDirection;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SortIndicator;
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _SortDirection = __webpack_require__(210);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Displayed beside a header to indicate that a Table is currently sorted by this column.
	 */
	function SortIndicator(_ref) {
	  var sortDirection = _ref.sortDirection;
	
	  var classNames = (0, _classnames2.default)('ReactVirtualized__Table__sortableHeaderIcon', {
	    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === _SortDirection2.default.ASC,
	    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === _SortDirection2.default.DESC
	  });
	
	  return React.createElement(
	    'svg',
	    { className: classNames, width: 18, height: 18, viewBox: '0 0 24 24' },
	    sortDirection === _SortDirection2.default.ASC ? React.createElement('path', { d: 'M7 14l5-5 5 5z' }) : React.createElement('path', { d: 'M7 10l5 5 5-5z' }),
	    React.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
	  );
	}
	
	SortIndicator.propTypes =  false ? {
	  sortDirection: _propTypes2.default.oneOf([_SortDirection2.default.ASC, _SortDirection2.default.DESC])
	} : {};

/***/ }),

/***/ 1163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Column = __webpack_require__(484);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(43);
	
	var _Grid2 = __webpack_require__(169);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _defaultRowRenderer = __webpack_require__(490);
	
	var _defaultRowRenderer2 = _interopRequireDefault(_defaultRowRenderer);
	
	var _defaultHeaderRowRenderer = __webpack_require__(489);
	
	var _defaultHeaderRowRenderer2 = _interopRequireDefault(_defaultHeaderRowRenderer);
	
	var _SortDirection = __webpack_require__(210);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
	 * This component expects explicit width, height, and padding parameters.
	 */
	var Table = function (_React$PureComponent) {
	  (0, _inherits3.default)(Table, _React$PureComponent);
	
	  function Table(props) {
	    (0, _classCallCheck3.default)(this, Table);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call(this, props));
	
	    _this.state = {
	      scrollbarWidth: 0
	    };
	
	    _this._createColumn = _this._createColumn.bind(_this);
	    _this._createRow = _this._createRow.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    _this._setRef = _this._setRef.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Table, [{
	    key: 'forceUpdateGrid',
	    value: function forceUpdateGrid() {
	      if (this.Grid) {
	        this.Grid.forceUpdate();
	      }
	    }
	
	    /** See Grid#getOffsetForCell */
	
	  }, {
	    key: 'getOffsetForRow',
	    value: function getOffsetForRow(_ref) {
	      var alignment = _ref.alignment,
	          index = _ref.index;
	
	      if (this.Grid) {
	        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
	          alignment: alignment,
	          rowIndex: index
	        }),
	            scrollTop = _Grid$getOffsetForCel.scrollTop;
	
	        return scrollTop;
	      }
	      return 0;
	    }
	
	    /** CellMeasurer compatibility */
	
	  }, {
	    key: 'invalidateCellSizeAfterRender',
	    value: function invalidateCellSizeAfterRender(_ref2) {
	      var columnIndex = _ref2.columnIndex,
	          rowIndex = _ref2.rowIndex;
	
	      if (this.Grid) {
	        this.Grid.invalidateCellSizeAfterRender({
	          rowIndex: rowIndex,
	          columnIndex: columnIndex
	        });
	      }
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      if (this.Grid) {
	        this.Grid.measureAllCells();
	      }
	    }
	
	    /** CellMeasurer compatibility */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref3$columnIndex = _ref3.columnIndex,
	          columnIndex = _ref3$columnIndex === undefined ? 0 : _ref3$columnIndex,
	          _ref3$rowIndex = _ref3.rowIndex,
	          rowIndex = _ref3$rowIndex === undefined ? 0 : _ref3$rowIndex;
	
	      if (this.Grid) {
	        this.Grid.recomputeGridSize({
	          rowIndex: rowIndex,
	          columnIndex: columnIndex
	        });
	      }
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeRowHeights',
	    value: function recomputeRowHeights() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.recomputeGridSize({
	          rowIndex: index
	        });
	      }
	    }
	
	    /** See Grid#scrollToPosition */
	
	  }, {
	    key: 'scrollToPosition',
	    value: function scrollToPosition() {
	      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.scrollToPosition({ scrollTop: scrollTop });
	      }
	    }
	
	    /** See Grid#scrollToCell */
	
	  }, {
	    key: 'scrollToRow',
	    value: function scrollToRow() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.scrollToCell({
	          columnIndex: 0,
	          rowIndex: index
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._setScrollbarWidth();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._setScrollbarWidth();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          disableHeader = _props.disableHeader,
	          gridClassName = _props.gridClassName,
	          gridStyle = _props.gridStyle,
	          headerHeight = _props.headerHeight,
	          headerRowRenderer = _props.headerRowRenderer,
	          height = _props.height,
	          id = _props.id,
	          noRowsRenderer = _props.noRowsRenderer,
	          rowClassName = _props.rowClassName,
	          rowStyle = _props.rowStyle,
	          scrollToIndex = _props.scrollToIndex,
	          style = _props.style,
	          width = _props.width;
	      var scrollbarWidth = this.state.scrollbarWidth;
	
	
	      var availableRowsHeight = disableHeader ? height : height - headerHeight;
	
	      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: -1 }) : rowClassName;
	      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: -1 }) : rowStyle;
	
	      // Precompute and cache column styles before rendering rows and columns to speed things up
	      this._cachedColumnStyles = [];
	      React.Children.toArray(children).forEach(function (column, index) {
	        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);
	
	        _this2._cachedColumnStyles[index] = (0, _extends3.default)({}, flexStyles, {
	          overflow: 'hidden'
	        });
	      });
	
	      // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
	      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
	      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
	      return React.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('ReactVirtualized__Table', className),
	          id: id,
	          role: 'grid',
	          style: style },
	        !disableHeader && headerRowRenderer({
	          className: (0, _classnames2.default)('ReactVirtualized__Table__headerRow', rowClass),
	          columns: this._getHeaderColumns(),
	          style: (0, _extends3.default)({}, rowStyleObject, {
	            height: headerHeight,
	            overflow: 'hidden',
	            paddingRight: scrollbarWidth,
	            width: width
	          })
	        }),
	        React.createElement(_Grid3.default, (0, _extends3.default)({}, this.props, {
	          autoContainerWidth: true,
	          className: (0, _classnames2.default)('ReactVirtualized__Table__Grid', gridClassName),
	          cellRenderer: this._createRow,
	          columnWidth: width,
	          columnCount: 1,
	          height: availableRowsHeight,
	          id: undefined,
	          noContentRenderer: noRowsRenderer,
	          onScroll: this._onScroll,
	          onSectionRendered: this._onSectionRendered,
	          ref: this._setRef,
	          role: 'rowgroup',
	          scrollbarWidth: scrollbarWidth,
	          scrollToRow: scrollToIndex,
	          style: (0, _extends3.default)({}, gridStyle, {
	            overflowX: 'hidden'
	          })
	        }))
	      );
	    }
	  }, {
	    key: '_createColumn',
	    value: function _createColumn(_ref4) {
	      var column = _ref4.column,
	          columnIndex = _ref4.columnIndex,
	          isScrolling = _ref4.isScrolling,
	          parent = _ref4.parent,
	          rowData = _ref4.rowData,
	          rowIndex = _ref4.rowIndex;
	      var _column$props = column.props,
	          cellDataGetter = _column$props.cellDataGetter,
	          cellRenderer = _column$props.cellRenderer,
	          className = _column$props.className,
	          columnData = _column$props.columnData,
	          dataKey = _column$props.dataKey,
	          id = _column$props.id;
	
	
	      var cellData = cellDataGetter({ columnData: columnData, dataKey: dataKey, rowData: rowData });
	      var renderedCell = cellRenderer({
	        cellData: cellData,
	        columnData: columnData,
	        columnIndex: columnIndex,
	        dataKey: dataKey,
	        isScrolling: isScrolling,
	        parent: parent,
	        rowData: rowData,
	        rowIndex: rowIndex
	      });
	
	      var style = this._cachedColumnStyles[columnIndex];
	
	      var title = typeof renderedCell === 'string' ? renderedCell : null;
	
	      // Avoid using object-spread syntax with multiple objects here,
	      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
	      // See PR https://github.com/bvaughn/react-virtualized/pull/942
	      return React.createElement(
	        'div',
	        {
	          'aria-describedby': id,
	          className: (0, _classnames2.default)('ReactVirtualized__Table__rowColumn', className),
	          key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
	          role: 'gridcell',
	          style: style,
	          title: title },
	        renderedCell
	      );
	    }
	  }, {
	    key: '_createHeader',
	    value: function _createHeader(_ref5) {
	      var column = _ref5.column,
	          index = _ref5.index;
	      var _props2 = this.props,
	          headerClassName = _props2.headerClassName,
	          headerStyle = _props2.headerStyle,
	          onHeaderClick = _props2.onHeaderClick,
	          sort = _props2.sort,
	          sortBy = _props2.sortBy,
	          sortDirection = _props2.sortDirection;
	      var _column$props2 = column.props,
	          columnData = _column$props2.columnData,
	          dataKey = _column$props2.dataKey,
	          defaultSortDirection = _column$props2.defaultSortDirection,
	          disableSort = _column$props2.disableSort,
	          headerRenderer = _column$props2.headerRenderer,
	          id = _column$props2.id,
	          label = _column$props2.label;
	
	      var sortEnabled = !disableSort && sort;
	
	      var classNames = (0, _classnames2.default)('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
	        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
	      });
	      var style = this._getFlexStyleForColumn(column, (0, _extends3.default)({}, headerStyle, column.props.headerStyle));
	
	      var renderedHeader = headerRenderer({
	        columnData: columnData,
	        dataKey: dataKey,
	        disableSort: disableSort,
	        label: label,
	        sortBy: sortBy,
	        sortDirection: sortDirection
	      });
	
	      var headerOnClick = void 0,
	          headerOnKeyDown = void 0,
	          headerTabIndex = void 0,
	          headerAriaSort = void 0,
	          headerAriaLabel = void 0;
	
	      if (sortEnabled || onHeaderClick) {
	        // If this is a sortable header, clicking it should update the table data's sorting.
	        var isFirstTimeSort = sortBy !== dataKey;
	
	        // If this is the firstTime sort of this column, use the column default sort order.
	        // Otherwise, invert the direction of the sort.
	        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === _SortDirection2.default.DESC ? _SortDirection2.default.ASC : _SortDirection2.default.DESC;
	
	        var onClick = function onClick(event) {
	          sortEnabled && sort({
	            defaultSortDirection: defaultSortDirection,
	            event: event,
	            sortBy: dataKey,
	            sortDirection: newSortDirection
	          });
	          onHeaderClick && onHeaderClick({ columnData: columnData, dataKey: dataKey, event: event });
	        };
	
	        var onKeyDown = function onKeyDown(event) {
	          if (event.key === 'Enter' || event.key === ' ') {
	            onClick(event);
	          }
	        };
	
	        headerAriaLabel = column.props['aria-label'] || label || dataKey;
	        headerTabIndex = 0;
	        headerOnClick = onClick;
	        headerOnKeyDown = onKeyDown;
	      }
	
	      if (sortBy === dataKey) {
	        headerAriaSort = sortDirection === _SortDirection2.default.ASC ? 'ascending' : 'descending';
	      }
	
	      // Avoid using object-spread syntax with multiple objects here,
	      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
	      // See PR https://github.com/bvaughn/react-virtualized/pull/942
	      return React.createElement(
	        'div',
	        {
	          'aria-label': headerAriaLabel,
	          'aria-sort': headerAriaSort,
	          className: classNames,
	          id: id,
	          key: 'Header-Col' + index,
	          onClick: headerOnClick,
	          onKeyDown: headerOnKeyDown,
	          role: 'columnheader',
	          style: style,
	          tabIndex: headerTabIndex },
	        renderedHeader
	      );
	    }
	  }, {
	    key: '_createRow',
	    value: function _createRow(_ref6) {
	      var _this3 = this;
	
	      var index = _ref6.rowIndex,
	          isScrolling = _ref6.isScrolling,
	          key = _ref6.key,
	          parent = _ref6.parent,
	          style = _ref6.style;
	      var _props3 = this.props,
	          children = _props3.children,
	          onRowClick = _props3.onRowClick,
	          onRowDoubleClick = _props3.onRowDoubleClick,
	          onRowRightClick = _props3.onRowRightClick,
	          onRowMouseOver = _props3.onRowMouseOver,
	          onRowMouseOut = _props3.onRowMouseOut,
	          rowClassName = _props3.rowClassName,
	          rowGetter = _props3.rowGetter,
	          rowRenderer = _props3.rowRenderer,
	          rowStyle = _props3.rowStyle;
	      var scrollbarWidth = this.state.scrollbarWidth;
	
	
	      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: index }) : rowClassName;
	      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: index }) : rowStyle;
	      var rowData = rowGetter({ index: index });
	
	      var columns = React.Children.toArray(children).map(function (column, columnIndex) {
	        return _this3._createColumn({
	          column: column,
	          columnIndex: columnIndex,
	          isScrolling: isScrolling,
	          parent: parent,
	          rowData: rowData,
	          rowIndex: index,
	          scrollbarWidth: scrollbarWidth
	        });
	      });
	
	      var className = (0, _classnames2.default)('ReactVirtualized__Table__row', rowClass);
	      var flattenedStyle = (0, _extends3.default)({}, style, rowStyleObject, {
	        height: this._getRowHeight(index),
	        overflow: 'hidden',
	        paddingRight: scrollbarWidth
	      });
	
	      return rowRenderer({
	        className: className,
	        columns: columns,
	        index: index,
	        isScrolling: isScrolling,
	        key: key,
	        onRowClick: onRowClick,
	        onRowDoubleClick: onRowDoubleClick,
	        onRowRightClick: onRowRightClick,
	        onRowMouseOver: onRowMouseOver,
	        onRowMouseOut: onRowMouseOut,
	        rowData: rowData,
	        style: flattenedStyle
	      });
	    }
	
	    /**
	     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
	     */
	
	  }, {
	    key: '_getFlexStyleForColumn',
	    value: function _getFlexStyleForColumn(column) {
	      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';
	
	      var style = (0, _extends3.default)({}, customStyle, {
	        flex: flexValue,
	        msFlex: flexValue,
	        WebkitFlex: flexValue
	      });
	
	      if (column.props.maxWidth) {
	        style.maxWidth = column.props.maxWidth;
	      }
	
	      if (column.props.minWidth) {
	        style.minWidth = column.props.minWidth;
	      }
	
	      return style;
	    }
	  }, {
	    key: '_getHeaderColumns',
	    value: function _getHeaderColumns() {
	      var _this4 = this;
	
	      var _props4 = this.props,
	          children = _props4.children,
	          disableHeader = _props4.disableHeader;
	
	      var items = disableHeader ? [] : React.Children.toArray(children);
	
	      return items.map(function (column, index) {
	        return _this4._createHeader({ column: column, index: index });
	      });
	    }
	  }, {
	    key: '_getRowHeight',
	    value: function _getRowHeight(rowIndex) {
	      var rowHeight = this.props.rowHeight;
	
	
	      return typeof rowHeight === 'function' ? rowHeight({ index: rowIndex }) : rowHeight;
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref7) {
	      var clientHeight = _ref7.clientHeight,
	          scrollHeight = _ref7.scrollHeight,
	          scrollTop = _ref7.scrollTop;
	      var onScroll = this.props.onScroll;
	
	
	      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref8) {
	      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
	          rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
	          rowStartIndex = _ref8.rowStartIndex,
	          rowStopIndex = _ref8.rowStopIndex;
	      var onRowsRendered = this.props.onRowsRendered;
	
	
	      onRowsRendered({
	        overscanStartIndex: rowOverscanStartIndex,
	        overscanStopIndex: rowOverscanStopIndex,
	        startIndex: rowStartIndex,
	        stopIndex: rowStopIndex
	      });
	    }
	  }, {
	    key: '_setRef',
	    value: function _setRef(ref) {
	      this.Grid = ref;
	    }
	  }, {
	    key: '_setScrollbarWidth',
	    value: function _setScrollbarWidth() {
	      if (this.Grid) {
	        var _Grid = (0, _reactDom.findDOMNode)(this.Grid);
	        var clientWidth = _Grid.clientWidth || 0;
	        var offsetWidth = _Grid.offsetWidth || 0;
	        var scrollbarWidth = offsetWidth - clientWidth;
	
	        this.setState({ scrollbarWidth: scrollbarWidth });
	      }
	    }
	  }]);
	  return Table;
	}(React.PureComponent);
	
	Table.defaultProps = {
	  disableHeader: false,
	  estimatedRowSize: 30,
	  headerHeight: 0,
	  headerStyle: {},
	  noRowsRenderer: function noRowsRenderer() {
	    return null;
	  },
	  onRowsRendered: function onRowsRendered() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  overscanIndicesGetter: _Grid2.accessibilityOverscanIndicesGetter,
	  overscanRowCount: 10,
	  rowRenderer: _defaultRowRenderer2.default,
	  headerRowRenderer: _defaultHeaderRowRenderer2.default,
	  rowStyle: {},
	  scrollToAlignment: 'auto',
	  scrollToIndex: -1,
	  style: {}
	};
	exports.default = Table;
	Table.propTypes =  false ? {
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _propTypes2.default.bool,
	
	  /** One or more Columns describing the data displayed in this row */
	  children: function children(props) {
	    var children = React.Children.toArray(props.children);
	    for (var i = 0; i < children.length; i++) {
	      var childType = children[i].type;
	      if (childType !== _Column2.default && !(childType.prototype instanceof _Column2.default)) {
	        return new Error('Table only accepts children of type Column');
	      }
	    }
	  },
	
	  /** Optional CSS class name */
	  className: _propTypes2.default.string,
	
	  /** Disable rendering the header at all */
	  disableHeader: _propTypes2.default.bool,
	
	  /**
	   * Used to estimate the total height of a Table before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _propTypes2.default.number.isRequired,
	
	  /** Optional custom CSS class name to attach to inner Grid element. */
	  gridClassName: _propTypes2.default.string,
	
	  /** Optional inline style to attach to inner Grid element. */
	  gridStyle: _propTypes2.default.object,
	
	  /** Optional CSS class to apply to all column headers */
	  headerClassName: _propTypes2.default.string,
	
	  /** Fixed height of header row */
	  headerHeight: _propTypes2.default.number.isRequired,
	
	  /**
	   * Responsible for rendering a table row given an array of columns:
	   * Should implement the following interface: ({
	   *   className: string,
	   *   columns: any[],
	   *   style: any
	   * }): PropTypes.node
	   */
	  headerRowRenderer: _propTypes2.default.func,
	
	  /** Optional custom inline style to attach to table header columns. */
	  headerStyle: _propTypes2.default.object,
	
	  /** Fixed/available height for out DOM element */
	  height: _propTypes2.default.number.isRequired,
	
	  /** Optional id */
	  id: _propTypes2.default.string,
	
	  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
	  noRowsRenderer: _propTypes2.default.func,
	
	  /**
	   * Optional callback when a column's header is clicked.
	   * ({ columnData: any, dataKey: string }): void
	   */
	  onHeaderClick: _propTypes2.default.func,
	
	  /**
	   * Callback invoked when a user clicks on a table row.
	   * ({ index: number }): void
	   */
	  onRowClick: _propTypes2.default.func,
	
	  /**
	   * Callback invoked when a user double-clicks on a table row.
	   * ({ index: number }): void
	   */
	  onRowDoubleClick: _propTypes2.default.func,
	
	  /**
	   * Callback invoked when the mouse leaves a table row.
	   * ({ index: number }): void
	   */
	  onRowMouseOut: _propTypes2.default.func,
	
	  /**
	   * Callback invoked when a user moves the mouse over a table row.
	   * ({ index: number }): void
	   */
	  onRowMouseOver: _propTypes2.default.func,
	
	  /**
	   * Callback invoked when a user right-clicks on a table row.
	   * ({ index: number }): void
	   */
	  onRowRightClick: _propTypes2.default.func,
	
	  /**
	   * Callback invoked with information about the slice of rows that were just rendered.
	   * ({ startIndex, stopIndex }): void
	   */
	  onRowsRendered: _propTypes2.default.func,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, scrollHeight, scrollTop }): void
	   */
	  onScroll: _propTypes2.default.func.isRequired,
	
	  /** See Grid#overscanIndicesGetter */
	  overscanIndicesGetter: _propTypes2.default.func.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible bounds of the list.
	   * These rows can help for smoother scrolling on touch devices.
	   */
	  overscanRowCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Optional CSS class to apply to all table rows (including the header row).
	   * This property can be a CSS class name (string) or a function that returns a class name.
	   * If a function is provided its signature should be: ({ index: number }): string
	   */
	  rowClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * Callback responsible for returning a data row given an index.
	   * ({ index: number }): any
	   */
	  rowGetter: _propTypes2.default.func.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * ({ index: number }): number
	   */
	  rowHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,
	
	  /** Number of rows in table. */
	  rowCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Responsible for rendering a table row given an array of columns:
	   * Should implement the following interface: ({
	   *   className: string,
	   *   columns: Array,
	   *   index: number,
	   *   isScrolling: boolean,
	   *   onRowClick: ?Function,
	   *   onRowDoubleClick: ?Function,
	   *   onRowMouseOver: ?Function,
	   *   onRowMouseOut: ?Function,
	   *   rowData: any,
	   *   style: any
	   * }): PropTypes.node
	   */
	  rowRenderer: _propTypes2.default.func,
	
	  /** Optional custom inline style to attach to table rows. */
	  rowStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]).isRequired,
	
	  /** See Grid#scrollToAlignment */
	  scrollToAlignment: _propTypes2.default.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToIndex: _propTypes2.default.number.isRequired,
	
	  /** Vertical offset. */
	  scrollTop: _propTypes2.default.number,
	
	  /**
	   * Sort function to be called if a sortable header is clicked.
	   * Should implement the following interface: ({
	   *   defaultSortDirection: 'ASC' | 'DESC',
	   *   event: MouseEvent,
	   *   sortBy: string,
	   *   sortDirection: SortDirection
	   * }): void
	   */
	  sort: _propTypes2.default.func,
	
	  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
	  sortBy: _propTypes2.default.string,
	
	  /** Table data is currently sorted in this direction (if it is sorted at all) */
	  sortDirection: _propTypes2.default.oneOf([_SortDirection2.default.ASC, _SortDirection2.default.DESC]),
	
	  /** Optional inline style */
	  style: _propTypes2.default.object,
	
	  /** Tab index for focus */
	  tabIndex: _propTypes2.default.number,
	
	  /** Width of list */
	  width: _propTypes2.default.number.isRequired
	} : {};

/***/ }),

/***/ 1164:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMultiSort;
	function createMultiSort(sortCallback) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      defaultSortBy = _ref.defaultSortBy,
	      _ref$defaultSortDirec = _ref.defaultSortDirection,
	      defaultSortDirection = _ref$defaultSortDirec === undefined ? {} : _ref$defaultSortDirec;
	
	  if (!sortCallback) {
	    throw Error('Required parameter "sortCallback" not specified');
	  }
	
	  var sortBy = defaultSortBy || [];
	  var sortDirection = {};
	
	  sortBy.forEach(function (dataKey) {
	    sortDirection[dataKey] = defaultSortDirection.hasOwnProperty(dataKey) ? defaultSortDirection[dataKey] : 'ASC';
	  });
	
	  function sort(_ref2) {
	    var defaultSortDirection = _ref2.defaultSortDirection,
	        event = _ref2.event,
	        dataKey = _ref2.sortBy;
	
	    if (event.shiftKey) {
	      // Shift + click appends a column to existing criteria
	      if (sortDirection.hasOwnProperty(dataKey)) {
	        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
	      } else {
	        sortDirection[dataKey] = defaultSortDirection;
	        sortBy.push(dataKey);
	      }
	    } else if (event.ctrlKey || event.metaKey) {
	      // Control + click removes column from sort (if pressent)
	      var index = sortBy.indexOf(dataKey);
	      if (index >= 0) {
	        sortBy.splice(index, 1);
	        delete sortDirection[dataKey];
	      }
	    } else {
	      sortBy.length = 0;
	      sortBy.push(dataKey);
	
	      if (sortDirection.hasOwnProperty(dataKey)) {
	        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
	      } else {
	        sortDirection[dataKey] = defaultSortDirection;
	      }
	    }
	
	    // Notify application code
	    sortCallback({
	      sortBy: sortBy,
	      sortDirection: sortDirection
	    });
	  }
	
	  return {
	    sort: sort,
	    sortBy: sortBy,
	    sortDirection: sortDirection
	  };
	}

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellDataGetter;
	
	var _types = __webpack_require__(170);
	
	/**
	 * Default accessor for returning a cell value for a given attribute.
	 * This function expects to operate on either a vanilla Object or an Immutable Map.
	 * You should override the column's cellDataGetter if your data is some other type of object.
	 */
	function defaultCellDataGetter(_ref) {
	  var dataKey = _ref.dataKey,
	      rowData = _ref.rowData;
	
	  if (typeof rowData.get === 'function') {
	    return rowData.get(dataKey);
	  } else {
	    return rowData[dataKey];
	  }
	}

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellRenderer;
	
	var _types = __webpack_require__(170);
	
	/**
	 * Default cell renderer that displays an attribute as a simple string
	 * You should override the column's cellRenderer if your data is some other type of object.
	 */
	function defaultCellRenderer(_ref) {
	  var cellData = _ref.cellData;
	
	  if (cellData == null) {
	    return '';
	  } else {
	    return String(cellData);
	  }
	}

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultHeaderRenderer;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _SortIndicator = __webpack_require__(485);
	
	var _SortIndicator2 = _interopRequireDefault(_SortIndicator);
	
	var _types = __webpack_require__(170);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Default table header renderer.
	 */
	function defaultHeaderRenderer(_ref) {
	  var dataKey = _ref.dataKey,
	      label = _ref.label,
	      sortBy = _ref.sortBy,
	      sortDirection = _ref.sortDirection;
	
	  var showSortIndicator = sortBy === dataKey;
	  var children = [React.createElement(
	    'span',
	    {
	      className: 'ReactVirtualized__Table__headerTruncatedText',
	      key: 'label',
	      title: label },
	    label
	  )];
	
	  if (showSortIndicator) {
	    children.push(React.createElement(_SortIndicator2.default, { key: 'SortIndicator', sortDirection: sortDirection }));
	  }
	
	  return children;
	}
	defaultHeaderRenderer.propTypes =  true ? null : _types.bpfrpt_proptype_HeaderRendererParams === _propTypes2.default.any ? {} : _types.bpfrpt_proptype_HeaderRendererParams;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultHeaderRowRenderer;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _types = __webpack_require__(170);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function defaultHeaderRowRenderer(_ref) {
	  var className = _ref.className,
	      columns = _ref.columns,
	      style = _ref.style;
	
	  return React.createElement(
	    'div',
	    { className: className, role: 'row', style: style },
	    columns
	  );
	}
	defaultHeaderRowRenderer.propTypes =  true ? null : _types.bpfrpt_proptype_HeaderRowRendererParams === _propTypes2.default.any ? {} : _types.bpfrpt_proptype_HeaderRowRendererParams;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = defaultRowRenderer;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _types = __webpack_require__(170);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default row renderer for Table.
	 */
	function defaultRowRenderer(_ref) {
	  var className = _ref.className,
	      columns = _ref.columns,
	      index = _ref.index,
	      key = _ref.key,
	      onRowClick = _ref.onRowClick,
	      onRowDoubleClick = _ref.onRowDoubleClick,
	      onRowMouseOut = _ref.onRowMouseOut,
	      onRowMouseOver = _ref.onRowMouseOver,
	      onRowRightClick = _ref.onRowRightClick,
	      rowData = _ref.rowData,
	      style = _ref.style;
	
	  var a11yProps = {};
	
	  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
	    a11yProps['aria-label'] = 'row';
	    a11yProps.tabIndex = 0;
	
	    if (onRowClick) {
	      a11yProps.onClick = function (event) {
	        return onRowClick({ event: event, index: index, rowData: rowData });
	      };
	    }
	    if (onRowDoubleClick) {
	      a11yProps.onDoubleClick = function (event) {
	        return onRowDoubleClick({ event: event, index: index, rowData: rowData });
	      };
	    }
	    if (onRowMouseOut) {
	      a11yProps.onMouseOut = function (event) {
	        return onRowMouseOut({ event: event, index: index, rowData: rowData });
	      };
	    }
	    if (onRowMouseOver) {
	      a11yProps.onMouseOver = function (event) {
	        return onRowMouseOver({ event: event, index: index, rowData: rowData });
	      };
	    }
	    if (onRowRightClick) {
	      a11yProps.onContextMenu = function (event) {
	        return onRowRightClick({ event: event, index: index, rowData: rowData });
	      };
	    }
	  }
	
	  return React.createElement(
	    'div',
	    (0, _extends3.default)({}, a11yProps, {
	      className: className,
	      key: key,
	      role: 'row',
	      style: style }),
	    columns
	  );
	}
	defaultRowRenderer.propTypes =  true ? null : _types.bpfrpt_proptype_RowRendererParams === _propTypes2.default.any ? {} : _types.bpfrpt_proptype_RowRendererParams;

/***/ }),

/***/ 1165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Table = exports.SortIndicator = exports.SortDirection = exports.Column = exports.defaultRowRenderer = exports.defaultHeaderRenderer = exports.defaultHeaderRowRenderer = exports.defaultCellRenderer = exports.defaultCellDataGetter = exports.createMultiSort = undefined;
	
	var _createMultiSort = __webpack_require__(1164);
	
	var _createMultiSort2 = _interopRequireDefault(_createMultiSort);
	
	var _defaultCellDataGetter = __webpack_require__(486);
	
	var _defaultCellDataGetter2 = _interopRequireDefault(_defaultCellDataGetter);
	
	var _defaultCellRenderer = __webpack_require__(487);
	
	var _defaultCellRenderer2 = _interopRequireDefault(_defaultCellRenderer);
	
	var _defaultHeaderRowRenderer = __webpack_require__(489);
	
	var _defaultHeaderRowRenderer2 = _interopRequireDefault(_defaultHeaderRowRenderer);
	
	var _defaultHeaderRenderer = __webpack_require__(488);
	
	var _defaultHeaderRenderer2 = _interopRequireDefault(_defaultHeaderRenderer);
	
	var _defaultRowRenderer = __webpack_require__(490);
	
	var _defaultRowRenderer2 = _interopRequireDefault(_defaultRowRenderer);
	
	var _Column = __webpack_require__(484);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _SortDirection = __webpack_require__(210);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	var _SortIndicator = __webpack_require__(485);
	
	var _SortIndicator2 = _interopRequireDefault(_SortIndicator);
	
	var _Table = __webpack_require__(1163);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Table2.default;
	exports.createMultiSort = _createMultiSort2.default;
	exports.defaultCellDataGetter = _defaultCellDataGetter2.default;
	exports.defaultCellRenderer = _defaultCellRenderer2.default;
	exports.defaultHeaderRowRenderer = _defaultHeaderRowRenderer2.default;
	exports.defaultHeaderRenderer = _defaultHeaderRenderer2.default;
	exports.defaultRowRenderer = _defaultRowRenderer2.default;
	exports.Column = _Column2.default;
	exports.SortDirection = _SortDirection2.default;
	exports.SortIndicator = _SortIndicator2.default;
	exports.Table = _Table2.default;

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bpfrpt_proptype_RowRendererParams = exports.bpfrpt_proptype_HeaderRendererParams = exports.bpfrpt_proptype_HeaderRowRendererParams = exports.bpfrpt_proptype_CellRendererParams = exports.bpfrpt_proptype_CellDataGetterParams = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bpfrpt_proptype_CellDataGetterParams =  true ? null : {
	  columnData: _propTypes2.default.any,
	  dataKey: _propTypes2.default.string.isRequired,
	  rowData: function rowData(props, propName, componentName) {
	    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
	      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
	    }
	  }
	};
	var bpfrpt_proptype_CellRendererParams =  true ? null : {
	  cellData: _propTypes2.default.any,
	  columnData: _propTypes2.default.any,
	  dataKey: _propTypes2.default.string.isRequired,
	  rowData: function rowData(props, propName, componentName) {
	    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
	      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
	    }
	  },
	  rowIndex: _propTypes2.default.number.isRequired
	};
	var bpfrpt_proptype_HeaderRowRendererParams =  true ? null : {
	  className: _propTypes2.default.string.isRequired,
	  columns: _propTypes2.default.arrayOf(function (props, propName, componentName) {
	    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
	      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
	    }
	  }).isRequired,
	  style: function style(props, propName, componentName) {
	    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
	      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
	    }
	  }
	};
	var bpfrpt_proptype_HeaderRendererParams =  true ? null : {
	  columnData: _propTypes2.default.any,
	  dataKey: _propTypes2.default.string.isRequired,
	  disableSort: _propTypes2.default.bool,
	  label: _propTypes2.default.any,
	  sortBy: _propTypes2.default.string,
	  sortDirection: _propTypes2.default.string
	};
	var bpfrpt_proptype_RowRendererParams =  true ? null : {
	  className: _propTypes2.default.string.isRequired,
	  columns: _propTypes2.default.arrayOf(function (props, propName, componentName) {
	    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
	      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
	    }
	  }).isRequired,
	  index: _propTypes2.default.number.isRequired,
	  isScrolling: _propTypes2.default.bool.isRequired,
	  onRowClick: _propTypes2.default.func,
	  onRowDoubleClick: _propTypes2.default.func,
	  onRowMouseOver: _propTypes2.default.func,
	  onRowMouseOut: _propTypes2.default.func,
	  rowData: function rowData(props, propName, componentName) {
	    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
	      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
	    }
	  },
	  style: function style(props, propName, componentName) {
	    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
	      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
	    }
	  }
	};
	exports.bpfrpt_proptype_CellDataGetterParams = bpfrpt_proptype_CellDataGetterParams;
	exports.bpfrpt_proptype_CellRendererParams = bpfrpt_proptype_CellRendererParams;
	exports.bpfrpt_proptype_HeaderRowRendererParams = bpfrpt_proptype_HeaderRowRendererParams;
	exports.bpfrpt_proptype_HeaderRendererParams = bpfrpt_proptype_HeaderRendererParams;
	exports.bpfrpt_proptype_RowRendererParams = bpfrpt_proptype_RowRendererParams;

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IS_SCROLLING_TIMEOUT = undefined;
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(19);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(43);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _onScroll = __webpack_require__(1168);
	
	var _dimensions = __webpack_require__(1167);
	
	var _detectElementResize = __webpack_require__(493);
	
	var _detectElementResize2 = _interopRequireDefault(_detectElementResize);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var IS_SCROLLING_TIMEOUT = exports.IS_SCROLLING_TIMEOUT = 150;
	
	var getWindow = function getWindow() {
	  return typeof window !== 'undefined' ? window : undefined;
	};
	
	var WindowScroller = function (_React$PureComponent) {
	  (0, _inherits3.default)(WindowScroller, _React$PureComponent);
	
	  function WindowScroller() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, WindowScroller);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WindowScroller.__proto__ || (0, _getPrototypeOf2.default)(WindowScroller)).call.apply(_ref, [this].concat(args))), _this), _this._window = getWindow(), _this._isMounted = false, _this._positionFromTop = 0, _this._positionFromLeft = 0, _this.state = (0, _extends3.default)({}, (0, _dimensions.getDimensions)(_this.props.scrollElement, _this.props), {
	      isScrolling: false,
	      scrollLeft: 0,
	      scrollTop: 0
	    }), _this._registerChild = function (element) {
	      if (element && !(element instanceof Element)) {
	        console.warn('WindowScroller registerChild expects to be passed Element or null');
	      }
	      _this._child = element;
	      _this.updatePosition();
	    }, _this._onChildScroll = function (_ref2) {
	      var scrollTop = _ref2.scrollTop;
	
	      if (_this.state.scrollTop === scrollTop) {
	        return;
	      }
	
	      var scrollElement = _this.props.scrollElement;
	      if (scrollElement) {
	        if (typeof scrollElement.scrollTo === 'function') {
	          scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
	        } else {
	          scrollElement.scrollTop = scrollTop + _this._positionFromTop;
	        }
	      }
	    }, _this._registerResizeListener = function (element) {
	      if (element === window) {
	        window.addEventListener('resize', _this._onResize, false);
	      } else {
	        _this._detectElementResize.addResizeListener(element, _this._onResize);
	      }
	    }, _this._unregisterResizeListener = function (element) {
	      if (element === window) {
	        window.removeEventListener('resize', _this._onResize, false);
	      } else if (element) {
	        _this._detectElementResize.removeResizeListener(element, _this._onResize);
	      }
	    }, _this._onResize = function () {
	      _this.updatePosition();
	    }, _this.__handleWindowScrollEvent = function () {
	      if (!_this._isMounted) {
	        return;
	      }
	
	      var onScroll = _this.props.onScroll;
	
	
	      var scrollElement = _this.props.scrollElement;
	      if (scrollElement) {
	        var scrollOffset = (0, _dimensions.getScrollOffset)(scrollElement);
	        var _scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
	        var _scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);
	
	        _this.setState({
	          isScrolling: true,
	          scrollLeft: _scrollLeft,
	          scrollTop: _scrollTop
	        });
	
	        onScroll({
	          scrollLeft: _scrollLeft,
	          scrollTop: _scrollTop
	        });
	      }
	    }, _this.__resetIsScrolling = function () {
	      _this.setState({
	        isScrolling: false
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(WindowScroller, [{
	    key: 'updatePosition',
	    value: function updatePosition() {
	      var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
	      var onResize = this.props.onResize;
	      var _state = this.state,
	          height = _state.height,
	          width = _state.width;
	
	
	      var thisNode = this._child || ReactDOM.findDOMNode(this);
	      if (thisNode instanceof Element && scrollElement) {
	        var offset = (0, _dimensions.getPositionOffset)(thisNode, scrollElement);
	        this._positionFromTop = offset.top;
	        this._positionFromLeft = offset.left;
	      }
	
	      var dimensions = (0, _dimensions.getDimensions)(scrollElement, this.props);
	      if (height !== dimensions.height || width !== dimensions.width) {
	        this.setState({
	          height: dimensions.height,
	          width: dimensions.width
	        });
	        onResize({
	          height: dimensions.height,
	          width: dimensions.width
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var scrollElement = this.props.scrollElement;
	
	      this._detectElementResize = (0, _detectElementResize2.default)();
	
	      this.updatePosition(scrollElement);
	
	      if (scrollElement) {
	        (0, _onScroll.registerScrollListener)(this, scrollElement);
	        this._registerResizeListener(scrollElement);
	      }
	
	      this._isMounted = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var scrollElement = this.props.scrollElement;
	      var prevScrollElement = prevProps.scrollElement;
	
	
	      if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
	        this.updatePosition(scrollElement);
	
	        (0, _onScroll.unregisterScrollListener)(this, prevScrollElement);
	        (0, _onScroll.registerScrollListener)(this, scrollElement);
	
	        this._unregisterResizeListener(prevScrollElement);
	        this._registerResizeListener(scrollElement);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var scrollElement = this.props.scrollElement;
	      if (scrollElement) {
	        (0, _onScroll.unregisterScrollListener)(this, scrollElement);
	        this._unregisterResizeListener(scrollElement);
	      }
	
	      this._isMounted = false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var _state2 = this.state,
	          isScrolling = _state2.isScrolling,
	          scrollTop = _state2.scrollTop,
	          scrollLeft = _state2.scrollLeft,
	          height = _state2.height,
	          width = _state2.width;
	
	
	      return children({
	        onChildScroll: this._onChildScroll,
	        registerChild: this._registerChild,
	        height: height,
	        isScrolling: isScrolling,
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        width: width
	      });
	    }
	
	    // Referenced by utils/onScroll
	
	
	    // Referenced by utils/onScroll
	
	  }]);
	  return WindowScroller;
	}(React.PureComponent);
	
	WindowScroller.defaultProps = {
	  onResize: function onResize() {},
	  onScroll: function onScroll() {},
	  scrollingResetTimeInterval: IS_SCROLLING_TIMEOUT,
	  scrollElement: getWindow(),
	  serverHeight: 0,
	  serverWidth: 0
	};
	WindowScroller.propTypes =  true ? null : {
	  /**
	   * Function responsible for rendering children.
	   * This function should implement the following signature:
	   * ({ height, isScrolling, scrollLeft, scrollTop, width }) => PropTypes.element
	   */
	  children: _propTypes2.default.func.isRequired,
	
	
	  /** Callback to be invoked on-resize: ({ height, width }) */
	  onResize: _propTypes2.default.func.isRequired,
	
	
	  /** Callback to be invoked on-scroll: ({ scrollLeft, scrollTop }) */
	  onScroll: _propTypes2.default.func.isRequired,
	
	
	  /** Element to attach scroll event listeners. Defaults to window. */
	  scrollElement: _propTypes2.default.oneOfType([_propTypes2.default.any, function () {
	    return (typeof Element === 'function' ? _propTypes2.default.instanceOf(Element) : _propTypes2.default.any).apply(this, arguments);
	  }]),
	
	  /**
	   * Wait this amount of time after the last scroll event before resetting child `pointer-events`.
	   */
	  scrollingResetTimeInterval: _propTypes2.default.number.isRequired,
	
	
	  /** Height used for server-side rendering */
	  serverHeight: _propTypes2.default.number.isRequired,
	
	
	  /** Width used for server-side rendering */
	  serverWidth: _propTypes2.default.number.isRequired
	};
	exports.default = WindowScroller;

/***/ }),

/***/ 1166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IS_SCROLLING_TIMEOUT = exports.WindowScroller = undefined;
	
	var _WindowScroller = __webpack_require__(491);
	
	var _WindowScroller2 = _interopRequireDefault(_WindowScroller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _WindowScroller2.default;
	exports.WindowScroller = _WindowScroller2.default;
	exports.IS_SCROLLING_TIMEOUT = _WindowScroller.IS_SCROLLING_TIMEOUT;

/***/ }),

/***/ 1167:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDimensions = getDimensions;
	exports.getPositionOffset = getPositionOffset;
	exports.getScrollOffset = getScrollOffset;
	
	
	/**
	 * Gets the dimensions of the element, accounting for API differences between
	 * `window` and other DOM elements.
	 */
	
	var isWindow = function isWindow(element) {
	  return element === window;
	};
	
	// TODO Move this into WindowScroller and import from there
	
	
	var getBoundingBox = function getBoundingBox(element) {
	  return element.getBoundingClientRect();
	};
	
	function getDimensions(scrollElement, props) {
	  if (!scrollElement) {
	    return {
	      height: props.serverHeight,
	      width: props.serverWidth
	    };
	  } else if (isWindow(scrollElement)) {
	    var _window = window,
	        innerHeight = _window.innerHeight,
	        innerWidth = _window.innerWidth;
	
	    return {
	      height: typeof innerHeight === 'number' ? innerHeight : 0,
	      width: typeof innerWidth === 'number' ? innerWidth : 0
	    };
	  } else {
	    return getBoundingBox(scrollElement);
	  }
	}
	
	/**
	 * Gets the vertical and horizontal position of an element within its scroll container.
	 * Elements that have been “scrolled past” return negative values.
	 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
	 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
	 */
	function getPositionOffset(element, container) {
	  if (isWindow(container) && document.documentElement) {
	    var containerElement = document.documentElement;
	    var elementRect = getBoundingBox(element);
	    var containerRect = getBoundingBox(containerElement);
	    return {
	      top: elementRect.top - containerRect.top,
	      left: elementRect.left - containerRect.left
	    };
	  } else {
	    var scrollOffset = getScrollOffset(container);
	    var _elementRect = getBoundingBox(element);
	    var _containerRect = getBoundingBox(container);
	    return {
	      top: _elementRect.top + scrollOffset.top - _containerRect.top,
	      left: _elementRect.left + scrollOffset.left - _containerRect.left
	    };
	  }
	}
	
	/**
	 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
	 * and API differences between `window` and other DOM elements.
	 */
	function getScrollOffset(element) {
	  if (isWindow(element) && document.documentElement) {
	    return {
	      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
	      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
	    };
	  } else {
	    return {
	      top: element.scrollTop,
	      left: element.scrollLeft
	    };
	  }
	}

/***/ }),

/***/ 1168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerScrollListener = registerScrollListener;
	exports.unregisterScrollListener = unregisterScrollListener;
	
	var _requestAnimationTimeout = __webpack_require__(325);
	
	var _WindowScroller = __webpack_require__(491);
	
	var mountedInstances = [];
	
	var originalBodyPointerEvents = null;
	var disablePointerEventsTimeoutId = null;
	
	function enablePointerEventsIfDisabled() {
	  if (disablePointerEventsTimeoutId) {
	    disablePointerEventsTimeoutId = null;
	
	    if (document.body && originalBodyPointerEvents != null) {
	      document.body.style.pointerEvents = originalBodyPointerEvents;
	    }
	
	    originalBodyPointerEvents = null;
	  }
	}
	
	function enablePointerEventsAfterDelayCallback() {
	  enablePointerEventsIfDisabled();
	  mountedInstances.forEach(function (instance) {
	    return instance.__resetIsScrolling();
	  });
	}
	
	function enablePointerEventsAfterDelay() {
	  if (disablePointerEventsTimeoutId) {
	    (0, _requestAnimationTimeout.cancelAnimationTimeout)(disablePointerEventsTimeoutId);
	  }
	
	  var maximumTimeout = 0;
	  mountedInstances.forEach(function (instance) {
	    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
	  });
	
	  disablePointerEventsTimeoutId = (0, _requestAnimationTimeout.requestAnimationTimeout)(enablePointerEventsAfterDelayCallback, maximumTimeout);
	}
	
	function onScrollWindow(event) {
	  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
	    originalBodyPointerEvents = document.body.style.pointerEvents;
	
	    document.body.style.pointerEvents = 'none';
	  }
	  enablePointerEventsAfterDelay();
	  mountedInstances.forEach(function (instance) {
	    if (instance.props.scrollElement === event.currentTarget) {
	      instance.__handleWindowScrollEvent();
	    }
	  });
	}
	
	function registerScrollListener(component, element) {
	  if (!mountedInstances.some(function (instance) {
	    return instance.props.scrollElement === element;
	  })) {
	    element.addEventListener('scroll', onScrollWindow);
	  }
	  mountedInstances.push(component);
	}
	
	function unregisterScrollListener(component, element) {
	  mountedInstances = mountedInstances.filter(function (instance) {
	    return instance !== component;
	  });
	  if (!mountedInstances.length) {
	    element.removeEventListener('scroll', onScrollWindow);
	    if (disablePointerEventsTimeoutId) {
	      (0, _requestAnimationTimeout.cancelAnimationTimeout)(disablePointerEventsTimeoutId);
	      enablePointerEventsIfDisabled();
	    }
	  }
	}

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ArrowKeyStepper = __webpack_require__(1132);
	
	Object.defineProperty(exports, 'ArrowKeyStepper', {
	  enumerable: true,
	  get: function get() {
	    return _ArrowKeyStepper.ArrowKeyStepper;
	  }
	});
	
	var _AutoSizer = __webpack_require__(1134);
	
	Object.defineProperty(exports, 'AutoSizer', {
	  enumerable: true,
	  get: function get() {
	    return _AutoSizer.AutoSizer;
	  }
	});
	
	var _CellMeasurer = __webpack_require__(478);
	
	Object.defineProperty(exports, 'CellMeasurer', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.CellMeasurer;
	  }
	});
	Object.defineProperty(exports, 'CellMeasurerCache', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.CellMeasurerCache;
	  }
	});
	
	var _Collection = __webpack_require__(1141);
	
	Object.defineProperty(exports, 'Collection', {
	  enumerable: true,
	  get: function get() {
	    return _Collection.Collection;
	  }
	});
	
	var _ColumnSizer = __webpack_require__(1144);
	
	Object.defineProperty(exports, 'ColumnSizer', {
	  enumerable: true,
	  get: function get() {
	    return _ColumnSizer.ColumnSizer;
	  }
	});
	
	var _Grid = __webpack_require__(169);
	
	Object.defineProperty(exports, 'accessibilityOverscanIndicesGetter', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.accessibilityOverscanIndicesGetter;
	  }
	});
	Object.defineProperty(exports, 'defaultCellRangeRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.defaultCellRangeRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultOverscanIndicesGetter', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.defaultOverscanIndicesGetter;
	  }
	});
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.Grid;
	  }
	});
	
	var _InfiniteLoader = __webpack_require__(1152);
	
	Object.defineProperty(exports, 'InfiniteLoader', {
	  enumerable: true,
	  get: function get() {
	    return _InfiniteLoader.InfiniteLoader;
	  }
	});
	
	var _List = __webpack_require__(1154);
	
	Object.defineProperty(exports, 'List', {
	  enumerable: true,
	  get: function get() {
	    return _List.List;
	  }
	});
	
	var _Masonry = __webpack_require__(1157);
	
	Object.defineProperty(exports, 'createMasonryCellPositioner', {
	  enumerable: true,
	  get: function get() {
	    return _Masonry.createCellPositioner;
	  }
	});
	Object.defineProperty(exports, 'Masonry', {
	  enumerable: true,
	  get: function get() {
	    return _Masonry.Masonry;
	  }
	});
	
	var _MultiGrid = __webpack_require__(1160);
	
	Object.defineProperty(exports, 'MultiGrid', {
	  enumerable: true,
	  get: function get() {
	    return _MultiGrid.MultiGrid;
	  }
	});
	
	var _ScrollSync = __webpack_require__(1162);
	
	Object.defineProperty(exports, 'ScrollSync', {
	  enumerable: true,
	  get: function get() {
	    return _ScrollSync.ScrollSync;
	  }
	});
	
	var _Table = __webpack_require__(1165);
	
	Object.defineProperty(exports, 'createTableMultiSort', {
	  enumerable: true,
	  get: function get() {
	    return _Table.createMultiSort;
	  }
	});
	Object.defineProperty(exports, 'defaultTableCellDataGetter', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultCellDataGetter;
	  }
	});
	Object.defineProperty(exports, 'defaultTableCellRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultCellRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultTableHeaderRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultHeaderRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultTableHeaderRowRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultHeaderRowRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultTableRowRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultRowRenderer;
	  }
	});
	Object.defineProperty(exports, 'Table', {
	  enumerable: true,
	  get: function get() {
	    return _Table.Table;
	  }
	});
	Object.defineProperty(exports, 'Column', {
	  enumerable: true,
	  get: function get() {
	    return _Table.Column;
	  }
	});
	Object.defineProperty(exports, 'SortDirection', {
	  enumerable: true,
	  get: function get() {
	    return _Table.SortDirection;
	  }
	});
	Object.defineProperty(exports, 'SortIndicator', {
	  enumerable: true,
	  get: function get() {
	    return _Table.SortIndicator;
	  }
	});
	
	var _WindowScroller = __webpack_require__(1166);
	
	Object.defineProperty(exports, 'WindowScroller', {
	  enumerable: true,
	  get: function get() {
	    return _WindowScroller.WindowScroller;
	  }
	});

/***/ }),

/***/ 1169:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	// Properly handle server-side rendering.
	var win = void 0;
	
	if (typeof window !== 'undefined') {
	  win = window;
	} else if (typeof self !== 'undefined') {
	  win = self;
	} else {
	  win = {};
	}
	
	// requestAnimationFrame() shim by Paul Irish
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
	  return win.setTimeout(callback, 1000 / 60);
	};
	
	var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
	  win.clearTimeout(id);
	};
	
	var raf = exports.raf = request;
	var caf = exports.caf = cancel;

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(100);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = createCallbackMemoizer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
	 */
	function createCallbackMemoizer() {
	  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  var cachedIndices = {};
	
	  return function (_ref) {
	    var callback = _ref.callback,
	        indices = _ref.indices;
	
	    var keys = (0, _keys2.default)(indices);
	    var allInitialized = !requireAllKeys || keys.every(function (key) {
	      var value = indices[key];
	      return Array.isArray(value) ? value.length > 0 : value >= 0;
	    });
	    var indexChanged = keys.length !== (0, _keys2.default)(cachedIndices).length || keys.some(function (key) {
	      var cachedValue = cachedIndices[key];
	      var value = indices[key];
	
	      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
	    });
	
	    cachedIndices = indices;
	
	    if (allInitialized && indexChanged) {
	      callback(indices);
	    }
	  };
	}

/***/ }),

/***/ 1170:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUpdatedOffsetForIndex;
	/**
	 * Determines a new offset that ensures a certain cell is visible, given the current offset.
	 * If the cell is already visible then the current offset will be returned.
	 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
	 *
	 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
	 * @param cellOffset Offset (x or y) position for cell
	 * @param cellSize Size (width or height) of cell
	 * @param containerSize Total size (width or height) of the container
	 * @param currentOffset Container's current (x or y) offset
	 * @return Offset to use to ensure the specified cell is visible
	 */
	function getUpdatedOffsetForIndex(_ref) {
	  var _ref$align = _ref.align,
	      align = _ref$align === undefined ? 'auto' : _ref$align,
	      cellOffset = _ref.cellOffset,
	      cellSize = _ref.cellSize,
	      containerSize = _ref.containerSize,
	      currentOffset = _ref.currentOffset;
	
	  var maxOffset = cellOffset;
	  var minOffset = maxOffset - containerSize + cellSize;
	
	  switch (align) {
	    case 'start':
	      return maxOffset;
	    case 'end':
	      return minOffset;
	    case 'center':
	      return maxOffset - (containerSize - cellSize) / 2;
	    default:
	      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
	  }
	}

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bpfrpt_proptype_AnimationTimeoutId = exports.requestAnimationTimeout = exports.cancelAnimationTimeout = undefined;
	
	var _animationFrame = __webpack_require__(1169);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bpfrpt_proptype_AnimationTimeoutId =  true ? null : {
	  id: _propTypes2.default.number.isRequired
	};
	var cancelAnimationTimeout = exports.cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
	  return (0, _animationFrame.caf)(frame.id);
	};
	
	/**
	 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
	 * When the delay time has been reached the function you're timing out will be called.
	 *
	 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
	 */
	var requestAnimationTimeout = exports.requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
	  var start = Date.now();
	
	  var timeout = function timeout() {
	    if (Date.now() - start >= delay) {
	      callback.call();
	    } else {
	      frame.id = (0, _animationFrame.raf)(timeout);
	    }
	  };
	
	  var frame = {
	    id: (0, _animationFrame.raf)(timeout)
	  };
	
	  return frame;
	};
	exports.bpfrpt_proptype_AnimationTimeoutId = bpfrpt_proptype_AnimationTimeoutId;

/***/ }),

/***/ 1171:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Binary Search Bounds
	 * https://github.com/mikolalysenko/binary-search-bounds
	 * Mikola Lysenko
	 *
	 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
	 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
	 **/
	
	function _GEA(a, l, h, y) {
	  var i = h + 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x >= y) {
	      i = m;
	      h = m - 1;
	    } else {
	      l = m + 1;
	    }
	  }
	  return i;
	}
	function _GEP(a, l, h, y, c) {
	  var i = h + 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (c(x, y) >= 0) {
	      i = m;
	      h = m - 1;
	    } else {
	      l = m + 1;
	    }
	  }
	  return i;
	}
	function dispatchBsearchGE(a, y, c, l, h) {
	  if (typeof c === 'function') {
	    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	function _GTA(a, l, h, y) {
	  var i = h + 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x > y) {
	      i = m;
	      h = m - 1;
	    } else {
	      l = m + 1;
	    }
	  }
	  return i;
	}
	function _GTP(a, l, h, y, c) {
	  var i = h + 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (c(x, y) > 0) {
	      i = m;
	      h = m - 1;
	    } else {
	      l = m + 1;
	    }
	  }
	  return i;
	}
	function dispatchBsearchGT(a, y, c, l, h) {
	  if (typeof c === 'function') {
	    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	function _LTA(a, l, h, y) {
	  var i = l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x < y) {
	      i = m;
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return i;
	}
	function _LTP(a, l, h, y, c) {
	  var i = l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (c(x, y) < 0) {
	      i = m;
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return i;
	}
	function dispatchBsearchLT(a, y, c, l, h) {
	  if (typeof c === 'function') {
	    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	function _LEA(a, l, h, y) {
	  var i = l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x <= y) {
	      i = m;
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return i;
	}
	function _LEP(a, l, h, y, c) {
	  var i = l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (c(x, y) <= 0) {
	      i = m;
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return i;
	}
	function dispatchBsearchLE(a, y, c, l, h) {
	  if (typeof c === 'function') {
	    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	function _EQA(a, l, h, y) {
	  l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x === y) {
	      return m;
	    } else if (x <= y) {
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return -1;
	}
	function _EQP(a, l, h, y, c) {
	  l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    var p = c(x, y);
	    if (p === 0) {
	      return m;
	    } else if (p <= 0) {
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return -1;
	}
	function dispatchBsearchEQ(a, y, c, l, h) {
	  if (typeof c === 'function') {
	    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	exports.default = {
	  ge: dispatchBsearchGE,
	  gt: dispatchBsearchGT,
	  lt: dispatchBsearchLT,
	  le: dispatchBsearchLE,
	  eq: dispatchBsearchEQ
	};

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createDetectElementResize;
	/**
	 * Detect Element Resize.
	 * https://github.com/sdecima/javascript-detect-element-resize
	 * Sebastian Decima
	 *
	 * Forked from version 0.5.3; includes the following modifications:
	 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
	 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
	 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
	 * 4) Add nonce for style element.
	 **/
	
	function createDetectElementResize(nonce) {
	  // Check `document` and `window` in case of server-side rendering
	  var _window;
	  if (typeof window !== 'undefined') {
	    _window = window;
	  } else if (typeof self !== 'undefined') {
	    _window = self;
	  } else {
	    _window = global;
	  }
	
	  var attachEvent = typeof document !== 'undefined' && document.attachEvent;
	
	  if (!attachEvent) {
	    var requestFrame = function () {
	      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
	        return _window.setTimeout(fn, 20);
	      };
	      return function (fn) {
	        return raf(fn);
	      };
	    }();
	
	    var cancelFrame = function () {
	      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
	      return function (id) {
	        return cancel(id);
	      };
	    }();
	
	    var resetTriggers = function resetTriggers(element) {
	      var triggers = element.__resizeTriggers__,
	          expand = triggers.firstElementChild,
	          contract = triggers.lastElementChild,
	          expandChild = expand.firstElementChild;
	      contract.scrollLeft = contract.scrollWidth;
	      contract.scrollTop = contract.scrollHeight;
	      expandChild.style.width = expand.offsetWidth + 1 + 'px';
	      expandChild.style.height = expand.offsetHeight + 1 + 'px';
	      expand.scrollLeft = expand.scrollWidth;
	      expand.scrollTop = expand.scrollHeight;
	    };
	
	    var checkTriggers = function checkTriggers(element) {
	      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
	    };
	
	    var scrollListener = function scrollListener(e) {
	      // Don't measure (which forces) reflow for scrolls that happen inside of children!
	      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
	        return;
	      }
	
	      var element = this;
	      resetTriggers(this);
	      if (this.__resizeRAF__) {
	        cancelFrame(this.__resizeRAF__);
	      }
	      this.__resizeRAF__ = requestFrame(function () {
	        if (checkTriggers(element)) {
	          element.__resizeLast__.width = element.offsetWidth;
	          element.__resizeLast__.height = element.offsetHeight;
	          element.__resizeListeners__.forEach(function (fn) {
	            fn.call(element, e);
	          });
	        }
	      });
	    };
	
	    /* Detect CSS Animations support to detect element display/re-attach */
	    var animation = false,
	        keyframeprefix = '',
	        animationstartevent = 'animationstart',
	        domPrefixes = 'Webkit Moz O ms'.split(' '),
	        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
	        pfx = '';
	    {
	      var elm = document.createElement('fakeelement');
	      if (elm.style.animationName !== undefined) {
	        animation = true;
	      }
	
	      if (animation === false) {
	        for (var i = 0; i < domPrefixes.length; i++) {
	          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	            pfx = domPrefixes[i];
	            keyframeprefix = '-' + pfx.toLowerCase() + '-';
	            animationstartevent = startEvents[i];
	            animation = true;
	            break;
	          }
	        }
	      }
	    }
	
	    var animationName = 'resizeanim';
	    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
	    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	  }
	
	  var createStyles = function createStyles(doc) {
	    if (!doc.getElementById('detectElementResize')) {
	      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
	          head = doc.head || doc.getElementsByTagName('head')[0],
	          style = doc.createElement('style');
	
	      style.id = 'detectElementResize';
	      style.type = 'text/css';
	
	      if (nonce != null) {
	        style.setAttribute('nonce', nonce);
	      }
	
	      if (style.styleSheet) {
	        style.styleSheet.cssText = css;
	      } else {
	        style.appendChild(doc.createTextNode(css));
	      }
	
	      head.appendChild(style);
	    }
	  };
	
	  var addResizeListener = function addResizeListener(element, fn) {
	    if (attachEvent) {
	      element.attachEvent('onresize', fn);
	    } else {
	      if (!element.__resizeTriggers__) {
	        var doc = element.ownerDocument;
	        var elementStyle = _window.getComputedStyle(element);
	        if (elementStyle && elementStyle.position == 'static') {
	          element.style.position = 'relative';
	        }
	        createStyles(doc);
	        element.__resizeLast__ = {};
	        element.__resizeListeners__ = [];
	        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
	        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
	        element.appendChild(element.__resizeTriggers__);
	        resetTriggers(element);
	        element.addEventListener('scroll', scrollListener, true);
	
	        /* Listen for a css animation to detect element display/re-attach */
	        if (animationstartevent) {
	          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
	            if (e.animationName == animationName) {
	              resetTriggers(element);
	            }
	          };
	          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	        }
	      }
	      element.__resizeListeners__.push(fn);
	    }
	  };
	
	  var removeResizeListener = function removeResizeListener(element, fn) {
	    if (attachEvent) {
	      element.detachEvent('onresize', fn);
	    } else {
	      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	      if (!element.__resizeListeners__.length) {
	        element.removeEventListener('scroll', scrollListener, true);
	        if (element.__resizeTriggers__.__animationListener__) {
	          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	          element.__resizeTriggers__.__animationListener__ = null;
	        }
	        try {
	          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	        } catch (e) {
	          // Preact compat; see developit/preact-compat/issues/228
	        }
	      }
	    }
	  };
	
	  return {
	    addResizeListener: addResizeListener,
	    removeResizeListener: removeResizeListener
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 1172:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createWrapper;
	
	var _binarySearchBounds = __webpack_require__(1171);
	
	var _binarySearchBounds2 = _interopRequireDefault(_binarySearchBounds);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NOT_FOUND = 0; /**
	                    * Binary Search Bounds
	                    * https://github.com/mikolalysenko/interval-tree-1d
	                    * Mikola Lysenko
	                    *
	                    * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
	                    * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
	                    **/
	
	var SUCCESS = 1;
	var EMPTY = 2;
	
	function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
	  this.mid = mid;
	  this.left = left;
	  this.right = right;
	  this.leftPoints = leftPoints;
	  this.rightPoints = rightPoints;
	  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
	}
	
	var proto = IntervalTreeNode.prototype;
	
	function copy(a, b) {
	  a.mid = b.mid;
	  a.left = b.left;
	  a.right = b.right;
	  a.leftPoints = b.leftPoints;
	  a.rightPoints = b.rightPoints;
	  a.count = b.count;
	}
	
	function rebuild(node, intervals) {
	  var ntree = createIntervalTree(intervals);
	  node.mid = ntree.mid;
	  node.left = ntree.left;
	  node.right = ntree.right;
	  node.leftPoints = ntree.leftPoints;
	  node.rightPoints = ntree.rightPoints;
	  node.count = ntree.count;
	}
	
	function rebuildWithInterval(node, interval) {
	  var intervals = node.intervals([]);
	  intervals.push(interval);
	  rebuild(node, intervals);
	}
	
	function rebuildWithoutInterval(node, interval) {
	  var intervals = node.intervals([]);
	  var idx = intervals.indexOf(interval);
	  if (idx < 0) {
	    return NOT_FOUND;
	  }
	  intervals.splice(idx, 1);
	  rebuild(node, intervals);
	  return SUCCESS;
	}
	
	proto.intervals = function (result) {
	  result.push.apply(result, this.leftPoints);
	  if (this.left) {
	    this.left.intervals(result);
	  }
	  if (this.right) {
	    this.right.intervals(result);
	  }
	  return result;
	};
	
	proto.insert = function (interval) {
	  var weight = this.count - this.leftPoints.length;
	  this.count += 1;
	  if (interval[1] < this.mid) {
	    if (this.left) {
	      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
	        rebuildWithInterval(this, interval);
	      } else {
	        this.left.insert(interval);
	      }
	    } else {
	      this.left = createIntervalTree([interval]);
	    }
	  } else if (interval[0] > this.mid) {
	    if (this.right) {
	      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
	        rebuildWithInterval(this, interval);
	      } else {
	        this.right.insert(interval);
	      }
	    } else {
	      this.right = createIntervalTree([interval]);
	    }
	  } else {
	    var l = _binarySearchBounds2.default.ge(this.leftPoints, interval, compareBegin);
	    var r = _binarySearchBounds2.default.ge(this.rightPoints, interval, compareEnd);
	    this.leftPoints.splice(l, 0, interval);
	    this.rightPoints.splice(r, 0, interval);
	  }
	};
	
	proto.remove = function (interval) {
	  var weight = this.count - this.leftPoints;
	  if (interval[1] < this.mid) {
	    if (!this.left) {
	      return NOT_FOUND;
	    }
	    var rw = this.right ? this.right.count : 0;
	    if (4 * rw > 3 * (weight - 1)) {
	      return rebuildWithoutInterval(this, interval);
	    }
	    var r = this.left.remove(interval);
	    if (r === EMPTY) {
	      this.left = null;
	      this.count -= 1;
	      return SUCCESS;
	    } else if (r === SUCCESS) {
	      this.count -= 1;
	    }
	    return r;
	  } else if (interval[0] > this.mid) {
	    if (!this.right) {
	      return NOT_FOUND;
	    }
	    var lw = this.left ? this.left.count : 0;
	    if (4 * lw > 3 * (weight - 1)) {
	      return rebuildWithoutInterval(this, interval);
	    }
	    var r = this.right.remove(interval);
	    if (r === EMPTY) {
	      this.right = null;
	      this.count -= 1;
	      return SUCCESS;
	    } else if (r === SUCCESS) {
	      this.count -= 1;
	    }
	    return r;
	  } else {
	    if (this.count === 1) {
	      if (this.leftPoints[0] === interval) {
	        return EMPTY;
	      } else {
	        return NOT_FOUND;
	      }
	    }
	    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
	      if (this.left && this.right) {
	        var p = this;
	        var n = this.left;
	        while (n.right) {
	          p = n;
	          n = n.right;
	        }
	        if (p === this) {
	          n.right = this.right;
	        } else {
	          var l = this.left;
	          var r = this.right;
	          p.count -= n.count;
	          p.right = n.left;
	          n.left = l;
	          n.right = r;
	        }
	        copy(this, n);
	        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
	      } else if (this.left) {
	        copy(this, this.left);
	      } else {
	        copy(this, this.right);
	      }
	      return SUCCESS;
	    }
	    for (var l = _binarySearchBounds2.default.ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
	      if (this.leftPoints[l][0] !== interval[0]) {
	        break;
	      }
	      if (this.leftPoints[l] === interval) {
	        this.count -= 1;
	        this.leftPoints.splice(l, 1);
	        for (var r = _binarySearchBounds2.default.ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
	          if (this.rightPoints[r][1] !== interval[1]) {
	            break;
	          } else if (this.rightPoints[r] === interval) {
	            this.rightPoints.splice(r, 1);
	            return SUCCESS;
	          }
	        }
	      }
	    }
	    return NOT_FOUND;
	  }
	};
	
	function reportLeftRange(arr, hi, cb) {
	  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
	    var r = cb(arr[i]);
	    if (r) {
	      return r;
	    }
	  }
	}
	
	function reportRightRange(arr, lo, cb) {
	  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
	    var r = cb(arr[i]);
	    if (r) {
	      return r;
	    }
	  }
	}
	
	function reportRange(arr, cb) {
	  for (var i = 0; i < arr.length; ++i) {
	    var r = cb(arr[i]);
	    if (r) {
	      return r;
	    }
	  }
	}
	
	proto.queryPoint = function (x, cb) {
	  if (x < this.mid) {
	    if (this.left) {
	      var r = this.left.queryPoint(x, cb);
	      if (r) {
	        return r;
	      }
	    }
	    return reportLeftRange(this.leftPoints, x, cb);
	  } else if (x > this.mid) {
	    if (this.right) {
	      var r = this.right.queryPoint(x, cb);
	      if (r) {
	        return r;
	      }
	    }
	    return reportRightRange(this.rightPoints, x, cb);
	  } else {
	    return reportRange(this.leftPoints, cb);
	  }
	};
	
	proto.queryInterval = function (lo, hi, cb) {
	  if (lo < this.mid && this.left) {
	    var r = this.left.queryInterval(lo, hi, cb);
	    if (r) {
	      return r;
	    }
	  }
	  if (hi > this.mid && this.right) {
	    var r = this.right.queryInterval(lo, hi, cb);
	    if (r) {
	      return r;
	    }
	  }
	  if (hi < this.mid) {
	    return reportLeftRange(this.leftPoints, hi, cb);
	  } else if (lo > this.mid) {
	    return reportRightRange(this.rightPoints, lo, cb);
	  } else {
	    return reportRange(this.leftPoints, cb);
	  }
	};
	
	function compareNumbers(a, b) {
	  return a - b;
	}
	
	function compareBegin(a, b) {
	  var d = a[0] - b[0];
	  if (d) {
	    return d;
	  }
	  return a[1] - b[1];
	}
	
	function compareEnd(a, b) {
	  var d = a[1] - b[1];
	  if (d) {
	    return d;
	  }
	  return a[0] - b[0];
	}
	
	function createIntervalTree(intervals) {
	  if (intervals.length === 0) {
	    return null;
	  }
	  var pts = [];
	  for (var i = 0; i < intervals.length; ++i) {
	    pts.push(intervals[i][0], intervals[i][1]);
	  }
	  pts.sort(compareNumbers);
	
	  var mid = pts[pts.length >> 1];
	
	  var leftIntervals = [];
	  var rightIntervals = [];
	  var centerIntervals = [];
	  for (var i = 0; i < intervals.length; ++i) {
	    var s = intervals[i];
	    if (s[1] < mid) {
	      leftIntervals.push(s);
	    } else if (mid < s[0]) {
	      rightIntervals.push(s);
	    } else {
	      centerIntervals.push(s);
	    }
	  }
	
	  //Split center intervals
	  var leftPoints = centerIntervals;
	  var rightPoints = centerIntervals.slice();
	  leftPoints.sort(compareBegin);
	  rightPoints.sort(compareEnd);
	
	  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
	}
	
	//User friendly wrapper that makes it possible to support empty trees
	function IntervalTree(root) {
	  this.root = root;
	}
	
	var tproto = IntervalTree.prototype;
	
	tproto.insert = function (interval) {
	  if (this.root) {
	    this.root.insert(interval);
	  } else {
	    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
	  }
	};
	
	tproto.remove = function (interval) {
	  if (this.root) {
	    var r = this.root.remove(interval);
	    if (r === EMPTY) {
	      this.root = null;
	    }
	    return r !== NOT_FOUND;
	  }
	  return false;
	};
	
	tproto.queryPoint = function (p, cb) {
	  if (this.root) {
	    return this.root.queryPoint(p, cb);
	  }
	};
	
	tproto.queryInterval = function (lo, hi, cb) {
	  if (lo <= hi && this.root) {
	    return this.root.queryInterval(lo, hi, cb);
	  }
	};
	
	Object.defineProperty(tproto, 'count', {
	  get: function get() {
	    if (this.root) {
	      return this.root.count;
	    }
	    return 0;
	  }
	});
	
	Object.defineProperty(tproto, 'intervals', {
	  get: function get() {
	    if (this.root) {
	      return this.root.intervals([]);
	    }
	    return [];
	  }
	});
	
	function createWrapper(intervals) {
	  if (!intervals || intervals.length === 0) {
	    return new IntervalTree(null);
	  }
	  return new IntervalTree(createIntervalTree(intervals));
	}

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (PromiseArgument) {
	  var Promise;
	  function throat(size, fn) {
	    var queue = new Queue();
	    function run(fn, self, args) {
	      if (size) {
	        size--;
	        var result = new Promise(function (resolve) {
	          resolve(fn.apply(self, args));
	        });
	        result.then(release, release);
	        return result;
	      } else {
	        return new Promise(function (resolve) {
	          queue.push(new Delayed(resolve, fn, self, args));
	        });
	      }
	    }
	    function release() {
	      size++;
	      if (!queue.isEmpty()) {
	        var next = queue.shift();
	        next.resolve(run(next.fn, next.self, next.args));
	      }
	    }
	    if (typeof size === 'function') {
	      var temp = fn;
	      fn = size;
	      size = temp;
	    }
	    if (typeof size !== 'number') {
	      throw new TypeError(
	        'Expected throat size to be a number but got ' + typeof size
	      );
	    }
	    if (fn !== undefined && typeof fn !== 'function') {
	      throw new TypeError(
	        'Expected throat fn to be a function but got ' + typeof fn
	      );
	    }
	    if (typeof fn === 'function') {
	      return function () {
	        var args = [];
	        for (var i = 0; i < arguments.length; i++) {
	          args.push(arguments[i]);
	        }
	        return run(fn, this, args);
	      };
	    } else {
	      return function (fn) {
	        if (typeof fn !== 'function') {
	          throw new TypeError(
	            'Expected throat fn to be a function but got ' + typeof fn
	          );
	        }
	        var args = [];
	        for (var i = 1; i < arguments.length; i++) {
	          args.push(arguments[i]);
	        }
	        return run(fn, this, args);
	      };
	    }
	  }
	  if (arguments.length === 1 && typeof PromiseArgument === 'function') {
	    Promise = PromiseArgument;
	    return throat;
	  } else {
	    Promise = module.exports.Promise;
	    if (typeof Promise !== 'function') {
	      throw new Error(
	        'You must provide a Promise polyfill for this library to work in older environments'
	      );
	    }
	    return throat(arguments[0], arguments[1]);
	  }
	};
	
	/* istanbul ignore next */
	if (typeof Promise === 'function') {
	  module.exports.Promise = Promise;
	}
	
	function Delayed(resolve, fn, self, args) {
	  this.resolve = resolve;
	  this.fn = fn;
	  this.self = self || null;
	  this.args = args;
	}
	
	function Queue() {
	  this._s1 = [];
	  this._s2 = [];
	}
	
	Queue.prototype.push = function (value) {
	  this._s1.push(value);
	};
	
	Queue.prototype.shift = function () {
	  var s2 = this._s2;
	  if (s2.length === 0) {
	    var s1 = this._s1;
	    if (s1.length === 0) {
	      return;
	    }
	    this._s1 = s2;
	    s2 = this._s2 = s1.reverse();
	  }
	  return s2.pop();
	};
	
	Queue.prototype.isEmpty = function () {
	  return !this._s1.length && !this._s2.length;
	};


/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLoadScript = __webpack_require__(1070);
	
	var _reactLoadScript2 = _interopRequireDefault(_reactLoadScript);
	
	var _youtubeAuth = __webpack_require__(174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoogleScript = function (_React$Component) {
	  _inherits(GoogleScript, _React$Component);
	
	  function GoogleScript() {
	    _classCallCheck(this, GoogleScript);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  GoogleScript.prototype.handleScriptError = function handleScriptError() {
	    alert('Failed to load Google API script - refresh the page');
	  };
	
	  GoogleScript.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(_reactLoadScript2.default, {
	      url: "https://apis.google.com/js/api.js",
	      onError: this.handleScriptError.bind(this),
	      onLoad: function onLoad() {
	        return (0, _youtubeAuth.loadYoutubeClient)(_this2.props.handleYoutubeClientLoad, _this2.props.updateSignInStatus);
	      }
	    });
	  };
	
	  return GoogleScript;
	}(_react2.default.Component);
	
	;
	
	exports.default = GoogleScript;
	module.exports = exports["default"];

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _GoogleScript = __webpack_require__(571);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GoogleScript).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactModal = __webpack_require__(208);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _youtube = __webpack_require__(205);
	
	var _youtube2 = _interopRequireDefault(_youtube);
	
	var _youtubeConverter = __webpack_require__(218);
	
	var _window = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var customStyles = {
	  overlay: { zIndex: 10 },
	  content: {
	    height: '80vh',
	    width: '80vw',
	    top: '50%',
	    left: '50%',
	    right: 'auto',
	    bottom: 'auto',
	    marginRight: '-50%',
	    transform: 'translate(-50%, -50%)'
	  }
	};
	
	var PlaylistConversionFilterModal = function (_React$Component) {
	  _inherits(PlaylistConversionFilterModal, _React$Component);
	
	  function PlaylistConversionFilterModal() {
	    _classCallCheck(this, PlaylistConversionFilterModal);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      modalIsOpen: false
	    };
	
	    _this.openModal = _this.openModal.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    return _this;
	  }
	
	  PlaylistConversionFilterModal.prototype.openModal = function openModal() {
	    this.setState({ modalIsOpen: true });
	  };
	
	  PlaylistConversionFilterModal.prototype.closeModal = function closeModal() {
	    // cancelAddAllToPlaylist();
	    this.setState({ modalIsOpen: false });
	  };
	
	  PlaylistConversionFilterModal.prototype.render = function render() {
	    var canConvert = this.props.canConvert;
	
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        "div",
	        {
	          className: "jsx-647034210" + " " + "playlist-conversion-modal"
	        },
	        canConvert && _react2.default.createElement(
	          "button",
	          { onClick: this.openModal, className: "jsx-647034210" + " " + "convert-playlist md"
	          },
	          "Filters"
	        ),
	        _react2.default.createElement(
	          _reactModal2.default,
	          {
	            ariaHideApp: false,
	            isOpen: this.state.modalIsOpen
	            // onAfterOpen={this.afterOpenModal}
	            , onRequestClose: this.closeModal,
	            style: customStyles,
	            contentLabel: "Example Modal"
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "jsx-647034210"
	            },
	            _react2.default.createElement(
	              "h2",
	              {
	                className: "jsx-647034210"
	              },
	              "Filters Coming Soon"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_style2.default, {
	        styleId: "647034210",
	        css: [".playlist-conversion-modal.jsx-647034210{display:inline-block;margin-left:10px;}", "button.jsx-647034210{border:0;cursor:pointer;font-size:16px;min-width:100px;}", "button.xl.jsx-647034210{border-radius:5px;font-size:24px;padding:10px 15px;}", "button.md.jsx-647034210{border-radius:5px;padding:10px 15px;}", "button.convert-playlist.jsx-647034210{background:#346294;color:white;}", "button.view-on-youtube.jsx-647034210{background:red;color:white;min-height:60px;margin-left:20px;}", "@media screen and (min-width:600px){}"]
	      })
	    );
	  };
	
	  return PlaylistConversionFilterModal;
	}(_react2.default.Component);
	
	;
	
	exports.default = PlaylistConversionFilterModal;
	module.exports = exports["default"];

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _PlaylistConversionFilterModal = __webpack_require__(583);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PlaylistConversionFilterModal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactModal = __webpack_require__(208);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _rcProgress = __webpack_require__(963);
	
	var _youtube = __webpack_require__(205);
	
	var _youtube2 = _interopRequireDefault(_youtube);
	
	var _youtubeConverter = __webpack_require__(218);
	
	var _window = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // TODO - update react icons to version 3 so I can use the correct icon
	
	
	var customStyles = {
	  overlay: { zIndex: 10 },
	  content: {
	    top: '50%',
	    left: '50%',
	    right: 'auto',
	    bottom: 'auto',
	    marginRight: '-50%',
	    transform: 'translate(-50%, -50%)'
	  }
	};
	
	var PlaylistConversionModal = function (_React$Component) {
	  _inherits(PlaylistConversionModal, _React$Component);
	
	  function PlaylistConversionModal() {
	    _classCallCheck(this, PlaylistConversionModal);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      modalIsOpen: false,
	      playlistId: '',
	      progress: 0,
	      songsLength: 0,
	      index: 0
	    };
	
	    _this.openModal = _this.openModal.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    _this.closeModalAndCancel = _this.closeModalAndCancel.bind(_this);
	    _this.updateProgress = _this.updateProgress.bind(_this);
	    return _this;
	  }
	
	  PlaylistConversionModal.prototype.openModal = function openModal(songs, title) {
	    var _this2 = this;
	
	    var songsLimit = songs.slice(0, 250);
	
	    // Do a progress bar and make sure this only runs once
	    (0, _youtubeConverter.promiseCreatePlaylist)(title).then(function (response) {
	      if (response.success) {
	        var playlist = response.success.playlist;
	
	        _this2.setState({ playlistId: playlist.id });
	
	        (0, _youtubeConverter.addAllToPlaylist)(songsLimit, playlist.id, _this2.updateProgress, {});
	      } else {
	        if (response.error) {
	          var message = response.error.message;
	        }
	      }
	    });
	    this.setState({ modalIsOpen: true, playlistId: '', progress: 0, songsLength: songsLimit.length });
	  };
	
	  PlaylistConversionModal.prototype.closeModalAndCancel = function closeModalAndCancel() {
	    (0, _youtubeConverter.cancelAddAllToPlaylist)();
	    this.setState({ modalIsOpen: false, progress: 0, playlistId: '', songsLength: 0, index: 0 });
	  };
	
	  PlaylistConversionModal.prototype.closeModal = function closeModal() {
	    // cancelAddAllToPlaylist();
	    this.setState({ modalIsOpen: false, progress: 0, playlistId: '', songsLength: 0, index: 0 });
	  };
	
	  PlaylistConversionModal.prototype.updateProgress = function updateProgress(index) {
	    var percent = 100 * index / this.state.songsLength;
	    var progress = Math.ceil(percent);
	    // make sure it's an int value
	
	    this.setState({ progress: progress, index: index });
	  };
	
	  PlaylistConversionModal.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        canConvert = _props.canConvert,
	        songs = _props.songs,
	        title = _props.title;
	    var _state = this.state,
	        playlistId = _state.playlistId,
	        progress = _state.progress,
	        index = _state.index;
	
	
	    var viewOnYoutube = function viewOnYoutube() {
	      (0, _window.windowOpen)('https://www.youtube.com/playlist?list=' + playlistId);
	    };
	    var done = progress === 100;
	
	    customStyles.content.height = (0, _window.isMobileOrTablet)() ? '90vh' : '70vh';
	    customStyles.content.width = (0, _window.isMobileOrTablet)() ? '90vw' : '70vw';
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        "div",
	        {
	          className: "jsx-252530398" + " " + "playlist-conversion-modal"
	        },
	        canConvert && _react2.default.createElement(
	          "button",
	          { onClick: function onClick() {
	              return _this3.openModal(songs, title);
	            }, className: "jsx-252530398" + " " + "convert-playlist md"
	          },
	          "Convert Playlist"
	        ),
	        _react2.default.createElement(
	          _reactModal2.default,
	          {
	            ariaHideApp: false,
	            isOpen: this.state.modalIsOpen
	            // onAfterOpen={this.afterOpenModal}
	            // onRequestClose={this.closeModal}
	            , style: customStyles,
	            contentLabel: "Example Modal"
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "jsx-252530398"
	            },
	            _react2.default.createElement(
	              "h2",
	              {
	                className: "jsx-252530398"
	              },
	              title,
	              " - Converting Spotify Playlist to YouTube"
	            ),
	            _react2.default.createElement("br", {
	              className: "jsx-252530398"
	            }),
	            _react2.default.createElement(
	              "h4",
	              {
	                className: "jsx-252530398"
	              },
	              progress,
	              "% Done, ",
	              index,
	              " of ",
	              songs.length,
	              _react2.default.createElement(
	                "a",
	                { target: "_blank", href: "https://www.youtube.com/channel/UCNnkp6SwIbCXXOmXZzoDEJA?sub_confirmation=1", className: "jsx-252530398"
	                },
	                _react2.default.createElement(
	                  "h3",
	                  {
	                    className: "jsx-252530398"
	                  },
	                  "Follow Playlist Buddy on YouTube"
	                )
	              )
	            ),
	            _react2.default.createElement(_rcProgress.Line, { percent: progress, strokeWidth: (0, _window.isMobileOrTablet)() ? 3 : 1, strokeColor: "#346294" }),
	            _react2.default.createElement("br", {
	              className: "jsx-252530398"
	            }),
	            _react2.default.createElement(
	              "a",
	              { target: "_blank", style: { "color": "red" }, href: "/quota-playlist-buddy/", className: "jsx-252530398"
	              },
	              "Playlist Conversion temporarily limited to 250 songs"
	            ),
	            _react2.default.createElement("br", {
	              className: "jsx-252530398"
	            }),
	            !(0, _window.isMobileOrTablet)() && _react2.default.createElement(
	              "div",
	              {
	                className: "jsx-252530398"
	              },
	              _react2.default.createElement("br", {
	                className: "jsx-252530398"
	              }),
	              _react2.default.createElement(
	                "a",
	                { target: "_blank", href: "https://www.tunemymusic.com/YouTube-to-Spotify.php", className: "jsx-252530398"
	                },
	                "Convert YouTube to Spotify"
	              ),
	              _react2.default.createElement("br", {
	                className: "jsx-252530398"
	              }),
	              _react2.default.createElement("br", {
	                className: "jsx-252530398"
	              }),
	              _react2.default.createElement(
	                "a",
	                { target: "_blank", href: "/airbnb-credit/", className: "jsx-252530398"
	                },
	                "Sign up for AirBnb - $55 free"
	              ),
	              _react2.default.createElement("br", {
	                className: "jsx-252530398"
	              }),
	              _react2.default.createElement(
	                "a",
	                { target: "_blank", href: "http://youtube.com/c/shervinater", className: "jsx-252530398"
	                },
	                "Learn about Smart Health Technology / Biohacking"
	              ),
	              _react2.default.createElement("br", {
	                className: "jsx-252530398"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "jsx-252530398" + " " + "bottom-right"
	              },
	              !done && _react2.default.createElement(
	                "button",
	                { onClick: this.closeModalAndCancel, className: "jsx-252530398" + " " + "cancel-conversion xl"
	                },
	                "Cancel Conversion"
	              ),
	              done && _react2.default.createElement(
	                "button",
	                { onClick: this.closeModal, className: "jsx-252530398" + " " + "cancel-conversion xl"
	                },
	                "Close Modal"
	              ),
	              playlistId && _react2.default.createElement(
	                "button",
	                { onClick: viewOnYoutube, className: "jsx-252530398" + " " + "view-on-youtube xl"
	                },
	                "View on YouTube"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_style2.default, {
	        styleId: "252530398",
	        css: [".playlist-conversion-modal.jsx-252530398{display:inline-block;margin-left:10px;}", "button.jsx-252530398{border:0;cursor:pointer;font-size:16px;min-width:100px;}", "button.xl.jsx-252530398{border-radius:5px;font-size:24px;padding:10px 15px;}", ".bottom-right.jsx-252530398{position:absolute;right:10px;bottom:10px;}", "button.md.jsx-252530398{border-radius:5px;padding:10px 15px;}", "button.convert-playlist.jsx-252530398{background:#346294;color:white;}", "button.view-on-youtube.jsx-252530398{background:red;color:white;min-height:60px;margin-left:20px;}", "button.view-on-youtube[disabled].jsx-252530398{background:gray;}", "@media screen and (min-width:600px){}"]
	      })
	    );
	  };
	
	  return PlaylistConversionModal;
	}(_react2.default.Component);
	
	;
	
	exports.default = PlaylistConversionModal;
	module.exports = exports["default"];

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _PlaylistConversionModal = __webpack_require__(585);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PlaylistConversionModal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactModal = __webpack_require__(208);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactVirtualized = __webpack_require__(492);
	
	var _spotifyAuth = __webpack_require__(58);
	
	var _window = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer' - improve bundle size
	//import List from 'react-virtualized/dist/commonjs/List'
	
	var PlaylistSelection = function (_React$Component) {
	  _inherits(PlaylistSelection, _React$Component);
	
	  function PlaylistSelection() {
	    _classCallCheck(this, PlaylistSelection);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {};
	    return _this;
	  }
	
	  PlaylistSelection.prototype.render = function render() {
	    var _props = this.props,
	        playlists = _props.playlists,
	        onClickPlaylist = _props.onClickPlaylist,
	        activePlaylistId = _props.activePlaylistId,
	        spotifyDisplayName = _props.spotifyDisplayName;
	
	
	    function rowRenderer(_ref) {
	      var key = _ref.key,
	          index = _ref.index,
	          isScrolling = _ref.isScrolling,
	          isVisible = _ref.isVisible,
	          style = _ref.style;
	
	      var playlist = playlists[index];
	      var playlistId = playlist.playlistId,
	          playlistName = playlist.playlistName,
	          songCount = playlist.songCount,
	          ownerId = playlist.ownerId;
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        { key: key },
	        _react2.default.createElement(
	          "div",
	          {
	            style: style,
	
	            onClick: function onClick() {
	              onClickPlaylist({ playlistId: playlistId, playlistName: playlistName, songCount: songCount, ownerId: ownerId });
	            },
	            className: "jsx-3309143808" + " " + ((playlistId == activePlaylistId ? 'playlist active' : 'playlist') || "")
	          },
	          playlistName,
	          " ",
	          _react2.default.createElement(
	            "span",
	            {
	              className: "jsx-3309143808" + " " + "song-count"
	            },
	            songCount,
	            " songs"
	          )
	        ),
	        _react2.default.createElement(_style2.default, {
	          styleId: "3309143808",
	          css: [".playlist.jsx-3309143808{padding-left:8px;font-size:1.1em;padding-bottom:5px;cursor:pointer;overflow-x:hidden;width:100%;white-space:nowrap;text-overflow:ellipsis;}", ".playlist.jsx-3309143808 .song-count.jsx-3309143808{font-size:10px;color:green;display:none;}", ".playlist.jsx-3309143808:hover{font-weight:600;color:white;}", ".playlist.jsx-3309143808:hover .song-count.jsx-3309143808{display:inline-block;}", ".playlist.active.jsx-3309143808{color:white;padding-left:5px;margin-left:0px;border-left:3px red solid;}"]
	        })
	      );
	    }
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        "div",
	        {
	          className: "jsx-1884438787" + " " + "playlist-selection"
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "jsx-1884438787" + " " + "head"
	          },
	          _react2.default.createElement(
	            "h3",
	            {
	              className: "jsx-1884438787"
	            },
	            "Your Spotify Playlists for ",
	            spotifyDisplayName,
	            " - ",
	            _react2.default.createElement(
	              "a",
	              { onClick: function onClick() {
	                  return (0, _spotifyAuth.logoutOfSpotifyAndRedirectToHome)();
	                }, className: "jsx-1884438787" + " " + "logout"
	              },
	              "Logout?"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "jsx-1884438787" + " " + "playlists"
	          },
	          playlists.length > 0 && _react2.default.createElement(
	            _reactVirtualized.AutoSizer,
	            null,
	            function (_ref2) {
	              var height = _ref2.height,
	                  width = _ref2.width;
	
	              return _react2.default.createElement(_reactVirtualized.List, {
	                width: width,
	                height: height,
	                rowCount: playlists.length,
	                rowHeight: (0, _window.isMobileOrTablet)() > 1000 ? 30 : 35,
	                rowRenderer: rowRenderer,
	                style: { outline: 'none' }
	              });
	            }
	          )
	        ),
	        _react2.default.createElement(
	          "h4",
	          {
	            className: "jsx-1884438787" + " " + "upcoming-features"
	          },
	          _react2.default.createElement(
	            "a",
	            { href: "/request-features-feedback", className: "jsx-1884438787"
	            },
	            "Feedback? Requests?"
	          )
	        )
	      ),
	      _react2.default.createElement(_style2.default, {
	        styleId: "1884438787",
	        css: [".playlist-selection.jsx-1884438787{background-color:#121212;height:100%;color:#cccccc;padding:15px 0px;height:100%;display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}", ".playlist-selection.jsx-1884438787 .playlists.jsx-1884438787{-webkit-box-flex:10;-ms-flex:10;-webkit-flex:10;-ms-flex:10;flex:10;padding-bottom:5px;}", ".playlist-selection.jsx-1884438787 .head.jsx-1884438787{-webkit-box-flex:.5;-ms-flex:.5;-webkit-flex:.5;-ms-flex:.5;flex:.5;color:white;margin-bottom:15px;padding:0px 15px;}", ".playlist-selection.jsx-1884438787 a.logout.jsx-1884438787{margin-top:15px;color:red;cursor:pointer;}", ".playlist-selection.jsx-1884438787 .upcoming-features.jsx-1884438787{padding:10px;-webkit-box-flex:.75;-ms-flex:.75;-webkit-flex:.75;-ms-flex:.75;flex:.75;display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}", ".playlist-selection.jsx-1884438787 .upcoming-features.jsx-1884438787 a.jsx-1884438787{color:white;}"]
	      })
	    );
	  };
	
	  return PlaylistSelection;
	}(_react2.default.Component);
	
	;
	
	exports.default = PlaylistSelection;
	module.exports = exports["default"];

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _PlaylistSelection = __webpack_require__(587);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PlaylistSelection).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactModal = __webpack_require__(208);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _spotify = __webpack_require__(996);
	
	var _spotify2 = _interopRequireDefault(_spotify);
	
	var _PlaylistSelection = __webpack_require__(344);
	
	var _PlaylistSelection2 = _interopRequireDefault(_PlaylistSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var customStyles = {
	  overlay: { zIndex: 10 },
	  content: {
	    height: '85vh',
	    width: '90vw',
	    top: '50%',
	    left: '50%',
	    right: 'auto',
	    bottom: 'auto',
	    marginRight: '-50%',
	    transform: 'translate(-50%, -50%)'
	  }
	};
	
	var PlaylistSelectionModal = function (_React$Component) {
	  _inherits(PlaylistSelectionModal, _React$Component);
	
	  function PlaylistSelectionModal() {
	    _classCallCheck(this, PlaylistSelectionModal);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      modalIsOpen: false
	    };
	
	    _this.openModal = _this.openModal.bind(_this);
	    _this.afterOpenModal = _this.afterOpenModal.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    return _this;
	  }
	
	  PlaylistSelectionModal.prototype.openModal = function openModal() {
	    this.setState({ modalIsOpen: true });
	  };
	
	  PlaylistSelectionModal.prototype.afterOpenModal = function afterOpenModal() {
	    // references are now sync'd and can be accessed.
	    //this.subtitle.style.color = '#f00';
	  };
	
	  PlaylistSelectionModal.prototype.closeModal = function closeModal() {
	    this.setState({ modalIsOpen: false });
	  };
	
	  PlaylistSelectionModal.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        playlists = _props.playlists,
	        _onClickPlaylist = _props.onClickPlaylist,
	        activePlaylistId = _props.activePlaylistId,
	        spotifyDisplayName = _props.spotifyDisplayName;
	
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        "div",
	        {
	          className: "jsx-1450318340" + " " + "playlist-selection-modal"
	        },
	        _react2.default.createElement(
	          "button",
	          { onClick: this.openModal, className: "jsx-1450318340" + " " + "select-playlist md"
	          },
	          "Select Spotify Playlist ",
	          _react2.default.createElement(_spotify2.default, null)
	        ),
	        _react2.default.createElement(
	          _reactModal2.default,
	          {
	            ariaHideApp: false,
	            isOpen: this.state.modalIsOpen,
	            onAfterOpen: this.afterOpenModal,
	            onRequestClose: this.closeModal,
	            style: customStyles,
	            contentLabel: "Example Modal"
	          },
	          _react2.default.createElement(_PlaylistSelection2.default, { playlists: playlists, onClickPlaylist: function onClickPlaylist(obj) {
	              _onClickPlaylist(obj);_this2.closeModal();
	            }, activePlaylistId: activePlaylistId, spotifyDisplayName: spotifyDisplayName })
	        )
	      ),
	      _react2.default.createElement(_style2.default, {
	        styleId: "1450318340",
	        css: [".playlist-selection-modal.jsx-1450318340{display:inline-block;margin-left:10px;}", "@media screen and (min-width:600px){.playlist-selection-modal.jsx-1450318340{display:none;}}", "button.jsx-1450318340{border:0;cursor:pointer;font-size:16px;min-width:100px;}", "button.md.jsx-1450318340{border-radius:5px;padding:10px 15px;}", "button.select-playlist.jsx-1450318340{background:#346294;color:white;margin-bottom:15px;}"]
	      })
	    );
	  };
	
	  return PlaylistSelectionModal;
	}(_react2.default.Component);
	
	;
	
	exports.default = PlaylistSelectionModal;
	module.exports = exports["default"];

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _PlaylistSelectionModal = __webpack_require__(588);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PlaylistSelectionModal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactVirtualized = __webpack_require__(492);
	
	var _window = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer' - improve bundle size
	//import List from 'react-virtualized/dist/commonjs/List'
	
	var TracksTable = function (_React$Component) {
	  _inherits(TracksTable, _React$Component);
	
	  function TracksTable() {
	    _classCallCheck(this, TracksTable);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {};
	    return _this;
	  }
	
	  TracksTable.prototype.render = function render() {
	    var _props = this.props,
	        songs = _props.songs,
	        onClickSong = _props.onClickSong,
	        activePlaylistLoading = _props.activePlaylistLoading;
	
	
	    function rowRenderer(_ref) {
	      var key = _ref.key,
	          index = _ref.index,
	          isScrolling = _ref.isScrolling,
	          isVisible = _ref.isVisible,
	          style = _ref.style;
	
	      var song = songs[index];
	      var songName = song.songName,
	          artistName = song.artistName,
	          albumName = song.albumName,
	          duration = song.duration,
	          popularity = song.popularity,
	          preview = song.preview;
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        { key: key },
	        _react2.default.createElement(
	          "div",
	          {
	            style: style,
	
	            onClick: function onClick() {
	              onClickSong(preview);
	            },
	            className: "jsx-130599628" + " " + 'song'
	          },
	          songName,
	          " | ",
	          artistName,
	          " | ",
	          albumName,
	          " | ",
	          duration,
	          " | ",
	          popularity
	        ),
	        _react2.default.createElement(_style2.default, {
	          styleId: "130599628",
	          css: [".song.jsx-130599628{color:#282828;padding-left:8px;font-size:1.1em;padding-bottom:5px;cursor:pointer;overflow-x:hidden;width:100%;white-space:nowrap;text-overflow:ellipsis;}", ".song.jsx-130599628:hover{font-weight:600;color:black;}"]
	        })
	      );
	    }
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        "div",
	        {
	          className: "jsx-3087005755" + " " + "tracks-table"
	        },
	        !activePlaylistLoading && _react2.default.createElement(
	          "div",
	          {
	            className: "jsx-3087005755" + " " + "tracks"
	          },
	          songs.length > 0 ? _react2.default.createElement(
	            _reactVirtualized.AutoSizer,
	            null,
	            function (_ref2) {
	              var height = _ref2.height,
	                  width = _ref2.width;
	
	              return _react2.default.createElement(_reactVirtualized.List, {
	                width: width,
	                height: height,
	                rowCount: songs.length,
	                rowHeight: (0, _window.isMobileOrTablet)() > 1000 ? 30 : 35,
	                rowRenderer: rowRenderer,
	                style: { outline: 'none' }
	              });
	            }
	          ) : _react2.default.createElement(
	            "div",
	            {
	              className: "jsx-3087005755"
	            },
	            "No songs in playlist to display"
	          )
	        )
	      ),
	      _react2.default.createElement(_style2.default, {
	        styleId: "3087005755",
	        css: [".tracks-table.jsx-3087005755{background-color:white;height:80%;color:#cccccc;padding:15px 0px;display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}", ".tracks-table.jsx-3087005755 .tracks.jsx-3087005755{-webkit-box-flex:10;-ms-flex:10;-webkit-flex:10;-ms-flex:10;flex:10;padding-bottom:5px;}", ".tracks-table.jsx-3087005755 .head.jsx-3087005755{-webkit-box-flex:.5;-ms-flex:.5;-webkit-flex:.5;-ms-flex:.5;flex:.5;color:white;margin-bottom:15px;padding:0px 15px;}"]
	      })
	    );
	  };
	
	  return TracksTable;
	}(_react2.default.Component);
	
	;
	
	exports.default = TracksTable;
	module.exports = exports["default"];

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _TracksTable = __webpack_require__(602);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TracksTable).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getPlaylistTracks = exports.getMyPlaylists = exports.getMe = undefined;
	
	var _axios = __webpack_require__(98);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _spotifyAuth = __webpack_require__(58);
	
	var _window = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var spotifyAxios = _axios2.default.create({
	  baseURL: 'https://api.spotify.com/v1',
	  timeout: 1000
	});
	
	var setAccessToken = function setAccessToken() {
	  if (!(0, _spotifyAuth.isSpotifyAccessTokenValid)()) {
	    (0, _window.setNewLocation)('/spotifyauth');
	    return false;
	  }
	  // Check if access token is valid first and redirect if not
	  var access_token = (0, _spotifyAuth.getSpotifyAccessToken)();
	
	  spotifyAxios.defaults.headers.common['Authorization'] = "Bearer " + access_token;
	  return true;
	};
	
	var getMe = function getMe() {
	  if (!setAccessToken()) {
	    return Promise.reject({ error: 'Invalid token' });
	  }
	
	  var access_token = (0, _spotifyAuth.getSpotifyAccessToken)();
	  var profileFromLocalStorage = getSpotifyProfile(access_token);
	
	  if (profileFromLocalStorage) {
	    return Promise.resolve(profileFromLocalStorage);
	  }
	
	  return spotifyAxios.get('/me').then(function (response) {
	    var _setSpotifyProfile;
	
	    var data = response.data;
	    var has_image = data.images && data.images.length > 0;
	    var image_url = has_image ? data.images[0].url : null;
	
	    var profile = {
	      display_name: data.display_name,
	      spotify_open_url: data.external_urls ? data.external_urls.spotify : '',
	      image_url: image_url,
	      id: data.id
	    };
	
	    setSpotifyProfile((_setSpotifyProfile = {}, _setSpotifyProfile[access_token] = profile, _setSpotifyProfile));
	
	    return profile;
	  }).catch(function (error) {
	    return {
	      error: "Failed to load profile. Try again."
	    };
	  });
	};
	
	// Consider a caching strategy
	var getMyPlaylists = function getMyPlaylists() {
	  if (!setAccessToken()) {
	    return Promise.reject({ error: 'Invalid token' });
	  }
	
	  var access_token = (0, _spotifyAuth.getSpotifyAccessToken)();
	
	  return new Promise(function (resolve, reject) {
	    getMyPlaylistsNext([], '/me/playlists?limit=50', resolve, reject, 0);
	  });
	};
	
	var getMyPlaylistsNext = function getMyPlaylistsNext(playlists, next, resolve, reject, retries) {
	  if (next) {
	    spotifyAxios.get(next).then(function (response) {
	      var _response$data = response.data,
	          items = _response$data.items,
	          next = _response$data.next;
	
	
	      var bareItems = items.map(function (item) {
	        return { playlistId: item.id, playlistName: item.name, songCount: item.tracks.total, ownerId: item.owner.id };
	      });
	      playlists = playlists.concat(bareItems); // can filter down what I need
	      getMyPlaylistsNext(playlists, next, resolve, reject);
	    }, function () {
	      if (retries < 2) {
	        getMyPlaylistsNext(playlists, next, resolve, reject, retries + 1);
	      } else {
	        alert('Failed to load Spotify playlists after several retries - please refresh the page or report the issue to playlistbuddy.app@gmail.com');
	        reject();
	      }
	    });
	  } else {
	    resolve({ playlists: playlists });
	  }
	};
	
	// GET https://api.spotify.com/v1/me/tracks USERS tracks
	
	// Would be nice to trim down the artist object to only name
	var getPlaylistTracks = function getPlaylistTracks(_ref) {
	  var ownerId = _ref.ownerId,
	      playlistId = _ref.playlistId;
	
	  if (!setAccessToken()) {
	    return Promise.reject({ error: 'Invalid token' });
	  }
	
	  var access_token = (0, _spotifyAuth.getSpotifyAccessToken)();
	
	  return new Promise(function (resolve, reject) {
	    getPlaylistTracksNext([], "users/" + ownerId + "/playlists/" + playlistId + "/tracks?limit=100&fields=next,items(track(name,album(name),artists,preview_url,popularity,duration_ms))", resolve, reject, 0);
	  });
	};
	
	var convertToMinutesSeconds = function convertToMinutesSeconds(ms) {
	  var minutes = Math.floor(ms / 60000);
	  var seconds = (ms % 60000 / 1000).toFixed(0);
	  return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
	};
	
	// Figure out how to cancel if long playlist is being loaded and use clicks away
	var getPlaylistTracksNext = function getPlaylistTracksNext(tracks, next, resolve, reject, retries) {
	  if (next) {
	    spotifyAxios.get(next).then(function (response) {
	      var _response$data2 = response.data,
	          items = _response$data2.items,
	          next = _response$data2.next;
	
	
	      var bareItems = items.map(function (item) {
	        var track = item.track;
	        var artistName = track.artists.map(function (artist) {
	          return artist.name;
	        }).join(', ');
	
	        return {
	          songName: track.name,
	          artistName: artistName,
	          albumName: track.album.name,
	          popularity: track.popularity,
	          preview: track.preview_url,
	          duration: convertToMinutesSeconds(track.duration_ms)
	        };
	      });
	
	      tracks = tracks.concat(bareItems);
	      getPlaylistTracksNext(tracks, next, resolve, reject);
	    }, function () {
	      if (retries < 3) {
	        getPlaylistTracksNext(tracks, next, resolve, reject, retries + 1);
	      } else {
	        alert('Failed to load Spotify playlist after several retries - please refresh the page or report the issue to playlistbuddy.app@gmail.com');
	        reject();
	      }
	    });
	  } else {
	    // Implement some sort of caching with snapshot_id
	    resolve({ tracks: tracks });
	  }
	};
	
	var getSpotifyProfile = function getSpotifyProfile(access_token) {
	  var profile = JSON.parse((0, _window.localStorageGet)('PB_SPOTIFY_PROFILE') || '{}');
	
	  return profile[access_token];
	};
	
	var setSpotifyProfile = function setSpotifyProfile(profile) {
	  return (0, _window.localStorageSet)('PB_SPOTIFY_PROFILE', JSON.stringify(profile));
	};
	
	exports.getMe = getMe;
	exports.getMyPlaylists = getMyPlaylists;
	exports.getPlaylistTracks = getPlaylistTracks;

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.insertIntoPlaylist = exports.createPlaylist = exports.searchYoutube = exports.getPlaylists = exports.getChannel = undefined;
	
	var _axios = __webpack_require__(98);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _youtubeAuth = __webpack_require__(174);
	
	var _window = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// videos?id=7lCDEYXw3mM
	// &key=YOUR_API_KEY\n' + &part=snippet,contentDetails,statistics,status',
	var youtubeAxios = _axios2.default.create({
	  baseURL: 'https://www.googleapis.com/youtube/v3/',
	  timeout: 1000
	});
	
	var parseYouTubeErrorObject = function parseYouTubeErrorObject(error) {
	  // LOOK FOR 403 Quota Exceeded...
	  if (error.domain == "youtube.playlist" && error.reason == "exceededRateLimit") {
	    return "YouTube limits the number of playlists an account can create per day to about 10. You can wait till tomorrow or try another YouTube account.";
	  } else {
	    return error.domain + " " + error.reason + " " + error.message;
	  }
	};
	
	var handleYoutubeError = function handleYoutubeError() {
	  var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var alertBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var errorMessage = 'No Message From YouTube';
	
	  if (response.result && response.result.error && response.result.error.errors) {
	    errorMessage = response.result.error.errors.map(parseYouTubeErrorObject).concat('');
	  } else if (response.data) {
	    errorMessage = response.data.map(parseYouTubeErrorObject).concat('');
	  }
	
	  var displayMessage = "Failed to " + action + ". Reason - " + errorMessage;
	
	  if (alertBox) {
	    alert(displayMessage);
	  }
	
	  return displayMessage;
	};
	
	var getChannel = function getChannel() {
	  var googleApi = (0, _window.getGoogleApi)();
	
	  if (!(0, _youtubeAuth.isYoutubeAccessTokenValid)()) {
	    return Promise.reject({ error: 'Not signed in' });
	  }
	
	  return googleApi.client.youtube.channels.list({
	    part: 'snippet,status',
	    mine: true
	  }).then(function (response) {
	    var channel = response.result.items[0];
	    var channelId = channel.id;
	    var channelName = channel.snippet.title;
	    // Indicates whether the channel data identifies a user that is already linked to either a YouTube username or a Google+ account.
	    // A user that has one of these links already has a public YouTube identity, which is a prerequisite for several actions, such as uploading videos.
	    var isLinked = channel.status.isLinked;
	    var privacyStatus = channel.status.privacyStatus;
	
	    return {
	      channelId: channelId,
	      channelName: channelName,
	      isLinked: isLinked,
	      privacyStatus: privacyStatus
	    };
	  }).catch(function (response) {
	    handleYoutubeError(response, 'Load YouTube Channel', true);
	  });
	};
	
	var getPlaylists = function getPlaylists() {
	  var googleApi = (0, _window.getGoogleApi)();
	
	  if (!(0, _youtubeAuth.isYoutubeAccessTokenValid)()) {
	    return Promise.reject({ error: 'Not signed in' });
	  }
	
	  return googleApi.client.youtube.playlists.list({
	    part: 'snippet',
	    mine: true,
	    maxResults: 50
	  }).then(function (response) {
	    var youtubePlaylists = response.result.items; // { snippet: { title: '' } }
	  }).catch(function (response) {
	    handleYoutubeError(response, 'Load YouTube Playlists');
	  });
	};
	
	var searchYoutube = function searchYoutube(searchString, resolve) {
	  var googleApi = (0, _window.getGoogleApi)();
	
	  if (!(0, _youtubeAuth.isYoutubeAccessTokenValid)()) {
	    resolve({ error: { message: 'NOT_SIGNED_IN', searchString: searchString } });
	    // return Promise.reject({error: 'Not signed in'});
	  }
	
	  googleApi.client.youtube.search.list({
	    part: 'id',
	    type: 'video',
	    videoCategoryId: '10', // ID 10 is music, might consider removing if there are videos that aren't labelled in this category
	    maxResults: 1,
	    q: searchString
	  }).then(function (response) {
	    var songs = response.result.items; // { snippet: { title: '' } }
	    if (songs.length > 0) {
	      var id = songs[0].id;
	      var videoId = id.videoId;
	      resolve({ success: { song: { videoId: videoId }, searchString: searchString } }); // return only what we need?
	    } else {
	      resolve({ error: { message: 'NO_RESULT', searchString: searchString } }); // return only what we need?
	    }
	  }).catch(function (response) {
	    var errorMessage = handleYoutubeError(response, 'Find Song on YouTube');
	    resolve({ error: { message: errorMessage, searchString: searchString } }); // might want to add to a not added list with the id
	  });
	};
	
	var createPlaylist = function createPlaylist(title) {
	  var isPrivate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var resolve = arguments[2];
	
	  var googleApi = (0, _window.getGoogleApi)();
	
	  if (!(0, _youtubeAuth.isYoutubeAccessTokenValid)()) {
	    resolve({ error: { message: 'NOT_SIGNED_IN', title: title } });
	  }
	
	  // Check title for bad characters
	
	  var part = 'snippet';
	  var resource = {
	    snippet: {
	      title: title || 'New Playlist Buddy Playlist',
	      description: 'Playlist Buddy - Music videos, Spotify to YouTube conversion. Check it out at www.playlistbuddy.com'
	    }
	  };
	
	  if (isPrivate) {
	    part += ',status';
	
	    resource.status = {
	      privacyStatus: 'private'
	    };
	  }
	
	  var request = googleApi.client.youtube.playlists.insert({ part: part, resource: resource });
	
	  request.execute(function (response) {
	    var result = response.result;
	
	    if (result) {
	      var playlistId = result.id; // result.snippet.title / description
	      resolve({ success: { playlist: { id: playlistId }, title: title } }); // return only what we need?
	    } else {
	      var errorMessage = handleYoutubeError(response, 'Create Playlist', true);
	      resolve({ error: { message: errorMessage, title: title } }); // might want to add to a not added list with the id
	    }
	  });
	};
	
	var insertIntoPlaylist = function insertIntoPlaylist(videoId, playlistId, resolve) {
	  var googleApi = (0, _window.getGoogleApi)();
	
	  if (!(0, _youtubeAuth.isYoutubeAccessTokenValid)()) {
	    resolve({ error: { message: 'NOT_SIGNED_IN', videoId: videoId, playlistId: playlistId } });
	  }
	
	  var resourceId = {
	    kind: 'youtube#video',
	    videoId: videoId
	  };
	
	  var request = googleApi.client.youtube.playlistItems.insert({
	    part: 'snippet', // See if we can use just id to save on response bytes
	    snippet: {
	      playlistId: playlistId,
	      resourceId: resourceId
	    }
	  });
	
	  request.execute(function (response) {
	    var result = response.result;
	
	    if (result) {
	      resolve({ success: { song: result, videoId: videoId, playlistId: playlistId } }); // result.id; // result.snippet.title
	    } else {
	      var errorMessage = handleYoutubeError(response, 'Add Song to Playlist');
	      resolve({ error: { message: errorMessage, videoId: videoId, playlistId: playlistId } }); // might want to add to a not added list with the id
	    }
	  });
	};
	
	exports.getChannel = getChannel;
	exports.getPlaylists = getPlaylists;
	exports.searchYoutube = searchYoutube;
	exports.createPlaylist = createPlaylist;
	exports.insertIntoPlaylist = insertIntoPlaylist;

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.isYoutubeAccessTokenValid = exports.getYoutubeAccessToken = exports.handleSignoutClick = exports.handleAuthClick = exports.loadYoutubeClient = undefined;
	
	var _qs = __webpack_require__(309);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _uuid = __webpack_require__(496);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _window = __webpack_require__(30);
	
	var _queryParams = __webpack_require__(217);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loadYoutubeClient = function loadYoutubeClient(handleYoutubeClientLoad) {
	  var googleApi = (0, _window.getGoogleApi)();
	  if (googleApi) {
	    googleApi.load('client:auth2', function () {
	      return initClient(handleYoutubeClientLoad);
	    });
	  } else {
	    alert('Google API not available for load - refresh the page');
	    handleYoutubeClientLoad({ youtubeClientLoaded: false });
	  }
	};
	
	// https://developers.google.com/youtube/v3/guides/auth/client-side-web-apps#creatingclient
	// https://developers.google.com/youtube/v3/quickstart/js
	// const client_id = '548238540140-8e87un3ip8a8knoja3te37etghu6183t.apps.googleusercontent.com'; // PB App 1 - 1M req day
	var client_id = '872701887463-ebbk1l9398ah2jq2c4nb9vc882n6og00.apps.googleusercontent.com'; // Winter Cargo 50M req day
	var discovery_docs = ["https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest"];
	var scopes = 'https://www.googleapis.com/auth/youtube';
	
	var initClient = function initClient(handleYoutubeClientLoad) {
	  var googleApi = (0, _window.getGoogleApi)();
	
	  googleApi.client.init({
	    clientId: client_id,
	    discoveryDocs: discovery_docs,
	    scope: scopes
	  }).then(function () {
	    handleYoutubeClientLoad({ youtubeClientLoaded: true });
	  }).catch(function () {
	    alert('YouTube Client Initialization Error - please refresh the page');
	    handleYoutubeClientLoad({ youtubeClientLoaded: false });
	  });
	};
	
	var handleAuthClick = function handleAuthClick() {
	  var googleApi = (0, _window.getGoogleApi)();
	
	  googleApi.auth2.getAuthInstance().signIn();
	};
	
	var handleSignoutClick = function handleSignoutClick() {
	  var googleApi = (0, _window.getGoogleApi)();
	
	  googleApi.auth2.getAuthInstance().signOut();
	};
	
	var getYoutubeAccessToken = function getYoutubeAccessToken() {
	  var googleApi = (0, _window.getGoogleApi)();
	
	  if (googleApi) {
	    return googleApi.client.getToken();
	  }
	
	  return null;
	};
	
	var isYoutubeAccessTokenValid = function isYoutubeAccessTokenValid() {
	  return !!getYoutubeAccessToken();
	};
	
	exports.loadYoutubeClient = loadYoutubeClient;
	exports.handleAuthClick = handleAuthClick;
	exports.handleSignoutClick = handleSignoutClick;
	exports.getYoutubeAccessToken = getYoutubeAccessToken;
	exports.isYoutubeAccessTokenValid = isYoutubeAccessTokenValid;

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.promiseCreatePlaylist = exports.cancelAddAllToPlaylist = exports.addAllToPlaylist = undefined;
	
	var _youtubeApi = __webpack_require__(345);
	
	var _youtubeAuth = __webpack_require__(174);
	
	// import throat from 'throat';
	
	// At 3, 3.5 seconds, 16 songs, order not guaranteed?
	// At 2, 7 seconds, 16 songs, order not guaranteed?
	// At 1, 10 seconds, 16 songs, in order :D, .6 seconds per song
	var throat = __webpack_require__(494)(3);
	throat = __webpack_require__(494)(1);
	
	var cancelConversion = false;
	var retrySearches = [];
	var retryAddToPlaylist = [];
	var playlistId = '';
	
	// Must return a promise to throat
	var promiseSearch = function promiseSearch(searchString) {
	  return new Promise(function (resolve) {
	    (0, _youtubeApi.searchYoutube)(searchString, resolve);
	  });
	};
	
	var promiseAddToPlaylist = function promiseAddToPlaylist(videoId, playlistId) {
	  return new Promise(function (resolve) {
	    (0, _youtubeApi.insertIntoPlaylist)(videoId, playlistId, resolve);
	  });
	};
	
	var promiseCreatePlaylist = function promiseCreatePlaylist(playlistName) {
	  return new Promise(function (resolve) {
	    var isPrivate = false;
	    (0, _youtubeApi.createPlaylist)(playlistName, isPrivate, resolve);
	  });
	};
	
	var checkCancelConversion = function checkCancelConversion() {
	  if (cancelConversion) {
	    cancelConversion = false;
	    return true;
	  }
	
	  return false;
	};
	
	var handleExpiredTokenDuringConversion = function handleExpiredTokenDuringConversion() {
	  alert('Please click ok, select your YouTube account, and sign in so Playlist Buddy can continue converting. Make sure popups are not blocked!');
	  (0, _youtubeAuth.handleAuthClick)(); // Popups are blocked so we should do a dialog and have the user click
	  // How do we proceed where they left off? Similar flow for rate limit issues
	};
	
	var searchBatch = function searchBatch(songs) {
	  var searchThroatPromises = songs.map(function (song) {
	    var searchString = song.songName + ' ' + song.artistName; // add filter string here // filter.query
	
	    return throat(function () {
	      return promiseSearch(searchString);
	    });
	  });
	
	  return Promise.all(searchThroatPromises).then(function (results) {
	    var videoIdsFound = [];
	    var searchesNotFound = [];
	    var pauseForSignIn = false;
	
	    results.map(function (result) {
	      if (result.success) {
	        var _result$success = result.success,
	            song = _result$success.song,
	            searchString = _result$success.searchString;
	
	        videoIdsFound.push(song.videoId);
	      }
	
	      if (result.error) {
	        var _result$error = result.error,
	            message = _result$error.message,
	            _searchString = _result$error.searchString;
	
	
	        if (message === 'NOT_SIGNED_IN') {
	          pauseForSignIn = true;
	        }
	
	        searchesNotFound.push(_searchString);
	      }
	    });
	
	    if (searchesNotFound.length > 0) {
	      retrySearches.concat(searchesNotFound);
	    }
	
	    return { videoIdsFound: videoIdsFound, pauseForSignIn: pauseForSignIn };
	  });
	};
	
	var addToPlaylistBatch = function addToPlaylistBatch(videoIdsFound) {
	  var addToPlaylistThroatPromises = videoIdsFound.map(function (videoId) {
	    return throat(function () {
	      return promiseAddToPlaylist(videoId, playlistId);
	    }); // Set globally in addAllToPlaylist, which comes from Promise success in view
	  });
	
	  return Promise.all(addToPlaylistThroatPromises).then(function (results) {
	    var videoIdsAdded = [];
	    var videoIdsNotAdded = [];
	    var pauseForSignIn = false;
	
	    results.map(function (result) {
	      if (result.success) {
	        var _result$success2 = result.success,
	            song = _result$success2.song,
	            videoId = _result$success2.videoId,
	            _playlistId = _result$success2.playlistId;
	
	        videoIdsAdded.push(videoId);
	      }
	
	      if (result.error) {
	        var _result$error2 = result.error,
	            message = _result$error2.message,
	            _videoId = _result$error2.videoId,
	            _playlistId2 = _result$error2.playlistId;
	
	
	        if (message === 'NOT_SIGNED_IN') {
	          pauseForSignIn = true;
	        }
	
	        videoIdsNotAdded.push({ videoId: _videoId, playlistId: _playlistId2 });
	      }
	    });
	
	    if (videoIdsNotAdded.length > 0) {
	      retryAddToPlaylist.concat(videoIdsNotAdded);
	    }
	
	    return { videoIdsAdded: videoIdsAdded, pauseForSignIn: pauseForSignIn };
	  });
	};
	
	var convertBatch = function convertBatch(songs) {
	  return new Promise(function (resolve, reject) {
	    searchBatch(songs).then(function (_ref) {
	      var videoIdsFound = _ref.videoIdsFound,
	          pauseForSignIn = _ref.pauseForSignIn;
	
	      if (checkCancelConversion()) {
	        // Good time to check for a 403, pause conversion for cool off or YouTube sign in
	        return reject('CONVERSION_CANCELLED');
	      }
	
	      if (pauseForSignIn) {
	        handleExpiredTokenDuringConversion();
	        return reject('YOUTUBE_SIGNIN_DURING_CONVERSION');
	      }
	
	      // do we want a timeout here?
	      addToPlaylistBatch(videoIdsFound).then(function (_ref2) {
	        var videoIdsAdded = _ref2.videoIdsAdded,
	            pauseForSignIn = _ref2.pauseForSignIn;
	
	        if (checkCancelConversion()) {
	          // Good time to check for a 403, pause conversion for cool off or YouTube sign in
	          return reject('CONVERSION_CANCELLED');
	        }
	
	        if (pauseForSignIn) {
	          handleExpiredTokenDuringConversion();
	          return reject('YOUTUBE_SIGNIN_DURING_CONVERSION');
	        }
	
	        return resolve();
	      });
	    });
	  });
	};
	
	var handleBatch = function handleBatch(batches, index, resolve, progressCallback) {
	  if (index < batches.length) {
	    convertBatch(batches[index]).then(function () {
	      progressCallback(index + 1);
	      handleBatch(batches, index + 1, resolve, progressCallback);
	    }, function () {
	      resolve('EARLY_EXIT');
	    });
	  } else {
	    resolve('DONE');
	  }
	};
	
	var addAllToPlaylist = function addAllToPlaylist() {
	  var songs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var pId = arguments[1];
	  var progressCallback = arguments[2];
	  var filter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  playlistId = pId;
	  if (filter.makePrivate) {
	    // make playlist private
	  }
	
	  if (filter.removeDuplicates) {
	    // add to query
	  }
	
	  if (filter.shuffleOrder) {
	    // add to query
	  }
	
	  var batches = [];
	  var BATCH_SIZE = 3;
	  cancelConversion = false;
	
	  for (var a = 0; a < songs.length; a += BATCH_SIZE) {
	    var batch = [];
	
	    for (var b = 0; b < BATCH_SIZE; b++) {
	      if (a + b < songs.length) {
	        batch.push(songs[a + b]);
	      }
	    }
	    batches.push(batch);
	  }
	
	  var batchesPromise = new Promise(function (resolve) {
	    if (batches.length > 0) {
	      handleBatch(batches, 0, resolve, function (index) {
	        return progressCallback(index * BATCH_SIZE);
	      });
	    } else {
	      resolve();
	    }
	  });
	
	  batchesPromise.then(function (value) {
	    progressCallback(songs.length);
	  });
	};
	
	var cancelAddAllToPlaylist = function cancelAddAllToPlaylist() {
	  cancelConversion = true;
	};
	
	exports.addAllToPlaylist = addAllToPlaylist;
	exports.cancelAddAllToPlaylist = cancelAddAllToPlaylist;
	exports.promiseCreatePlaylist = promiseCreatePlaylist;

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PlaylistSelectionModal = __webpack_require__(589);
	
	var _PlaylistSelectionModal2 = _interopRequireDefault(_PlaylistSelectionModal);
	
	var _PlaylistConversionModal = __webpack_require__(586);
	
	var _PlaylistConversionModal2 = _interopRequireDefault(_PlaylistConversionModal);
	
	var _PlaylistConversionFilterModal = __webpack_require__(584);
	
	var _PlaylistConversionFilterModal2 = _interopRequireDefault(_PlaylistConversionFilterModal);
	
	var _PlaylistSelection = __webpack_require__(344);
	
	var _PlaylistSelection2 = _interopRequireDefault(_PlaylistSelection);
	
	var _TracksTable = __webpack_require__(603);
	
	var _TracksTable2 = _interopRequireDefault(_TracksTable);
	
	var _GoogleScript = __webpack_require__(572);
	
	var _GoogleScript2 = _interopRequireDefault(_GoogleScript);
	
	var _youtube = __webpack_require__(205);
	
	var _youtube2 = _interopRequireDefault(_youtube);
	
	var _spotifyAuth = __webpack_require__(58);
	
	var _youtubeAuth = __webpack_require__(174);
	
	var _youtubeApi = __webpack_require__(345);
	
	var _youtubeConverter = __webpack_require__(218);
	
	var _window = __webpack_require__(30);
	
	var _spotifyApi = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Converter = function (_React$Component) {
	  _inherits(Converter, _React$Component);
	
	  function Converter() {
	    _classCallCheck(this, Converter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      playlists: [],
	      activePlaylistId: '',
	      activePlaylistName: '',
	      activePlaylistSongs: [],
	      activePlaylistSongCount: 0,
	      activePlaylistLoading: false,
	      activePlaylistOwnerId: '',
	      spotifyDisplayName: [],
	      youtubeClientLoaded: false,
	      youtubeSignedIn: false,
	      youtubeChannel: null
	    };
	
	    _this.loadPlaylist = _this.loadPlaylist.bind(_this);
	    _this.noPlaylist = _this.noPlaylist.bind(_this);
	    _this.handleYoutubeClientLoad = _this.handleYoutubeClientLoad.bind(_this);
	    _this.updateSignInStatus = _this.updateSignInStatus.bind(_this);
	    return _this;
	  }
	
	  Converter.prototype.loadPlaylist = function loadPlaylist(_ref) {
	    var _this2 = this;
	
	    var playlistId = _ref.playlistId,
	        playlistName = _ref.playlistName,
	        songCount = _ref.songCount,
	        ownerId = _ref.ownerId;
	
	    if (this.state.activePlaylistLoading) {
	      // Implement cancel loading so we don't have to do this...
	      alert('Spotify playlist songs are loading. Please wait for that to finish or refresh the page to select a new playlist.');
	      return;
	    }
	
	    this.setState({
	      activePlaylistId: playlistId,
	      activePlaylistName: playlistName,
	      activePlaylistSongCount: songCount,
	      activePlaylistLoading: true,
	      activePlaylistOwnerId: ownerId
	    });
	
	    (0, _spotifyApi.getPlaylistTracks)({ ownerId: ownerId, playlistId: playlistId }).then(function (response) {
	      _this2.setState({
	        activePlaylistLoading: false,
	        activePlaylistSongs: response.tracks
	      });
	    });
	  };
	
	  Converter.prototype.updateSignInStatus = function updateSignInStatus(signedIn) {
	    var _this3 = this;
	
	    this.setState({ youtubeSignedIn: signedIn });
	
	    if (signedIn) {
	      (0, _youtubeApi.getChannel)().then(function (response) {
	        if (response) {
	          _this3.setState({
	            youtubeChannel: response
	          });
	        }
	      });
	    } else {
	      this.setState({
	        youtubeChannel: null
	      });
	    }
	  };
	
	  Converter.prototype.handleYoutubeClientLoad = function handleYoutubeClientLoad(_ref2) {
	    var youtubeClientLoaded = _ref2.youtubeClientLoaded;
	
	    this.setState({ youtubeClientLoaded: youtubeClientLoaded });
	
	    if (youtubeClientLoaded) {
	      var googleApi = (0, _window.getGoogleApi)();
	
	      googleApi.auth2.getAuthInstance().isSignedIn.listen(this.updateSignInStatus); // Listen for sign-in state changes.
	      this.updateSignInStatus(googleApi.auth2.getAuthInstance().isSignedIn.get()); // Handle the initial sign-in state.
	    }
	  };
	
	  Converter.prototype.noPlaylist = function noPlaylist() {
	    this.setState({
	      activePlaylistId: '',
	      activePlaylistName: 'No Playlists Available - Please add playlists and refresh the page',
	      activePlaylistSongCount: 0,
	      activePlaylistLoading: false,
	      activePlaylistOwnerId: ''
	    });
	  };
	
	  Converter.prototype.componentDidMount = function componentDidMount() {
	    var _this4 = this;
	
	    (0, _spotifyApi.getMe)().then(function (response) {
	      var spotifyDisplayName = response ? response.display_name : '';
	      spotifyDisplayName && _this4.setState({ spotifyDisplayName: spotifyDisplayName });
	    });
	
	    (0, _spotifyApi.getMyPlaylists)().then(function (response) {
	      var playlists = response.playlists;
	      _this4.setState({ playlists: playlists });
	
	      if (playlists.length > 0) {
	        var firstPlaylist = playlists[0];
	        var playlistId = firstPlaylist.playlistId,
	            playlistName = firstPlaylist.playlistName,
	            songCount = firstPlaylist.songCount,
	            ownerId = firstPlaylist.ownerId;
	
	        _this4.loadPlaylist({ playlistId: playlistId, playlistName: playlistName, songCount: songCount, ownerId: ownerId });
	      } else {
	        noPlaylist();
	      }
	    });
	  };
	
	  Converter.prototype.render = function render() {
	    var _state = this.state,
	        playlists = _state.playlists,
	        activePlaylistId = _state.activePlaylistId,
	        activePlaylistName = _state.activePlaylistName,
	        activePlaylistSongs = _state.activePlaylistSongs,
	        spotifyDisplayName = _state.spotifyDisplayName,
	        youtubeClientLoaded = _state.youtubeClientLoaded,
	        youtubeSignedIn = _state.youtubeSignedIn,
	        youtubeChannel = _state.youtubeChannel,
	        activePlaylistSongCount = _state.activePlaylistSongCount,
	        activePlaylistLoading = _state.activePlaylistLoading,
	        activePlaylistOwnerId = _state.activePlaylistOwnerId;
	
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(_GoogleScript2.default, { handleYoutubeClientLoad: this.handleYoutubeClientLoad }),
	      _react2.default.createElement(
	        "div",
	        {
	          className: "jsx-3309517693" + " " + "flex-grid"
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "jsx-3309517693" + " " + "col-t t_25 _20"
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "jsx-3309517693"
	            },
	            _react2.default.createElement(_PlaylistSelection2.default, { playlists: playlists, onClickPlaylist: this.loadPlaylist, activePlaylistId: activePlaylistId, spotifyDisplayName: spotifyDisplayName })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "jsx-3309517693" + " " + "p_100 t_75 _55"
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "jsx-3309517693" + " " + "convert-table-head"
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "jsx-3309517693"
	              },
	              activePlaylistLoading && _react2.default.createElement(
	                "span",
	                {
	                  className: "jsx-3309517693"
	                },
	                _react2.default.createElement(
	                  "h2",
	                  {
	                    className: "jsx-3309517693"
	                  },
	                  activePlaylistName
	                ),
	                " - Loading ",
	                activePlaylistSongCount,
	                " Songs..."
	              ),
	              !activePlaylistLoading && _react2.default.createElement(
	                "span",
	                {
	                  className: "jsx-3309517693"
	                },
	                _react2.default.createElement(
	                  "h2",
	                  {
	                    className: "jsx-3309517693"
	                  },
	                  activePlaylistName
	                ),
	                " by ",
	                activePlaylistOwnerId,
	                " - ",
	                activePlaylistSongCount,
	                " Songs (250 Max)"
	              ),
	              _react2.default.createElement(_PlaylistSelectionModal2.default, { playlists: playlists, onClickPlaylist: this.loadPlaylist, activePlaylistId: activePlaylistId, spotifyDisplayName: spotifyDisplayName })
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "jsx-3309517693" + " " + "youtube-head"
	              },
	              youtubeClientLoaded && !youtubeSignedIn && _react2.default.createElement(
	                "button",
	                { onClick: _youtubeAuth.handleAuthClick, className: "jsx-3309517693" + " " + "youtube md"
	                },
	                "Sign in YouTube"
	              ),
	              youtubeSignedIn && _react2.default.createElement(
	                "button",
	                { onClick: _youtubeAuth.handleSignoutClick, className: "jsx-3309517693" + " " + "youtube md"
	                },
	                "Logout - ",
	                youtubeChannel && youtubeChannel.channelName
	              ),
	              _react2.default.createElement(_PlaylistConversionFilterModal2.default, { canConvert: youtubeSignedIn }),
	              _react2.default.createElement(_PlaylistConversionModal2.default, { canConvert: youtubeSignedIn, title: activePlaylistName, songs: activePlaylistSongs })
	            )
	          ),
	          _react2.default.createElement(_TracksTable2.default, {
	            songs: activePlaylistSongs,
	            onClickSong: function onClickSong() {},
	            activePlaylistLoading: activePlaylistLoading
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "jsx-3309517693" + " " + "col-d _25 look-here-section"
	          },
	          _react2.default.createElement(
	            "a",
	            { target: "_blank", href: "https://www.tunemymusic.com/YouTube-to-Spotify.php", className: "jsx-3309517693"
	            },
	            "Convert YouTube to Spotify"
	          ),
	          _react2.default.createElement("br", {
	            className: "jsx-3309517693"
	          }),
	          _react2.default.createElement(
	            "a",
	            { target: "_blank", href: "/airbnb-credit/", className: "jsx-3309517693"
	            },
	            "$55 free"
	          ),
	          _react2.default.createElement("br", {
	            className: "jsx-3309517693"
	          }),
	          _react2.default.createElement(
	            "a",
	            { target: "_blank", href: "http://youtube.com/c/shervinater", className: "jsx-3309517693"
	            },
	            "Learn about Smart Health Technology / Biohacking, subscribe to my friend's YouTube"
	          ),
	          _react2.default.createElement("br", {
	            className: "jsx-3309517693"
	          })
	        )
	      ),
	      _react2.default.createElement(_style2.default, {
	        styleId: "3309517693",
	        css: [".flex-grid.jsx-3309517693{margin-left:2vw;width:98vw;display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;max-height:80vh;min-height:80vh;margin-bottom:5vh;}", ".flex-grid.jsx-3309517693>div.jsx-3309517693{padding:0px 15px;}", ".flex-grid.jsx-3309517693 .col-d.jsx-3309517693,.flex-grid.jsx-3309517693 .col-t.jsx-3309517693{display:none;}", "button.jsx-3309517693{border:0;cursor:pointer;font-size:16px;min-width:100px;margin-bottom:15px;}", "button.md.jsx-3309517693{border-radius:5px;padding:10px 15px;}", "button.youtube.jsx-3309517693{background:red;color:white;margin-left:20px;}", ".convert-table-head.jsx-3309517693{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}", ".look-here-section.jsx-3309517693{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}", ".look-here-section.jsx-3309517693 a.jsx-3309517693{margin-bottom:15px;padding:20px;}", ".look-here-section.jsx-3309517693 a.jsx-3309517693:hover{color:#346294;}", ".youtube-head.jsx-3309517693{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;}", "@media screen and (min-width:1024px){.flex-grid.jsx-3309517693{margin-top:100px;}.flex-grid.jsx-3309517693 .col-d.jsx-3309517693{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}.convert-table-head.jsx-3309517693{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;}}", "@media screen and (min-width:600px){.flex-grid.jsx-3309517693 .col-t.jsx-3309517693{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}}", ".p_100.jsx-3309517693{-webkit-box-flex:10;-ms-flex:10;-webkit-flex:10;-ms-flex:10;flex:10;}", ".col-t.jsx-3309517693 .t_25.jsx-3309517693{-webkit-box-flex:2.5;-ms-flex:2.5;-webkit-flex:2.5;-ms-flex:2.5;flex:2.5;}", ".col-t.jsx-3309517693 .t_75.jsx-3309517693{-webkit-box-flex:7.5;-ms-flex:7.5;-webkit-flex:7.5;-ms-flex:7.5;flex:7.5;}", "._15.jsx-3309517693{-webkit-box-flex:1.5;-ms-flex:1.5;-webkit-flex:1.5;-ms-flex:1.5;flex:1.5;}", "._25.jsx-3309517693{-webkit-box-flex:2.5;-ms-flex:2.5;-webkit-flex:2.5;-ms-flex:2.5;flex:2.5;}", "._55.jsx-3309517693{-webkit-box-flex:5.5;-ms-flex:5.5;-webkit-flex:5.5;-ms-flex:5.5;flex:5.5;}", "._20.jsx-3309517693{-webkit-box-flex:2;-ms-flex:2;-webkit-flex:2;-ms-flex:2;flex:2;}"]
	      })
	    );
	  };
	
	  return Converter;
	}(_react2.default.Component);
	
	exports.default = Converter;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-converter-js-3a7be41ac6dce7a961ce.js